import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { LinearGauge, LinearGaugeProps } from '@progress/kendo-react-gauges';

import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import GaugeChart from "react-gauge-chart";
import { BrowserRouter, Route } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Draggable from "react-draggable";
import { connect } from "react-redux"
import { v4 as uuidv4, v4 } from 'uuid';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Resizable } from 're-resizable';
import { add_page_name, set_current_dyn_pageName, set_current_page_details, set_yetkilendirme_state, set_external_trend_info, set_pages, setCanvasBoyut, set_user_item } from "./Action/Action"
import Store from "./Store/Store"
import { elements } from "chart.js";
import GaugeComponent from 'react-gauge-component'
import "./Components/CSS/Raporlama.css"
import { Line } from 'react-chartjs-2';
import loading_ from "./Assets2/loading.gif";
import {
  Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement,
  Title,
  Tooltip,
  Legend,
  Zoom
} from "chart.js"
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-moment';
import moment from 'moment';
import 'moment-timezone';
import DashboardpngIcon from "./Assets/Icons/Dashboard.png";
import Misafir_Oda from "./Assets/Icons/pngwing.com.png";
import water_storage from "./Assets/Icons/tank.png";
import DigerSistemlerIcon from "./Assets/Icons/DigerSistemler.png";
import EnerjiIcon from "./Assets/Icons/Enerji.png";
import IsitmaSistemleriIcon from "./Assets/Icons/IsitmaSistemleri.png";
import KlimaSantIcon from "./Assets/Icons/KlimaSant.png";
import NotificationsIcon from "./Assets/Icons/Notifications.png";
import PompaVeHidroforIcon from "./Assets/Icons/PompaVeHidrofor.png";
import RooftopIcon from "./Assets/Icons/Rooftop.png";
import SogutmaSistemleriIcon from "./Assets/Icons/SogutmaSistemleri.png";
import SystemMonitoringIcon from "./Assets/Icons/SystemMonitoring.png";
import TuketimTakibiIcon from "./Assets/Icons/TuketimTakibi.png";
import VRFIcon from "./Assets/Icons/VRF.png";
import WorkOrdersIcon from "./Assets/Icons/WorkOrders.png";
import DevicesIcon from "./Assets/Icons/Devices.png";
import TagsIcon from "./Assets/Icons/Tags.png";

import { HexColorPicker } from "react-colorful";


const ResponsiveReactGridLayout = WidthProvider(Responsive);

const availableHandles = ["s", "w", "e", "n", "sw", "nw", "se", "ne"];


const DynEdit = (props) => {
  const [special_type_active, Set_special_type_active] = useState(false)

  const history = useHistory();
  const [screenWidthState, Set_screenWidthState] = useState(0);
  const [canvas_boyutu, Set_canvas_boyutu] = useState({ width: 0, height: 0 })
  const [canvas_boyutu_gecici, Set_canvas_boyutu_gecici] = useState({ width: 0, height: 0 })
  const [set_Raporlama, Set_set_raporlama] = useState(false)

  const [control_loading, Set_control_loading] = useState(true);

  const [image_objs, Set_image_objs] = useState([]);
  const [random_value, Set_random_value] = useState(0)

  useEffect(() => { console.log(image_objs);}, [image_objs])

  const [page_list, Set_page_list] = useState([])

  const [active_page_TagIds, Set_active_page_TagIds] = useState([])


  const [get_value_timer, Set_get_value_timer] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      Set_get_value_timer(prevValue => prevValue + 1);
      console.log(get_value_timer + 1);
    }, 5000);

    return () => clearInterval(interval); // Temizleme işlemi
  }, []);

  const [min, Set_min] = useState(0)
  const [max, Set_max] = useState(0)

  const [sayfa_adi, Set_sayfa_adi] = useState("")
  const [sayfa_ikonu_son, Set_sayfa_ikonu_son] = useState("")

  const onChangePageName = (e) => {
    Set_sayfa_adi(e.target.value)
  }
  const [active_popup_items, Set_active_popup_items] = useState([])

  const dashBoard = TuketimTakibiIcon;
  const water = water_storage;
  const enerjiIcon = EnerjiIcon;
  const heat_system = IsitmaSistemleriIcon;
  const pumpicon = PompaVeHidroforIcon;
  const fansicon = "fa-solid fa-fan";
  const vrf_icon = VRFIcon;
  function resizeAllFonts() {
    const inputs = document.querySelectorAll('.popupduz_widget input');
    inputs.forEach(input => {
      const width = input.offsetWidth;
      input.style.fontSize = (width / 5) + 'px';
    });
  }

  // İlk çalıştırma
  resizeAllFonts();

  // Ekran boyutu değiştiğinde tekrar çalışsın
  window.addEventListener('resize', resizeAllFonts);

  const [tag_values_state, Set_tag_values_state] = useState([])




  useEffect(() => {
    if (active_page_TagIds.length > 0) {


      const fetchTagValues = async () => {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(active_page_TagIds),
            }
          );
          const response = await request.json();

          if (request.status === 200) { Set_tag_values_state(response); console.warn(response); }
        } catch (err) {
          console.log(err);
        } finally {
          Set_control_loading(false)
        }

      };

      fetchTagValues()
    }
  }, [get_value_timer, active_page_TagIds])




  useEffect(() => {
    if (props.users_list && props.uid !== "" && props.temp_com_id !== null) {
      props.users_list.forEach(a => {
        if (a.userId === props.uid) {

          let data = a.yetkilendirme;
          let newObj = JSON.parse(data);
          console.log(newObj);
          if (newObj !== undefined) {
            if (newObj[props.temp_com_id < 3 ? 2 : props.temp_com_id]["Raporlama"]["Y"] === "t") {
              Set_set_raporlama(true);
            } else {
              Set_set_raporlama(false);
            }
          }
        }
      })
    }
  }, [props.users_list]);

  const [current_max_value, Set_current_max_value] = useState({})

  const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");

  //resize widget states
  const [selected_widgets, Set_selected_widgets] = useState([])


  const [date1, SetDate1] = useState(null)
  const [date2, SetDate2] = useState(null)
  const [selected_tag, Set_selected_tag] = useState("")
  const [current_tag, Setcurrent_tag] = useState([])
  const [y_axis, Sety_axis] = useState({})


  const [real_datas, SetRealDatas] = useState({});


  // useEffect(()=>{
  //   document.querySelector("body").style.width=String(document.querySelector("aside").getBoundingClientRect().width+canvas_boyutu.width)+"px"
  // },[canvas_boyutu])

  //For trends


  const [bigger_trend_active, Set_bigger_trend_active] = useState(false)
  const [bigger_trend_id, Set_bigger_trend_id] = useState(null)

  const chartRef = useRef(null);
  function createChartOptions(elemId) {
    return {
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'day',
            stepSize: 1,
            displayFormats: {
              day: 'MMM D'
            }
          },
          ticks: {
            maxTicksLimit: 24
          }
        },
        y: {
          min: Number(min),
          max: max === 0 ? current_max_value[elemId] : Number(max),
          beginAtZero: true,
          ticks: {
            callback: function (value) {
              return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
            }
          }
        }
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            filter: function (item, chart) {
              return item.text !== undefined;
            },
            generateLabels: function (chart) {
              return [{
                text: y_axis[elemId],
                fillStyle: "crimson",
                strokeStyle: chart.ctx.strokeStyle,
                lineWidth: chart.ctx.lineWidth,
                hidden: false,
                index: 0,
                datasetIndex: 0
              }];
            }
          }
        },
        zoom: {
          pan: {
            enabled: true,
            mode: 'xy',
          },
          zoom: {
            wheel: {
              enabled: true,
            },
            pinch: {
              enabled: true,
            },
            mode: 'x',
            onZoom: ({ chart }) => {
              const xScale = chart.scales.x;
              const min = xScale.min;
              const max = xScale.max;
              const diff = max - min;
              let unit = 'second';

              // Zoom leveline göre birim seçimi
              if (diff > 1000 * 60 * 60 * 24 * 7) {
                unit = 'day';
              } else if (diff > 1000 * 60 * 60) {
                unit = 'hour';
              } else if (diff > 1000 * 60) {
                unit = 'minute';
              }

              // Yeniden ayarlama
              xScale.options.time.unit = unit;
              xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
              xScale.options.ticks.callback = (value) => {
                return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
              };

              chart.update();
            },
          },
        },
      },
    };
  }

  const [sayfa_group, Set_sayfa_group] = useState("")


  useEffect(() => { console.log(real_datas) }, [real_datas])

  function createChartData(elemId) {
    const selectedData = real_datas[elemId];
    console.log(selectedData)

    const data = {
      labels: JSON.stringify(real_datas) !== "{}" ? selectedData.map(item => item.date) : [],
      datasets: [{
        data: JSON.stringify(real_datas) !== "{}" ? selectedData.map(item => item.value) : [],
        backgroundColor: "transparent",
        borderColor: "#f26c6d",
        pointBorderColor: "#f26c6d",
        pointBorderWidth: 1
      }]
    };

    return data;
  }




  const fetchTag = async (tagId, value, value2, elemId) => {


    console.log(value)

    const dateObj = new Date();
    const oneDay = 24 * 60 * 60 * 1000; // Bir günün milisaniye cinsinden değeri

    // Mevcut tarihi bir gün geri al
    const previousDay = new Date(dateObj.getTime() - oneDay);

    const pMonth = (previousDay.getUTCMonth() + 1).toString().padStart(2, "0"); // Ayları 01-12 arası yap
    const pDay = previousDay.getUTCDate().toString().padStart(2, "0"); // Günleri 01-31 arası yap
    const year = previousDay.getUTCFullYear();

    const newPaddedDate = `${year}-${pMonth}-${pDay}`;
    const date1_ = newPaddedDate + " " + "00:00:00.000";
    const date2_ = newPaddedDate + " " + "23:59:59.999";

    if (date1_ !== "" && date2_ !== "" && tagId !== "" && value !== null && value2 !== null) {
      Setcurrent_tag([]);
      const url = value === "1"
        ? "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagTrendTotalizer"
        : "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagTrend";

      try {
        const request = await fetch(url, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json"
          },
          body: JSON.stringify({ "TagId": tagId, "StartDate": date1_, "EndDate": date2_ })
        });

        const response = await request.json();

        var newdata_ = [];
        let control_data = new Map();

        var maksimumTagValue = response.reduce(function (previousValue, currentValue) {
          previousValue.tagValue = previousValue.tagValue.replaceAll(",", "");
          currentValue.tagValue = currentValue.tagValue.replaceAll(",", "");
          return (Number(previousValue.tagValue) > Number(currentValue.tagValue)) ? previousValue : currentValue;
        });

        props.tags.forEach(i => {
          if (i.tagId === tagId) {
            Sety_axis((PrevState) => ({ ...PrevState, [elemId]: i.tagName }));

          }
        });
        Set_current_max_value((PrevState) => ({ ...PrevState, [elemId]: Number(maksimumTagValue.tagValue) + (Number(maksimumTagValue.tagValue) / 10) }));


        const startDate = new Date(date1_);
        const endDate = new Date(date2_);
        const dateDifference = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1; // Difference in days (inclusive)

        const maxItemsPerDay = Math.floor(3000 / dateDifference);

        response.forEach((item) => {
          let value_int = Number(item.tagValue);
          let obj__ = {
            "date": item.valueDate,
            "value": Number(value_int),
          };



          newdata_.push(obj__);
        });

        // if (value2 !== "1") {
        //   // Limit to 10 data points
        //   const interval = (endDate - startDate) / 10;
        //   newdata_ = newdata_.filter((item, index) => {
        //     const itemDate = new Date(item.date).getTime();
        //     return (itemDate >= startDate.getTime() + index * interval) && (itemDate < startDate.getTime() + (index + 1) * interval);
        //   }).slice(0, 10);
        // }

        SetRealDatas((prevState) => ({ ...prevState, [elemId]: newdata_ }))
      } catch (err) {
        console.log(err);
      }
    }
  };



  const [x_oran, Set_x_oran] = useState(null)
  const [y_oran, Set_y_oran] = useState(null)

  const [rotation, setRotation] = useState(0);

  const handleRotationChange = (e) => {
    let parent = e.target.parentElement;
    let id_ = parent.id;

    setLayouts(prevLayouts => {
      const updatedLayouts = { ...prevLayouts };
      updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(item => {
        if (String(item.id) === id_) {
          return {
            ...item,
            elementDetails: {
              ...item.elementDetails,
              rotate_deg: e.target.value,
            },
          };
        }
        return item;
      });
      return updatedLayouts;
    });

    setRotation(e.target.value)
  };

  // Copy-Paste

  const [showPopup_kopyalandi, Set_showPopup_kopyalandi] = useState(false);
  const [popupPosition_kopyalandi, Set_popupPosition_kopyalandi] = useState({ x: 0, y: 0 });
  const [popupOpacity_kopyalandi, Set_popupOpacity_kopyalandi] = useState(1);
  const [copiedId, Set_copiedId] = useState(null)


  const [hoveredElementId, setHoveredElementId] = useState(null);

  const [temp_image_state, Set_temp_image_state] = useState("")

  useEffect(() => {
    const handleMouseMove = (e) => {
      // Fare hangi elementin üstünde ise onu al
      const hoveredElement = e.target.closest('.react-grid-item');
      if (hoveredElement) {
        setHoveredElementId(hoveredElement.id); // Hover edilen elementin ID'sini kaydet
      } else {
        setHoveredElementId(null); // Eğer react-grid-item dışına çıkarsa ID'yi sıfırla
      }
    };

    const handleKeyDown2 = (e) => {
      if (e.ctrlKey && e.key === 'c') {
        if (hoveredElementId) {
          let elementData = layouts[currentBreakpoint].find(
            (l) => String(l.id) === String(hoveredElementId)
          );
          Set_copiedId(hoveredElementId)
          const element = document.querySelector(`[data-key="${hoveredElementId}"]`);
          if (element) {
            element.style.boxShadow = "0 0 8px 3px rgba(46, 204, 113, 0.8)"; // yeşil glow
            element.style.transition = "box-shadow 0.3s ease"; // geçiş animasyonu
          }

          // Sadece image ise src'yi al ve temp_image_state'e koy
          if (elementData.type === "image") {
            let src_ = image_objs.find(
              (l) => String(l.id) === String(hoveredElementId)
            )?.src;

            if (src_ && src_.length > 0) {
              copyToClipboard(elementData, src_); // Elemanı kopyala
            }
          }

          copyToClipboard(elementData, ""); // Elemanı kopyala

        }
      } else if (e.ctrlKey && e.key === 'v' && !special_type_active) {
        // Yapıştırma işlemini tetikleme

        pasteFromClipboard();
      }
    };


    // Fare hareketlerini ve klavye eventlerini dinle
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('keydown', handleKeyDown2);

    // Component unmount olduğunda event listener'ları kaldır
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('keydown', handleKeyDown2);
    };
  }, [hoveredElementId]);

  const copyToClipboard = (layoutItem, src) => {
    const copiedItem = { ...layoutItem };
    localStorage.setItem('copiedLayoutItem', JSON.stringify(copiedItem));

    // İmleç pozisyonunu al ve popup'ı o pozisyonda göster
    document.addEventListener('mousemove', (e) => {
      Set_popupPosition_kopyalandi({ x: e.clientX, y: e.clientY });
    });

    console.log(src);

    if (src !== "") {
      Set_temp_image_state(src)
    }


    console.log(temp_image_state);

    // Pop-up'ı göster
    Set_showPopup_kopyalandi(true);
    Set_popupOpacity_kopyalandi(1); // Başlangıçta tamamen görünür yap

    // 1 saniye sonra opacity animasyonunu başlat
    setTimeout(() => {
      Set_popupOpacity_kopyalandi(0); // 2 saniyelik geçişle kaybolacak
    }, 1000);

    // 3 saniye sonra pop-up'ı tamamen gizle
    setTimeout(() => {
      Set_showPopup_kopyalandi(false);
    }, 3000);
  };
  const [isOpenGroup, setIsOpenGroup] = useState(false);
  const [selectedOptionGroup, setSelectedOptionGroup] = useState("");

  const toggleDropdownGroup = () => setIsOpenGroup(!isOpenGroup);

  const handleOptionClickGroup = (option) => {
    setSelectedOptionGroup(option);
    setIsOpenGroup(false);
  };


  const [add_unit, Set_add_unit] = useState("")



  const pasteFromClipboard = () => {
    let copiedItem_ = localStorage.getItem('copiedLayoutItem');

    if (copiedItem_) {
      const copiedItem = JSON.parse(copiedItem_);

      console.log(copiedItem, temp_image_state);

      const element = document.querySelector(`[data-key="${copiedId}"]`);
      if (element) {
        element.style.boxShadow = "none"; // yeşil glow
        element.style.transition = "none"; // geçiş animasyonu
      }


      setLayouts((prevLayouts) => {
        const currentItems = prevLayouts[currentBreakpoint] || [];
        const newItemID = top_score_id !== null ? currentItems.length + top_score_id : currentItems.length;

        // Eğer kopyalanan eleman bir image ise
        if (copiedItem.type === "image" && temp_image_state !== "") {
          Set_image_objs((prevItems) => [
            ...prevItems,
            { id: newItemID, src: temp_image_state }
          ]);
          console.log(image_objs);

        }

        // Her durumda temp_image_state'i sıfırla

        const newItem = {
          ...copiedItem,
          i: String(newItemID + 200001),
          id: newItemID + 200001,
          x: copiedItem.x + 50,
          y: copiedItem.y + 25,
        };

        Set_top_score_id(newItemID + 200001)

        return {
          ...prevLayouts,
          [currentBreakpoint]: [...currentItems, newItem],
        };
      });

      Set_render_items((prevRenderItems) => {
        return {
          ...prevRenderItems,
          [currentBreakpoint]: [...prevRenderItems[currentBreakpoint], "paste_eleman"],
        };
      });
    }
    Set_copiedId(null)
  };




  const [activePageName, Set_activePageName] = useState("")

  const [save_control, Set_save_control] = useState(false)


  const [current_items_prop, Set_current_items_prop] = useState(null)

  //   useEffect(() => {
  //     if (props.pages.length > 0) {


  //         setTimeout(() => {
  //             let pageName_ = window.location.pathname;
  //             pageName_ = pageName_.substring(pageName_.lastIndexOf("/") + 1, pageName_.length);
  //             console.log(pageName_)
  //             Set_activePageName(pageName_)
  //             let canvas_prop = props.pages.length > 0
  //                 ? props.pages.filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_).map(x => x.details.canvas_boyutu)[0]
  //                 : null;

  //             function normalizeURLPath(path) {
  //                 const turkishMap = {
  //                     'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
  //                     'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
  //                     'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
  //                 };

  //                 return path.split('').map(char => turkishMap[char] || char).join('');
  //             }
  //             let main_sec = document.querySelector(".main_sec")
  //             let leftbar = document.querySelector("aside")
  //             console.log(document.querySelector("aside"));

  //             if (canvas_prop) {

  //                 let items_prop = props.pages.length > 0
  //                     ? props.pages.filter(x => x.pageName === pageName_).map(x => x.details)[0]
  //                     : null;

  //                     Store.dispatch(set_current_page_details(items_prop))

  //                 Set_current_items_prop(items_prop);
  //                 console.log({ width: Number(canvas_prop.width), height: Number(canvas_prop.height) });
  //                 Set_canvas_boyutu({ width: document.querySelector("aside")?window.innerWidth - document.querySelector("aside").getBoundingClientRect().width:window.innerWidth*0.86, height: document.querySelector("header")?window.innerHeight - document.querySelector("header").getBoundingClientRect().height:window.innerHeight - 86 })
  //                 Set_canvas_boyutu_gecici({ width: document.querySelector("aside")?window.innerWidth - document.querySelector("aside").getBoundingClientRect().width:window.innerWidth*0.86, height: document.querySelector("header")?window.innerHeight - document.querySelector("header").getBoundingClientRect().height:window.innerHeight - 86 })
  //                 Store.dispatch(setCanvasBoyut({ width: document.querySelector("aside")?window.innerWidth - document.querySelector("aside").getBoundingClientRect().width:window.innerWidth*0.86, height: document.querySelector("header")?window.innerHeight - document.querySelector("header").getBoundingClientRect().height:window.innerHeight - 86 - 6 }))
  //                 document.querySelector("aside").style.height = Number(window.innerHeight) + "px"
  //                 document.querySelector("aside").style.maxHeight = Number(window.innerHeight) + "px"



  //             }
  //         }, 800);
  //     }

  // }, [props.pages])

  useEffect(() => {
    let pageName_ = window.location.pathname;
    pageName_ = pageName_.substring(pageName_.indexOf("s/") + 2, pageName_.lastIndexOf("/"));
    let canvas_prop = props.pages.length > 0
      ? props.pages.filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_).map(x => x.details.canvas_boyutu)[0]
      : null;

    function normalizeURLPath(path) {
      const turkishMap = {
        'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
        'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
        'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
      };

      return path.split('').map(char => turkishMap[char] || char).join('');
    }

    let main_sec = document.querySelector(".main_sec")
    let leftbar = document.querySelector("aside");
    let items_prop = props.pages.length > 0
      ? props.pages.filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_).map(x => x.details)[0]
      : null;

    function normalizeURLPath(path) {
      const turkishMap = {
        'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
        'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
        'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
      };

      return path.split('').map(char => turkishMap[char] || char).join('');
    }

    console.log(items_prop);
    Set_current_items_prop(items_prop);

    Store.dispatch(set_current_page_details(items_prop))





    Set_canvas_boyutu({ width: window.innerWidth - leftbar.getBoundingClientRect().width, height: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 })
    Set_canvas_boyutu_gecici({ width: window.innerWidth - leftbar.getBoundingClientRect().width, height: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 })
    Store.dispatch(setCanvasBoyut({ width: window.innerWidth - leftbar.getBoundingClientRect().width, height: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 - 6 }))
    document.querySelector("aside").style.height = Number(window.innerHeight) + "px"
    document.querySelector("aside").style.maxHeight = Number(window.innerHeight) + "px"



  }, [props.pages, screenWidthState])



  useEffect(() => {




    const setWEidth = () => {

      setTimeout(() => {
        if (document.querySelector(".main_sec")) {
          Set_screenWidthState((document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86));

        } else {
          Set_screenWidthState(document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86);

        }

      }, 800);

    }
    // Add event listener to update okPopup on window resize
    window.addEventListener("resize", setWEidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", setWEidth);
      Store.dispatch(set_current_dyn_pageName(""))
    };
  }, []);



  const {
    className = "layout",
    rowHeight = 0.1,
    cols = { lg: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, md: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, sm: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, xs: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, xxs: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, },

    onLayoutChange = () => { },
  } = props;


  const [ok_popup, Set_ok_popup] = useState(null)
  const [elem_popup, Set_elem_popup] = useState(null)


  const [layouts, setLayouts] = useState({
    lg: [],
    md: [],
    sm: [],
    xs: [],
    xxs: [],
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [searchTerm2, setSearchTerm2] = useState('');
  const [searchTerm3, setSearchTerm3] = useState('');
  const [searchTerm4, setSearchTerm4] = useState('');
  const [searchTerm5, setSearchTerm5] = useState('');


  const [zoomLevel, setZoomLevel] = useState(getZoomLevel());

  const [ws_items, Set_ws_items] = useState([])

  const [ws_active, Set_ws_active] = useState(false)

  useEffect(() => { setLayouts(layouts) }, [zoomLevel])

  useEffect(() => {
    const handleResize = () => {
      setZoomLevel(getZoomLevel());
    };

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function getZoomLevel() {
    return Math.round(window.devicePixelRatio * 100);
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };
  const handleSearch2 = (event) => {
    setSearchTerm2(event.target.value.toLowerCase());
  };
  const handleSearch3 = (event) => {
    setSearchTerm3(event.target.value.toLowerCase());
  };
  const handleSearch4 = (event) => {
    setSearchTerm4(event.target.value.toLowerCase());
  };
  const handleSearch5 = (event) => {
    setSearchTerm5(event.target.value.toLowerCase());
  };

  const [top_score_id2, Set_top_score_id2] = useState(null);//en yüksek id ye sahip elemanın id'si




  const filteredTags = props.tags.filter(tag =>
    tag.tagName.toLowerCase().includes(searchTerm)
  );
  const filteredTags2 = props.tags.filter(tag =>
    tag.tagName.toLowerCase().includes(searchTerm2)
  );

  const filteredTags3 = props.tags.filter(tag =>
    tag.tagName.toLowerCase().includes(searchTerm3)
  );

  const filteredTags4 = props.tags.filter(tag =>
    tag.tagName.toLowerCase().includes(searchTerm4)
  );
  const [page_bgColor, Set_page_bgColor] = useState("")


  const bgRef = useRef(null)

  const mainRef = useRef(null)

  const [bg_control, Set_bg_control] = useState(false)
  const [bg_item, Set_bg_item] = useState("");
  const [bg_key_current, Set_bg_key_current] = useState("")

  const [compactType, setCompactType] = useState(null);
  const [resizeHandles, setResizeHandles] = useState(["se"]);
  const [mounted, setMounted] = useState(false);

  const [render_items, Set_render_items] = useState({
    lg: [],
    md: [],
    sm: [],
    xs: [],
    xxs: [],
  });
  const [gauge_value, Set_gauge_value] = useState(72);

  const [temp_gauge_max, Set_temp_gauge_max] = useState(0);

  const [current_pageDetails, Set_currentpageDetails] = useState(null);

  const [top_score_id, Set_top_score_id] = useState(null);//en yüksek id ye sahip elemanın id'si
  const [top_group_t_id, Set_top_group_t_id] = useState(null);//en yüksek id ye sahip elemanın id'si

  const [original_page_name, Set_original_page_name] = useState("")
  const [ogPageName, Set_ogPageName] = useState("")

  const [key, setKey] = useState(0);

  const [total_widget_in_page, Set_total_widget_in_page] = useState(0)

  useEffect(() => {

    console.warn("top_score_id", top_score_id)
  }, [top_score_id])

  const reloadGauge = () => {
    setKey((prevKey) => prevKey + 1); // Key değiştirildiğinde gauge yeniden yüklenir
  };

  const getLS = async () => {

    if (document.querySelector(".main_sec")) {
      try {

        Set_control_loading(true)
        let response;
        if (props.current_dyn_pageName !== "") {
          response = await fetch(
            `https://app-rmmsapi.azurewebsites.net/api/pages/GetPagetByName`,
            {
              method: "POST",
              body: JSON.stringify({
                pageName: props.current_dyn_pageName,
                companyId: props.com_id,
              }),
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            }
          );
        } else {
          response = await fetch(
            `https://app-rmmsapi.azurewebsites.net/api/pages/GetPageList`,
            {
              method: "POST",
              body: JSON.stringify({
                companyId: props.com_id,
              }),
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            }
          );
        }

        const data = await response.json();
        var newlist = data;
        if (props.current_dyn_pageName === "") {
          newlist.forEach(async (i) => {
            await Store.dispatch(add_page_name(i.pageName));
            if (i.details !== "") {
              i.details = JSON.parse(i.details);
            }
          });

          await Store.dispatch(set_pages(newlist));
          Set_page_list(newlist)
        }



        let last_id_data = [];

        let pageName_ = window.location.pathname;
        pageName_ = pageName_.substring(pageName_.indexOf("s/") + 2, pageName_.lastIndexOf("/"));
        let items = newlist.length > 0
          ? newlist
            .filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_)
            .map(x => typeof x.details === 'string' ? JSON.parse(x.details) : x.details)[0]
          : null;

        let ogName = newlist.length > 0
          ? newlist
            .filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_)
            .map(x => x.pageName)[0]
          : null;

        Set_ogPageName(ogName)
        Set_sayfa_adi(ogName)



        Set_original_page_name(pageName_)

        let group = newlist.length > 0
          ? newlist
            .filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_)
            .map(x => x.group)[0]
          : null;

        let bgColor = newlist.length > 0
          ? newlist
            .filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_)
            .map(x => x.bgColor)[0]
          : null;

        Set_sayfa_group(group)
        setSelectedOptionGroup(group)
        Set_page_bgColor(bgColor !== undefined ? bgColor : "")

        function normalizeURLPath(path) {
          const turkishMap = {
            'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
            'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
            'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
          };

          return path.split('').map(char => turkishMap[char] || char).join('');
        }
        console.log(items, props.pages);
        if (items !== null) {
          const canvas_boyutu_ = current_pageDetails !== null ? current_pageDetails.canvas_boyutu : items.canvas_boyutu;


          Set_currentpageDetails(items);

          let guncel_ekran_boyutu;
          let df1_w = document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86
          let df1_h = document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86

          let df2_w = (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)
          let df2_h = (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)



          guncel_ekran_boyutu = { w: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, h: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 }

          console.warn(canvas_boyutu, guncel_ekran_boyutu)

          let json_items;
          let currentWidth = guncel_ekran_boyutu.w
          let initalWidth = canvas_boyutu_.width
          let currentHeight = guncel_ekran_boyutu.h
          let initalHeight = canvas_boyutu_.height

          let width_oran = currentWidth / initalWidth;
          let height_oran = currentHeight / initalHeight;


          if (items) {
            json_items = items;
            if (JSON.stringify(json_items) !== "{}") {
              if (json_items.lg) {
                var temp_data = [];
                let top_score_control = 0
                let top_group_id_control = 0


                json_items.lg.forEach((item) => {
                  if (Number(item.id) > top_score_control) {
                    top_score_control = Number(item.id)
                  }
                  if (item.group_t_id && Number(item.group_t_id) > top_group_id_control) {
                    top_group_id_control = Number(item.group_t_id);
                    Set_total_widget_in_page(prev => prev + 1);
                  }

                  if (item.type === "trend" && item.elementDetails.tagId !== "") {
                    fetchTag(item.elementDetails.tagId, props.totalizer_tags.some(tag2 => item.elementDetails.tagId === tag2.tagId) ? "1" : " 0", "0", item.id)
                  }
                  if (item.type === "bg") {
                    item.elementDetails.left = item.elementDetails.left * width_oran
                    item.elementDetails.width = item.elementDetails.width * width_oran
                    item.elementDetails.top = item.elementDetails.top * height_oran
                    item.elementDetails.height = item.elementDetails.height * height_oran
                  }

                  if (item.elementDetails.items && item.elementDetails.items.length > 0) {
                    item.elementDetails.items.forEach(x => {
                      if (x.elementDetails.tagId && x.elementDetails.tagId !== "" && last_id_data.indexOf(x.elementDetails.tagId) < 0) {
                        last_id_data.push(x.elementDetails.tagId)
                      }
                      if (Number(x.id) > top_score_control) {
                        top_score_control = Number(x.id)
                      }
                      x.x = x.hasOwnProperty("x_percent") ? x.x_percent * currentWidth : x.x * width_oran;
                      x.w = x.hasOwnProperty("w_percent") ? x.w_percent * currentWidth : x.w * width_oran;
                      x.y = x.hasOwnProperty("y_percent") ? x.y_percent * currentHeight : x.y * height_oran;
                      x.h = x.hasOwnProperty("h_percent") ? x.h_percent * currentHeight : x.h * height_oran;

                      x.fontSize = Number(x.fontSize) * width_oran;
                    })
                  }


                  item.x = item.x_percent * currentWidth;
                  item.w = item.w_percent * currentWidth;
                  item.y = item.y_percent * currentHeight;
                  item.h = item.h_percent * currentHeight;

                  if (item.elementDetails.tagId && item.elementDetails.tagId !== "") {
                    last_id_data.push(item.elementDetails.tagId)
                  }

                  item.fontSize = item.fontSize * width_oran


                  temp_data.push(item.type);
                });
                Set_top_score_id(top_score_control)
                Set_top_group_t_id(top_group_id_control)


                Set_render_items((prevLayouts) => {
                  return {
                    ...prevLayouts,
                    lg: temp_data,
                  };
                });
              }
              if (json_items.md) {
                var temp_data = [];
                json_items.md.forEach((item) => {

                  if (item.type === "bg") {
                    item.elementDetails.left = item.elementDetails.left * width_oran
                    item.elementDetails.width = item.elementDetails.width * width_oran
                    item.elementDetails.top = item.elementDetails.top * height_oran
                    item.elementDetails.height = item.elementDetails.height * height_oran
                  }

                  if (item.elementDetails.items && item.elementDetails.items.length > 0) {
                    item.elementDetails.items.forEach(x => {
                      if (x.elementDetails.tagId && x.elementDetails.tagId !== "" && last_id_data.indexOf(x.elementDetails.tagId) < 0) {
                        last_id_data.push(x.elementDetails.tagId)
                      }
                      x.x = x.hasOwnProperty("x_percent") ? x.x_percent * currentWidth : x.x * width_oran;
                      x.w = x.hasOwnProperty("w_percent") ? x.w_percent * currentWidth : x.w * width_oran;
                      x.y = x.hasOwnProperty("y_percent") ? x.y_percent * currentHeight : x.y * height_oran;
                      x.h = x.hasOwnProperty("h_percent") ? x.h_percent * currentHeight : x.h * height_oran;

                      x.fontSize = Number(x.fontSize) * width_oran;
                    })
                  }
                  temp_data.push(item.type);
                  console.log(item.x, item.y);

                  item.x = item.x_percent * currentWidth;
                  item.w = item.w_percent * currentWidth;
                  item.y = item.y_percent * currentHeight;
                  item.h = item.h_percent * currentHeight;

                  item.fontSize = item.fontSize * width_oran

                });



                Set_render_items((prevLayouts) => {
                  return {
                    ...prevLayouts,
                    md: temp_data,
                  };
                });
              }
              if (json_items.sm) {
                var temp_data = [];
                json_items.sm.forEach((item) => {

                  temp_data.push(item.type);

                  if (item.type === "bg") {
                    item.elementDetails.left = item.elementDetails.left * width_oran
                    item.elementDetails.width = item.elementDetails.width * width_oran
                    item.elementDetails.top = item.elementDetails.top * height_oran
                    item.elementDetails.height = item.elementDetails.height * height_oran
                  }

                  if (item.elementDetails.items && item.elementDetails.items.length > 0) {
                    item.elementDetails.items.forEach(x => {
                      if (x.elementDetails.tagId && x.elementDetails.tagId !== "" && last_id_data.indexOf(x.elementDetails.tagId) < 0) {
                        last_id_data.push(x.elementDetails.tagId)
                      }
                      x.x = x.hasOwnProperty("x_percent") ? x.x_percent * currentWidth : x.x * width_oran;
                      x.w = x.hasOwnProperty("w_percent") ? x.w_percent * currentWidth : x.w * width_oran;
                      x.y = x.hasOwnProperty("y_percent") ? x.y_percent * currentHeight : x.y * height_oran;
                      x.h = x.hasOwnProperty("h_percent") ? x.h_percent * currentHeight : x.h * height_oran;

                      x.fontSize = Number(x.fontSize) * width_oran;
                    })
                  }

                  console.log(item.x, item.y);


                  item.x = item.x_percent * currentWidth;
                  item.w = item.w_percent * currentWidth;
                  item.y = item.y_percent * currentHeight;
                  item.h = item.h_percent * currentHeight;

                  item.fontSize = item.fontSize * width_oran

                });


                Set_render_items((prevLayouts) => {
                  return {
                    ...prevLayouts,
                    sm: temp_data,
                  };
                });
              }
              if (json_items.xs) {
                var temp_data = [];
                json_items.xs.forEach((item) => {

                  temp_data.push(item.type);
                  if (item.type === "bg") {
                    item.elementDetails.left = item.elementDetails.left * width_oran
                    item.elementDetails.width = item.elementDetails.width * width_oran
                    item.elementDetails.top = item.elementDetails.top * height_oran
                    item.elementDetails.height = item.elementDetails.height * height_oran
                  }

                  console.log(item.x, item.y);

                  if (item.elementDetails.items && item.elementDetails.items.length > 0) {
                    item.elementDetails.items.forEach(x => {
                      if (x.elementDetails.tagId && x.elementDetails.tagId !== "" && last_id_data.indexOf(x.elementDetails.tagId) < 0) {
                        last_id_data.push(x.elementDetails.tagId)
                      }
                      x.x = x.hasOwnProperty("x_percent") ? x.x_percent * currentWidth : x.x * width_oran;
                      x.w = x.hasOwnProperty("w_percent") ? x.w_percent * currentWidth : x.w * width_oran;
                      x.y = x.hasOwnProperty("y_percent") ? x.y_percent * currentHeight : x.y * height_oran;
                      x.h = x.hasOwnProperty("h_percent") ? x.h_percent * currentHeight : x.h * height_oran;

                      x.fontSize = Number(x.fontSize) * width_oran;
                    })
                  }


                  item.x = item.x_percent * currentWidth;
                  item.w = item.w_percent * currentWidth;
                  item.y = item.y_percent * currentHeight;
                  item.h = item.h_percent * currentHeight;

                  item.fontSize = item.fontSize * width_oran

                });


                Set_render_items((prevLayouts) => {
                  return {
                    ...prevLayouts,
                    xs: temp_data,
                  };
                });
              }
              if (json_items.xxs) {
                var temp_data = [];
                json_items.xxs.forEach((item) => {

                  if (item.type === "bg") {
                    item.elementDetails.left = item.elementDetails.left * width_oran
                    item.elementDetails.width = item.elementDetails.width * width_oran
                    item.elementDetails.top = item.elementDetails.top * height_oran
                    item.elementDetails.height = item.elementDetails.height * height_oran
                  }

                  if (item.elementDetails.items && item.elementDetails.items.length > 0) {
                    item.elementDetails.items.forEach(x => {
                      if (x.elementDetails.tagId && x.elementDetails.tagId !== "" && last_id_data.indexOf(x.elementDetails.tagId) < 0) {
                        last_id_data.push(x.elementDetails.tagId)
                      }
                      x.x = x.hasOwnProperty("x_percent") ? x.x_percent * currentWidth : x.x * width_oran;
                      x.w = x.hasOwnProperty("w_percent") ? x.w_percent * currentWidth : x.w * width_oran;
                      x.y = x.hasOwnProperty("y_percent") ? x.y_percent * currentHeight : x.y * height_oran;
                      x.h = x.hasOwnProperty("h_percent") ? x.h_percent * currentHeight : x.h * height_oran;

                      x.fontSize = Number(x.fontSize) * width_oran;
                    })
                  }
                  temp_data.push(item.type);

                  console.log(item.x, item.y);

                  item.x = item.x_percent * currentWidth;
                  item.w = item.w_percent * currentWidth;
                  item.y = item.y_percent * currentHeight;
                  item.h = item.h_percent * currentHeight;

                  item.fontSize = item.fontSize * width_oran

                });
                Set_render_items((prevLayouts) => {
                  return {
                    ...prevLayouts,
                    xxs: temp_data,
                  };
                });
              }
            }

          } else {
            json_items = { lg: [], md: [], sm: [], xs: [], xxs: [] };
          }
          let last_obje = []
          console.log(last_id_data);
          last_id_data.forEach(s => {
            last_obje.push({ tagId: s })
          })
          Set_active_page_TagIds(last_obje)
          console.warn(json_items, "json");
          setLayouts(json_items);
        }
      } catch (err) {
        console.log(err);
      } finally {
        Set_control_loading(false)
      }
    }


  };

  useEffect(() => {
    setTimeout(async () => {
      getLS();

    }, 1000);

    setMounted(true);


  }, [screenWidthState, props.com_id]);




  useEffect(() => {

    setLayouts((prevLayouts) => {
      if (prevLayouts[currentBreakpoint]) {
        return {
          ...prevLayouts,
          [currentBreakpoint]: prevLayouts[currentBreakpoint].map(
            (layoutItem) => {
              // Mevcut layout'un her bir elemanının resizeHandles özelliğini güncelle
              return { ...layoutItem, resizeHandles: resizeHandles };
            }
          ),
        };
      }

    });
  }, [resizeHandles]);

  //   function adjustFontSizeforWS(e) {
  //     var id_ = e.target.id;
  //     // Div'i seç
  //     var div = e.target;


  //     var pElements = div.querySelectorAll('.alt_white_space');
  //     var totalHeight = 0;

  //     for (var i = 0; i < pElements.length; i++) {
  //         // Yükseklik
  //         totalHeight += pElements[i].offsetHeight;

  //     }

  //     // Toplam yüksekliği div'in yeni yüksekliği olarak ayarla
  //     div.style.height = String((totalHeight/2 + 20)) + "px";
  // }

  useEffect(() => {
    const layoutList = layouts[currentBreakpoint];

    if (Array.isArray(layoutList) && layoutList.length > 0) {
      let maxId = -1;

      layoutList.forEach(item => {
        const numericId = parseInt(item.id);
        if (!isNaN(numericId) && numericId > maxId) {
          maxId = numericId;
        }
      });

      if (maxId !== -1) {
        Set_top_score_id2(maxId);
      }
    }
  }, [layouts]);



  function adjustFontSizeforWS(id) {
    var div; // divId, div'in gerçek id'siyle değiştirilmelidir
    document.querySelectorAll(".white_Space").forEach((a) => {
      if (a.id === id) {
        div = a;
      }
    });
    var elements = div.querySelectorAll(".alt_white_space");
    var minHeight = Number.MAX_SAFE_INTEGER; // Başlangıçta minimum yüksekliği en büyük olabilecek bir değerle başlat
    var maxHeight = Number.MIN_SAFE_INTEGER; // Başlangıçta maksimum yüksekliği en küçük olabilecek bir değerle başlat


    // Div içindeki her bir elementin pozisyonunu ve yüksekliğini hesapla
    elements.forEach(function (element) {
      var rect = element.getBoundingClientRect(); // Elementin pozisyonunu ve boyutunu al
      var elementTop = rect.top;
      var elementBottom = rect.bottom;

      // En üstteki elemanın başlangıcını, en alttaki elemanın bitişini ve en küçük yüksekliği bul
      if (elementTop < minHeight) {
        minHeight = elementTop;
      }
      if (elementBottom > maxHeight) {
        maxHeight = elementBottom;
      }
    });

    // En üstteki elemanın başlangıcından en alttaki elemanın bitişine kadar olan yüksekliği hesapla
    var totalHeight = maxHeight - minHeight;
    var divHeight = div.offsetHeight;

    if (totalHeight > divHeight) {
      div.style.height = String(totalHeight + 20) + "px";
      setLayouts((prevLayouts) => {
        return {
          ...prevLayouts,
          [currentBreakpoint]: prevLayouts[currentBreakpoint].map(
            (layoutItem) => {
              if (String(layoutItem.id) === id) {
                return {
                  ...layoutItem,
                  h: Number(
                    Number(Math.ceil((totalHeight + 20) / 40)).toFixed(0)
                  ),
                };
              }
              return { ...layoutItem };
            }
          ),
        };
      });
    }
  }

  const getPages = async () => {
    try {
      const response = await fetch(
        `https://app-rmmsapi.azurewebsites.net/api/pages/GetPageList`,
        {
          method: "POST",
          body: JSON.stringify({
            userId: props.uid,
            companyId: props.com_id,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      var newlist = data;
      newlist.forEach(async (i) => {
        await Store.dispatch(add_page_name(i.pageName));
        if (i.details !== "") {
          i.details = JSON.parse(i.details);
        }
      });


      await Store.dispatch(set_pages(newlist));
    } catch (err) {
      console.log(err);
    }
  }

  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };


  const [draggableActive, Set_dragggableActive] = useState(false)

  const [dragggableDetail, Set_dragggableDetail] = useState(null)
  const deleteElem = (id) => {
    // Önce id'yi alıp logluyoruz
    console.log(id);

    setLayouts((prevLayouts) => {
      const updatedLayouts = { ...prevLayouts };

      if (Array.isArray(updatedLayouts[currentBreakpoint])) {
        // Silinecek öğeyi bul
        const itemToDelete = updatedLayouts[currentBreakpoint].find(
          (item) => String(item.id) === String(id)
        );

        // Eğer silinecek öğe image türündeyse, image_objs'tan da sil
        if (itemToDelete && itemToDelete.type === "image") {
          Set_image_objs((prevImageObjs) =>
            prevImageObjs.filter((img) => String(img.id) !== String(id))
          );
        }

        // Layout'tan ilgili öğeyi sil
        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].filter(
          (item) => String(item.id) !== String(id)
        );
      }

      return updatedLayouts;
    });
  };

  const widget_delete = (id) => {
    // Önce id'yi alıp logluyoruz
    console.log(id);

    setLayouts((prevLayouts) => {
      const updatedLayouts = { ...prevLayouts };

      if (Array.isArray(updatedLayouts[currentBreakpoint])) {
        // Silinecek öğeyi bul
        const itemToDelete = updatedLayouts[currentBreakpoint].find(
          (item) => String(item.id) === String(id)
        );

        let group_t_id = null;

        if (itemToDelete.group_t_id) {
          group_t_id = itemToDelete.group_t_id
        }

        if (group_t_id !== null) {
          // Layout'tan ilgili öğeyi sil
          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].filter(
            (item) => String(item.group_t_id) !== String(group_t_id)
          );
        }

      }

      return updatedLayouts;
    });
  };

  const addPageFunc = async (item) => {

    document.querySelector(".main_sec").classList.toggle("main_sec_dark");
    document.querySelector(".export_loading").classList.toggle("export_loading_active");
    let dumenden_items = item;
    dumenden_items = JSON.parse(dumenden_items)
    dumenden_items = dumenden_items.details;

    console.log(JSON.parse(dumenden_items));
    try {
      const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/pages/AddPage", {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        body: item
      })

      if (request.status === 200) {
        const response = await request.json()
      }
      const req__ = await fetch(
        "https://app-rmmsapi.azurewebsites.net/api/person/GetUserList",
        {
          headers: {
            Accept: "applicaiton/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            companyId: String(props.temp_com_id),
          }),
        }
      );

      const response__ = await req__.json();

      if (req__.status === 200 && response__.length > 0) {
        Store.dispatch(set_user_item(response__));
      }
    } catch (err) {
      console.log(err)
    } finally {
      try {

        Set_save_control(false)


        await getPages();
        document.querySelector(".main_sec").classList.toggle("main_sec_dark");
        document.querySelector(".export_loading").classList.toggle("export_loading_active");
        document.querySelector(".tool_box").classList.toggle("tool_box_active")

      } catch (err) {
        console.log(err);
      }

    }


  }

  const [isOpenUnit, setIsOpenUnit] = useState(false);
  const [selectedOptionUnit, setSelectedOptionUnit] = useState("°C");

  const toggleDropdownUnit = () => setIsOpenUnit(!isOpenUnit);

  const handleOptionClickUnit = (option) => {
    setSelectedOptionUnit(option);
    setIsOpenUnit(false);
  };

  const [isOpenSenaryo, setIsOpenSenaryo] = useState(false);
  const [selectedOptionSenaryo, setSelectedOptionSenaryo] = useState(props.flowList.length > 0 ? props.flowList[0].senaryoAdi : "");

  const toggleDropdownSenaryo = () => setIsOpenSenaryo(!isOpenSenaryo);

  const handleOptionClickSenaryo = (option) => {
    setSelectedOptionSenaryo(option);
    setIsOpenSenaryo(false);
  };



  const [isOpenyg, setIsOpenyg] = useState(false);
  const [selectedOptionyg, setSelectedOptionyg] = useState("");
  const [currentIndexYG, Set_currentIndexYG] = useState(0)

  const toggleDropdownyg = () => setIsOpenyg(!isOpenyg);

  const handleOptionClickyg = (option) => {
    setSelectedOptionyg(option);
    setIsOpenyg(false);
  };


  const [isOpenselectbox2, setIsOpenselectbox2] = useState(false);
  const [selectedOptionselectbox2, setSelectedOptionselectbox2] = useState("");

  const toggleDropdownselectbox2 = () => setIsOpenselectbox2(!isOpenselectbox2);

  const handleOptionClickselectbox2 = (option) => {
    setSelectedOptionselectbox2(option);
    setIsOpenselectbox2(false);
  };
  const [gauge_unit_control, Set_gauge_unit_control] = useState(false)
  const [gauge_unit_limit_values, Set_gauge_limit_values] = useState([])

  const [active_popup_id, Set_active_popup_id] = useState(null)

  useEffect(() => { console.log("first,", active_popup_id) }, [active_popup_id])

  const [selectedWidgetsToResize, Set_selectedWidgetsToResize] = useState([]);
  const [old_resize_infos_frame, Set_old_resize_infos_frame] = useState(null);
  const [new_resize_infos_frame, Set_new_resize_infos_frame] = useState(null);


  const [resize_frame_popupActive, Set_resize_frame_popupActive] = useState(false)


  const generateDOM = () => {
    const breakpoints = ["lg", "md", "sm", "xs", "xxs"];
    return breakpoints.map((bp) => {
      if (currentBreakpoint !== bp) return null;
      return layouts[bp].map((l, i) => {
        if (l.type === "text") {

          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-text").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-text").id = l.id

                var popup = document.querySelector(".Popup-text")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".text_widget");
                const parentRect = parentElement.getBoundingClientRect();

                console.log(e.target.getBoundingClientRect().top);

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              style={{
                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={"text_widget" + " " + (l.special_type ? "special_type" : "")}
            >

              {l.elementDetails.text !== "" ? (
                <input
                  type="text"
                  style={{
                    textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`, position: "relative", backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black"
                  }}

                  value={l.elementDetails.text}
                  onChange={(e) => {
                    setLayouts((prevLayouts) => {
                      const updatedLayouts = { ...prevLayouts };
                      if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = updatedLayouts[
                          currentBreakpoint
                        ].map((item) => {
                          if (item.i === e.target.parentElement.id) {
                            // Eğer elemanın ID'si hedef ID ile eşleşiyorsa, metni güncelle
                            return {
                              ...item,
                              elementDetails: {
                                ...item.elementDetails,
                                text: e.target.value,
                              },
                            };
                          }
                          return item;
                        });
                      }
                      return updatedLayouts;
                    });
                  }}
                />
              ) : (
                <input
                  type="text"
                  onChange={(e) => {
                    setLayouts((prevLayouts) => {
                      const updatedLayouts = { ...prevLayouts };
                      if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = updatedLayouts[
                          currentBreakpoint
                        ].map((item) => {
                          if (item.i === e.target.parentElement.id) {
                            // Eğer elemanın ID'si hedef ID ile eşleşiyorsa, metni güncelle
                            return {
                              ...item,
                              elementDetails: {
                                ...item.elementDetails,
                                text: e.target.value,
                              },
                            };
                          }
                          return item;
                        });
                      }
                      return updatedLayouts;
                    });
                  }}
                />
              )}
            </div>
          );
        } else if (l.type === "Alarm") {

          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup_Alarm").classList.toggle("changeProperties_active")
                document.querySelector(".Popup_Alarm").id = l.id

                var popup = document.querySelector(".Popup_Alarm")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".alarm_widget");
                const parentRect = parentElement.getBoundingClientRect();

                console.log(e.target.getBoundingClientRect().top);




                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  seviye: l.elementDetails.seviye || "1"
                })
              }}
              style={{
                zIndex: "1", border: "2px solid black", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor || "transparent"
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className="alarm_widget"
            >
              <div className="main_alarm_widget">

                <div style={{ display: "flex", justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }} className="showAlarmValueW">0</div>
              </div>


            </div>
          );

        } else if (l.type === "t_t") {

          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup_t_t").classList.toggle("changeProperties_active")
                document.querySelector(".Popup_t_t").id = l.id

                var popup = document.querySelector(".Popup_t_t")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".text_tag_widget");
                const parentRect = parentElement.getBoundingClientRect();

                console.log(e.target.getBoundingClientRect().top);

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              style={{
                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className="text_tag_widget"
            >

              <input
                type="text"
                style={{
                  width: "100%", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`, position: "relative", backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black"
                }}

                value={
                  (l.elementDetails.text !== "" ? l.elementDetails.text : " ") +
                  " : " +
                  (l.elementDetails.tagId !== ""
                    ? (() => {
                      let selectedTag;
                      if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(item => item.tip === "Var" && item.tagId === l.elementDetails.tagId);
                      } else {
                        selectedTag = tag_values_state.find(item => item.tagId === l.elementDetails.tagId);
                      }

                      return selectedTag
                        ? selectedTag.tagValue + (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                        : " ";
                    })()
                    : " ")
                }

                onChange={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                      updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(
                        (item) => {
                          if (item.i === l.i) { // Elemanın `id`si ile kontrol yap
                            return {
                              ...item,
                              elementDetails: {
                                ...item.elementDetails,
                                text: e.target.value.split(" : ")[0], // Text alanını düzgün güncelle
                              },
                            };
                          }
                          return item;
                        }
                      );
                    }
                    return updatedLayouts;
                  });
                }}
              />

            </div>
          );

        } else if (l.type === "y_g") {

          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup_y_g").classList.toggle("changeProperties_active")
                document.querySelector(".Popup_y_g").id = l.id

                var popup = document.querySelector(".Popup_y_g")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".yuvarlak_gosterge_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "red",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  rad: l.elementDetails.rad ? l.elementDetails.rad : 10,
                  tur: l.elementDetails.tur ? l.elementDetails.tur : null,
                  bg_list: l.elementDetails.bg_list ? l.elementDetails.bg_list : [],
                  border_list: l.elementDetails.border_list ? l.elementDetails.border_list : [],
                  value_list: l.elementDetails.value_list ? l.elementDetails.value_list : [],

                })

                setTimeout(() => {
                  if (l.elementDetails.tur) {
                    if (l.elementDetails.tur === "circle") {
                      document.querySelector(".rkjg-c").checked = true; // Circle seçili
                    } else {
                      document.querySelector(".rkjg-s").checked = true; // Diğer tür seçili
                    }
                  }

                }, 500)


              }}
              style={{
                border: "2px solid rgb(60,60,60)",

                width: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", height: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", borderRadius: l.elementDetails.rad ? (l.elementDetails.tur ? l.elementDetails.tur === "circle" ? l.elementDetails.rad + "px" : l.elementDetails.borderRadius + "px" : "10px") : "10px", zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "red", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "red", color: l.fontColor ? l.fontColor : "black",
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                h: l.elementDetails.rad ? l.elementDetails.rad : l.w,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className="yuvarlak_gosterge_widget"
            >


            </div>
          );
        } else if (l.type === "i_g") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-i_g").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-i_g").id = l.id

                var popup = document.querySelector(".Popup-i_g")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".i_g_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                zIndex: "1"
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className="i_g_widget"
            >

              <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>

            </div>
          );
        }
        else if (l.type === "go_page") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-go_page").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-go_page").id = l.id

                var popup = document.querySelector(".Popup-go_page")

                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".go_page_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                zIndex: "1"
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className="go_page_widget"
            >

              <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>

            </div>
          );
        }
        else if (l.type === "set") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-selectbox2").id = l.id

                var popup = document.querySelector(".Popup-selectbox2")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                const parentElement = e.target.closest(".set_widget");
                const parentRect = parentElement.getBoundingClientRect();




                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  value_list: l.elementDetails.value_list ? l.elementDetails.value_list : [],
                  type: l.type,
                  bg_list: l.elementDetails.bg_list ? l.elementDetails.bg_list : [],
                  border_list: l.elementDetails.border_list ? l.elementDetails.border_list : [],
                  font_list: l.elementDetails.font_list ? l.elementDetails.font_list : [],


                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                })

                setSelectedOptionselectbox2(l.elementDetails.text)



              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                zIndex: "1",
              }}

              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={`set_widget ${l.elementDetails.text}` + " " + (l.special_type ? "special_type" : "")}
            >
              <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>

            </div>
          );
        }
        else if (l.type === "trend") {
          let data_ = {
            labels: [],
            datasets: [{
              data: [],
              backgroundColor: "transparent",
              borderColor: "#f26c6d",
              pointBorderColor: "#f26c6d",
              pointBorderWidth: 1
            }]

          }
          if (l.elementDetails.data) {
            data_ = {
              labels: l.elementDetails.data.map((item, index) => {
                return item.date

              }),
              datasets: [{
                data: l.elementDetails.data.map((item, index) => {
                  return item.value
                }),
                backgroundColor: "transparent",
                borderColor: "#f26c6d",
                pointBorderColor: "#f26c6d",
                pointBorderWidth: 1
              }]

            }
          }

          const datason = data_

          const optionsSon = {
            scales: {
              x: {
                type: 'time',
                time: {
                  unit: 'day',
                  stepSize: 1,
                  displayFormats: {
                    day: 'MMM D'
                  }
                },
                ticks: {
                  maxTicksLimit: 24
                }
              },
              y: {
                min: Number(min),
                max: 0,
                beginAtZero: true,
                ticks: {
                  callback: function (value) {
                    return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
                  }
                }
              }
            },
            plugins: {
              legend: {
                display: true,
                labels: {
                  filter: function (item, chart) {
                    return item.text !== undefined;
                  },
                  generateLabels: function (chart) {
                    return [{
                      text: "",
                      fillStyle: "crimson",
                      strokeStyle: chart.ctx.strokeStyle,
                      lineWidth: chart.ctx.lineWidth,
                      hidden: false,
                      index: 0,
                      datasetIndex: 0
                    }];
                  }
                }
              },
              zoom: {
                pan: {
                  enabled: true,
                  mode: 'xy',
                },
                zoom: {
                  wheel: {
                    enabled: true,
                  },
                  pinch: {
                    enabled: true,
                  },
                  mode: 'x',
                  onZoom: ({ chart }) => {
                    const xScale = chart.scales.x;
                    const min = xScale.min;
                    const max = xScale.max;
                    const diff = max - min;
                    let unit = 'second';

                    // Zoom leveline göre birim seçimi
                    if (diff > 1000 * 60 * 60 * 24 * 7) {
                      unit = 'day';
                    } else if (diff > 1000 * 60 * 60) {
                      unit = 'hour';
                    } else if (diff > 1000 * 60) {
                      unit = 'minute';
                    }

                    // Yeniden ayarlama
                    xScale.options.time.unit = unit;
                    xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
                    xScale.options.ticks.callback = (value) => {
                      return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
                    };

                    chart.update();
                  },
                },
              },
            },
          };

          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-trend").id = l.id

                var popup = document.querySelector(".Popup-trend")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                const parentElement = e.target.closest(".trend_widget");
                const parentRect = parentElement.getBoundingClientRect();
                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  tagId: l.elementDetails.tagId ? l.elementDetails.tagId : "",
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))

              }}


              style={{ zIndex: "1" }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w * 4) / 5,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className="trend_widget"
            >

              <div style={{ width: "100%", height: "100%" }} className="bottom_sec trend_graph">
                <Line options={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartOptions(String(l.id)) : optionsSon : optionsSon} data={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartData(String(l.id)) : datason : datason} />
              </div>
            </div>
          )
        }
        else if (l.type === "tag") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup").classList.toggle("changeProperties_active")
                document.querySelector(".Popup").id = l.id

                var popup = document.querySelector(".Popup")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".tag_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))

                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  unit_list: l.elementDetails.unit_list ? l.elementDetails.unit_list : []

                })
              }}
              style={{
                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={"tag_widget" + " " + (l.special_type ? "special_type" : "")}
            >



              <input
                id={l.id + "cc"}
                type="text"
                style={{
                  fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                  backgroundColor: "transparent",
                  color: l.fontColor ? l.fontColor : "black",
                  width: "100%", outline: "none", border: "none",

                }}
                value={
                  l.elementDetails.tagId !== ""
                    ? (() => {
                      let selectedTag;
                      if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                          (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                      } else {
                        selectedTag = tag_values_state.find(
                          (item) => item.tagId === l.elementDetails.tagId
                        );
                      }
                      console.log(selectedTag, tag_values_state)


                      if (!selectedTag) return "";

                      const numericValue = parseFloat(selectedTag.tagValue);
                      const isNumeric = !isNaN(numericValue);



                      return isNumeric
                        ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                        (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                        : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                    })()
                    : ""
                }


              />

            </div>
          );
        }
        else if (l.type === "Popup") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-popupduz").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-popupduz").id = l.id

                var popup = document.querySelector(".Popup-popupduz")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;



                const parentElement = e.target.closest(".popupduz_widget");
                const parentRect = parentElement.getBoundingClientRect();


                Set_active_popup_items(l.elementDetails.items)
                Set_active_popup_id(l.id)
                Set_elem_popup({
                  items: l.elementDetails.items,
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", text: l.elementDetails.text,
                  value_list: l.elementDetails.value_list || [],
                  value_list2: l.elementDetails.value_list2 || [],

                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))

              }}
              style={{
                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(70,70,70)", borderRadius: "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className="popupduz_widget"
            >
              <input
                className="showRoomNumber_popupDYN"
                placeholder="room number"
                onChange={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                      updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(
                        (item) => {
                          if (item.i === l.i) { // Elemanın `id`si ile kontrol yap
                            return {
                              ...item,
                              elementDetails: {
                                ...item.elementDetails,
                                text: e.target.value.split(" : ")[0], // Text alanını düzgün güncelle
                              },
                            };
                          }
                          return item;
                        }
                      );
                    }
                    return updatedLayouts;
                  });
                }}
                id={l.id + "cc"}
                type="text"

                value={l.elementDetails.text ? l.elementDetails.text : ""}


                style={{
                  fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                  backgroundColor: "transparent",
                  color: l.fontColor ? l.fontColor : "black",
                  width: "100%", outline: "none", backgroundColor: "transparent"

                }}




              />

              <div className="dyn_popup_bottom_part">
                <div><p style={{ fontSize: `${l.w / 17}px` }}>Oda:</p> <input style={{ color: l.fontColor || "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent" }} type="text" value={
                  l.elementDetails.tagId3 !== ""
                    ? (() => {
                      let selectedTag;
                      if (l.elementDetails.tip3 === "Var") {
                        selectedTag = tag_values_state.find(
                          (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId3
                        );
                      } else {
                        selectedTag = tag_values_state.find(
                          (item) => item.tagId === l.elementDetails.tagId3
                        );
                        console.log(selectedTag, tag_values_state)
                      }

                      if (!selectedTag) return "";

                      const numericValue = parseFloat(selectedTag.tagValue);
                      const isNumeric = !isNaN(numericValue);



                      return isNumeric
                        ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                        (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                        : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                    })()
                    : ""
                } className="dyn_popup_show_room_temp" /></div>
                <div className="span_divPopupW"><span style={{ backgroundColor: l.bgColor2 || "gray", borderColor: l.borderColor2 || "black" }}></span></div>
                <div><p style={{ fontSize: `${l.w / 17}px` }}>Set:</p> <input style={{ color: l.fontColor || "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent" }} type="text" value={
                  l.elementDetails.tagId4 !== ""
                    ? (() => {
                      let selectedTag;
                      if (l.elementDetails.tip4 === "Var") {
                        selectedTag = tag_values_state.find(
                          (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId4
                        );
                      } else {
                        selectedTag = tag_values_state.find(
                          (item) => item.tagId === l.elementDetails.tagId4
                        );
                        console.log(selectedTag, tag_values_state)
                      }

                      if (!selectedTag) return "";

                      const numericValue = parseFloat(selectedTag.tagValue);
                      const isNumeric = !isNaN(numericValue);



                      return isNumeric
                        ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                        (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                        : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                    })()
                    : ""
                } className="dyn_popup_show_room_set_temp" /></div>
              </div>

            </div>
          );
        }
        else if (l.type === "frame") {
          if (!l.special_type) {
            return (
              <div


                onContextMenu={(e) => {
                  e.preventDefault()
                  const shouldHandleOnlyClick = (() => {
                    const el = e.currentTarget;
                    const templateId = el.getAttribute("data-template-id");
                    const boxShadow = el.style.boxShadow;


                    return templateId && templateId.trim() !== "" && boxShadow && boxShadow !== "none";
                  })();

                  if (shouldHandleOnlyClick) {
                    // Sadece onClick'teki olayları çalıştır
                    const el = e.currentTarget;
                    const templateId = el.getAttribute("data-template-id");

                    const yellow = "rgba(237,188,69,0.9) 0px 0px 15px 4px";
                    const green = "rgba(0,255,0,0.9) 0px 0px 15px 4px";
                    const currentBoxShadow = el.style.boxShadow;


                    if (templateId && templateId !== "") {
                      // Yalnızca renk kısmını alıyoruz (gölgeleme ve boyut kısmını atlıyoruz)
                      const extractColor = (boxShadow) => {
                        // Sadece rgba renklerini yakalayacak şekilde regex kullanıyoruz
                        const regex = /rgba?\(\d+,\s*\d+,\s*\d+,\s*(\d*\.\d+|\d+)\)/g;
                        const matches = (boxShadow.match(regex) || []);
                        return matches.length > 0 ? matches[0].trim().replace(/\s+/g, "") : ''; // boşlukları kaldır
                      };

                      const currentColor = extractColor(currentBoxShadow);
                      const yellowColor = extractColor(yellow);
                      const greenColor = extractColor(green);


                      // Renkleri karşılaştır
                      if (currentColor === yellowColor) {
                        // Sarıydı -> Yeşile geçiyor => EKLE
                        el.style.boxShadow = green;
                        Set_selectedWidgetsToResize((prev) => {
                          if (!prev.includes(templateId)) {
                            return [...prev, templateId]; // ekle
                          }
                          return prev; // zaten varsa dokunma
                        });
                      } else if (currentColor === greenColor) {
                        // Yeşildi -> Sarıya dönüyor => ÇIKAR
                        el.style.boxShadow = yellow;
                        Set_selectedWidgetsToResize((prev) => {
                          return prev.filter((id) => id !== templateId); // çıkar
                        });
                      }

                    }
                    return
                  }




                  // --- Buradan sonrası normal onContextMenu işlemleri ---
                  console.log(e.target);
                  e.preventDefault();
                  e.stopPropagation();
                  const { clientX, clientY } = e;
                  document.querySelector(".Popup-frame").classList.toggle("changeProperties_active");
                  document.querySelector(".Popup-frame").id = l.id;

                  var popup = document.querySelector(".Popup-frame");
                  const popupRect = popup.getBoundingClientRect();

                  let newX = clientX + window.scrollX;
                  let newY = clientY + window.scrollY;

                  console.log(newX, newY);

                  if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                    newX = window.innerWidth + window.scrollX - popupRect.width;
                  }

                  if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                    newY = window.innerHeight + window.scrollY - popupRect.height;
                  }

                  if (newX < window.scrollX) {
                    newX = window.scrollX;
                  }

                  if (newY < window.scrollY) {
                    newY = window.scrollY;
                  }

                  console.log(newX, newY);

                  popup.style.left = `${newX}px`;
                  popup.style.top = `${newY}px`;

                  const parentElement = e.target.closest(".frame_widget");
                  const parentRect = parentElement.getBoundingClientRect();

                  Set_elem_popup({
                    width: l.w,
                    height: l.h,
                    left: l.x,
                    top: l.y,
                    borderColor: l.borderColor ? l.borderColor : "#000000",
                    bgColor: l.bgColor ? l.bgColor : "#ffffff",
                    fontColor: l.fontColor ? l.fontColor : "#000000",
                    group_t_id: l.group_t_id ? l.group_t_id : null,
                    type: l.type,
                    id: l.id,
                    borderRadius: l.elementDetails.borderRadius,
                    borderWidth: l.elementDetails.borderWidth
                  });

                  setSearchTerm(
                    l.elementDetails.tagId !== ""
                      ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName
                      : ""
                  );

                  Set_add_option_value(
                    l.elementDetails.text === "ON" && l.elementDetails.value1
                      ? l.elementDetails.value1
                      : l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                        ? l.elementDetails.value1
                        : ""
                  );
                }}


                style={{
                  borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                  borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderWidth: l.elementDetails.borderWidth + "px", zIndex: "0", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                }}
                data-grid={{
                  x: l.x,
                  y: l.y,
                  w: (l.w),
                  h: l.h,
                  resizeHandles: l.resizeHandles,
                }}
                id={l.id}
                data-id={l.special_type ? "popup_" + String(l.id) : ""}
                key={l.i}
                data-key={l.i}
                className="frame_widget"
                data-template-id={l.group_t_id_frame ? l.group_t_id_frame : ""}
              >




              </div>
            );
          } else {
            return (
              <div


                onContextMenu={(e) => {
                  console.log(e.target);
                  e.preventDefault();
                  e.stopPropagation();
                  const { clientX, clientY } = e;
                  document.querySelector(".Popup-frame").classList.toggle("changeProperties_active")
                  document.querySelector(".Popup-frame").id = l.id

                  var popup = document.querySelector(".Popup-frame")
                  const popupRect = popup.getBoundingClientRect();

                  // Yeni pozisyonları hesapla
                  let newX = clientX + window.scrollX;
                  let newY = clientY + window.scrollY;

                  console.log(newX, newY);

                  // Sağ kenardan taşmayı önle
                  if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                    newX = window.innerWidth + window.scrollX - popupRect.width;
                  }

                  // Alt kenardan taşmayı önle
                  if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                    newY = window.innerHeight + window.scrollY - popupRect.height;
                  }

                  // Sol kenardan taşmayı önle
                  if (newX < window.scrollX) {
                    newX = window.scrollX;
                  }

                  // Üst kenardan taşmayı önle
                  if (newY < window.scrollY) {
                    newY = window.scrollY;
                  }

                  console.log(newX, newY);

                  // Pop-up'ın pozisyonunu ayarla
                  popup.style.left = `${newX}px`;
                  popup.style.top = `${newY}px`;
                  setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                  Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                    ? l.elementDetails.value1
                    : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                      ? l.elementDetails.value1 : ""))


                  const parentElement = e.target.closest(".frame_widget");
                  const parentRect = parentElement.getBoundingClientRect();

                  Set_elem_popup({
                    width: l.w,
                    height: l.h,
                    left: l.x,
                    top: l.y,
                    borderColor: l.borderColor ? l.borderColor : "#000000",
                    bgColor: l.bgColor ? l.bgColor : "#ffffff",
                    fontColor: l.fontColor ? l.fontColor : "#000000",
                    type: l.type,
                    id: l.id,
                    borderRadius: l.elementDetails.borderRadius,
                    borderWidth: l.elementDetails.borderWidth,
                    group_t_id: l.group_t_id ? l.group_t_id : null
                  })
                }}
                style={{
                  borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                  borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderWidth: l.elementDetails.borderWidth + "px", zIndex: "0"
                }}
                data-grid={{
                  x: l.x,
                  y: l.y,
                  w: (l.w),
                  h: l.h,
                  resizeHandles: l.resizeHandles,
                }}
                id={l.id}
                data-id={l.special_type ? "popup_" + String(l.id) : ""}
                key={l.i}
                data-key={l.i}
                className="frame_widget"
              >
                <i
                  onClick={(e) => {
                    if (
                      document
                        .querySelector(".main_sec")
                        .classList.contains("main_sec_bg_blur")
                    ) {
                      Set_special_type_active(false);

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].filter(
                            (item) =>
                              !(
                                item.special_type &&
                                String(item.id2) === String(active_popup_id)
                              )
                          );
                        }

                        return updatedLayouts;
                      });

                      Set_active_popup_id(null);
                      Set_active_popup_items([]);

                      // Blur'ı kaldır
                      document
                        .querySelector(".main_sec")
                        .classList.toggle("main_sec_bg_blur");

                      // ToolBox'ları sıfırla
                      document.querySelector(".tool_box").style.opacity = "1";
                      document.querySelector(".tool_box").style.zIndex = "10000";

                      document.querySelector(".tool_box2").style.opacity = "0";
                      document.querySelector(".tool_box2").style.zIndex = "-1";
                      document
                        .querySelector(".tool_box")
                        .classList.toggle("tool_box_active");

                      document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                        x.style.opacity = "1";
                        x.style.zIndex = "2";
                      });




                    }
                  }}
                  style={{
                    position: "relative",
                    left: "95%",
                    top: "-30px",
                    cursor: "pointer",
                    backgroundColor: "red",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    borderRadius: "40px",
                    border: "none",
                  }}
                  className="fa fa-times"
                ></i>





              </div>
            );
          }

        }
        else if (l.type === "fan_modu") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-fan").id = l.id

                var popup = document.querySelector(".Popup-fan")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".fan_modu_widget");
                const parentRect = parentElement.getBoundingClientRect();
                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))

                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                zIndex: "1"
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={"fan_modu_widget" + " " + (l.special_type ? "special_type" : "")}
            >

              <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>

            </div>
          );
        }
        else if (l.type === "calisma_modu") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-calisma").id = l.id

                var popup = document.querySelector(".Popup-calisma")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".calisma_modu_widget");
                const parentRect = parentElement.getBoundingClientRect();
                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value1 : ""))

                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                zIndex: "1"
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={"calisma_modu_widget" + " " + (l.special_type ? "special_type" : "")}
            >


              <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>



            </div>
          );
        }
        else if (l.type === "on/off") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-onOff").id = l.id

                var popup = document.querySelector(".Popup-onOff")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".on-off_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(
                  l.elementDetails.text === "ON"
                    ? (l.elementDetails.tagId && l.elementDetails.tagId !== ""
                      ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName
                      : "")
                    : (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== ""
                      ? props.tags.find(item => item.tagId === l.elementDetails.tagId2)?.tagName
                      : "")
                );

                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  value: l.elementDetails.text
                })
              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                borderRadius: "8px", zIndex: "1",
              }}

              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={`on-off_widget ${l.elementDetails.text} ` + " " + (l.special_type ? "special_type" : "")}
            >
              <div style={{ backgroundColor: "transparent", color: "white", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>

            </div>
          );
        }
        else if (l.type === "lock") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-lock").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-lock").id = l.id

                var popup = document.querySelector(".Popup-lock")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".lock_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(
                  l.elementDetails.text === "ON"
                    ? (l.elementDetails.tagId && l.elementDetails.tagId !== ""
                      ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName
                      : "")
                    : (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== ""
                      ? props.tags.find(item => item.tagId === l.elementDetails.tagId2)?.tagName
                      : "")
                );

                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  value: l.elementDetails.text
                })
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={`lock_widget`}
            >
              <i id="lock_i_dyn" style={{ color: l.fontColor || "gray", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: `${l.w / 4}px` }} className="fa fa-lock">

              </i>

            </div>
          );
        }
        else if (l.type === "empty_btn") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-empty_btn").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-empty_btn").id = l.id

                var popup = document.querySelector(".Popup-empty_btn")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".empty_btn_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  value: l.elementDetails.text
                })
              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                borderRadius: "8px", zIndex: "1",
              }}

              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={`empty_btn_widget ${l.elementDetails.text}`}
            >
              <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                <input style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", outline: "none", appearance: "none", border: "none", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px` }} type="text" value={l.elementDetails.text} onChange={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                      updatedLayouts[currentBreakpoint] = updatedLayouts[
                        currentBreakpoint
                      ].map((item) => {
                        if (item.i === e.target.parentElement.parentElement.id) {
                          // Eğer elemanın ID'si hedef ID ile eşleşiyorsa, metni güncelle
                          return {
                            ...item,
                            elementDetails: {
                              ...item.elementDetails,
                              text: e.target.value,
                            },
                          };
                        }
                        return item;
                      });
                    }
                    return updatedLayouts;
                  });
                }} />

              </div>

            </div>
          );
        }
        else if (l.type === "selectbox") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-selectbox").id = l.id

                var popup = document.querySelector(".Popup-selectbox")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                const parentElement = e.target.closest(".selectbox_widget");
                const parentRect = parentElement.getBoundingClientRect();




                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", text_list: l.elementDetails.text_list,
                  value_list: l.elementDetails.value_list ? l.elementDetails.value_list : [],
                  type: l.type,
                  bg_list: l.elementDetails.bg_list ? l.elementDetails.bg_list : [],
                  border_list: l.elementDetails.border_list ? l.elementDetails.border_list : [],
                  font_list: l.elementDetails.font_list ? l.elementDetails.font_list : [],


                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  value: l.elementDetails.text
                })
                setSelectedOptionselectbox(l.elementDetails.text)


              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                zIndex: "1",
              }}

              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={`selectbox_widget ${l.elementDetails.text}` + " " + (l.special_type ? "special_type" : "")}
            >
              <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>

            </div>
          );
        }
        else if (l.type === "senaryoSelect") {
          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-senaryo").classList.toggle("changeProperties_active")
                document.querySelector(".Popup-senaryo").id = l.id

                var popup = document.querySelector(".Popup-senaryo")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".senaryo_widget");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",

                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  value: l.elementDetails.text
                })
                setSelectedOptionSenaryo(l.elementDetails.text)


              }}
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
              }}

              data-grid={{
                x: l.x,
                y: l.y,
                w: (l.w),
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              key={l.i}
              data-key={l.i}
              className={`senaryo_widget ${l.elementDetails.text}`}
            >
              <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                {l.elementDetails.text}

              </div>

            </div>
          );
        }
        else if (l.type === "image") {


          return (
            <div


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup").classList.toggle("changeProperties_active")
                document.querySelector(".Popup").id = l.id

                var popup = document.querySelector(".Popup")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                const parentElement = e.target.closest(".image_widgetParentDiv");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.borderRadius ? l.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              className="image_widgetParentDiv"
              style={{
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "1px solid rgb(100,100,100)", zIndex: "1"
              }}
              key={l.i}
              data-key={l.i}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
            >

              <img
                style={{ width: "100%", height: "100%" }}
                className="image_widget"
                src={l.elementDetails.src !== ""
                  ? l.elementDetails.src
                  : (image_objs.find(a => String(a.id) === String(l.id))?.src || "")
                }
                alt=""
              />
            </div>
          );
        } else if (l.type === "bg") {

          let diffWidth = document.querySelector(".link-group-data-links").getBoundingClientRect().width * 1.05
          let diffHeigth = document.querySelector("nav").getBoundingClientRect().height * 1.25
          console.log(diffHeigth)


          setTimeout(() => {
            document.querySelector(
              ".main_sec"
            ).style.backgroundImage = `url("${l.elementDetails.src}")`;
            document.querySelector(".main_sec").style.backgroundPosition =
              `${l.elementDetails.left}px ${l.elementDetails.top}px`;
            document.querySelector(".main_sec").style.backgroundSize = `${l.elementDetails.width}px ${l.elementDetails.height}px`;
            document.querySelector(".main_sec").style.backgroundRepeat = "no-repeat"
          }, 100)



        } else if (l.type === "gauge") {
          let value_max = Number(l.elementDetails.maxValue);

          // tip kontrolü ile uygun tag değerini bul
          let selectedTag;
          if (l.elementDetails.tip === "Var") {
            selectedTag = tag_values_state.find(
              (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
            );
          } else {
            selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
          }

          // Sayısal değeri güvenli şekilde al
          let value_tag = selectedTag ? selectedTag.tagValue : "";
          const numericValue = parseFloat(value_tag);
          const isNumeric = !isNaN(numericValue);

          // Eğer isNumeric false ise boşluktan sonrasını kes
          value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];

          console.warn(numericValue, "num", l.elementDetails.endValue, isNumeric);

          // startValue ve endValue güvenli şekilde belirle
          const startValue =
            l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
              ? l.elementDetails.startValue
              : 0;

          const endValue = l.elementDetails.endValue && isNumeric
            ? l.elementDetails.limitValues && l.elementDetails.limitValues.length > 0 && Number([...l.elementDetails.limitValues]
              .sort((a, b) => a.value - b.value)
              .at(-1).value) >= l.elementDetails.endValue
              ? Math.max(l.elementDetails.endValue, numericValue) +
              Number([...l.elementDetails.limitValues]
                .sort((a, b) => a.value - b.value)
                .at(-1).value)
              : Math.max(l.elementDetails.endValue, numericValue)
            : isNumeric
              ? numericValue.toFixed(2)
              : 100;

          // normalizedValue hesapla
          const normalizedValue = isNumeric
            ? ((value_tag - startValue) / (endValue - startValue)) * 100
            : 0;

          // Arc limitlerini tanımla
          const arcLimits = l.elementDetails.pU && l.elementDetails.limitValues
            ? (() => {
              if (l.elementDetails.pU === "Unit") {
                // Unit modu için özel mantık
                const sortedLimits = [...l.elementDetails.limitValues].sort((a, b) => a.value - b.value);
                const colorLimits = sortedLimits.filter(i => i.color);

                let lastLimit = startValue;
                let result = [];

                colorLimits.forEach(({ value, color }) => {
                  let newColor = color;
                  if (l.elementDetails.scaleX === "-1" && color === "#008000") {
                    newColor = "#ff0000";
                  } else if (l.elementDetails.scaleX === "-1" && color === "#ff0000") {
                    newColor = "#008000";
                  }
                  result.push({
                    limit: value,
                    color: newColor,
                  });
                  lastLimit = value;
                });

                // Son rengi endValue'ya kadar devam ettir
                if (colorLimits.length > 2) {
                  result.push({
                    limit: endValue,
                    color: l.elementDetails.scaleX === "-1" ? colorLimits[0].color : colorLimits[colorLimits.length - 1].color,
                  });
                } else {
                  result = [
                    {
                      limit: ((20 / 100) * (endValue - startValue)) + startValue,
                      color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                    },
                    {
                      limit: ((40 / 100) * (endValue - startValue)) + startValue,
                      color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                    },
                    {
                      limit: ((60 / 100) * (endValue - startValue)) + startValue,
                      color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                    },
                    {
                      limit: ((80 / 100) * (endValue - startValue)) + startValue,
                      color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                    },
                    {
                      limit: ((100 / 100) * (endValue - startValue)) + startValue,
                      color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                    },
                  ];
                }

                return result;
              } else if (l.elementDetails.pU === "Percent") {
                // Percent modu için 5 renkli dizi
                return [
                  {
                    limit: ((20 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                  },
                  {
                    limit: ((40 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                  },
                  {
                    limit: ((60 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                  },
                  {
                    limit: ((80 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                  },
                  {
                    limit: ((100 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                  },
                ];
              } else {
                // Diğer durumlar için varsayılan dizi
                return [
                  {
                    limit: ((20 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                  },
                  {
                    limit: ((40 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                  },
                  {
                    limit: ((60 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                  },
                  {
                    limit: ((80 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                  },
                  {
                    limit: ((100 / 100) * (endValue - startValue)) + startValue,
                    color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                  },
                ];
              }
            })()
            : [
              {
                limit: ((20 / 100) * (endValue - startValue)) + startValue,
                color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
              },
              {
                limit: ((40 / 100) * (endValue - startValue)) + startValue,
                color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
              },
              {
                limit: ((60 / 100) * (endValue - startValue)) + startValue,
                color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
              },
              {
                limit: ((80 / 100) * (endValue - startValue)) + startValue,
                color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
              },
              {
                limit: ((100 / 100) * (endValue - startValue)) + startValue,
                color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
              },
            ];

          // Ensure subArcs limits are in ascending order
          arcLimits.sort((a, b) => a.limit - b.limit);

          const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);

          if (textElement && l.fontColor) textElement.style.fill = l.fontColor

          document.querySelectorAll(`.gauge_widgetParentDiv${l.id} .tick-value text`).forEach(x => {
            if (l.fontColor) x.style.fill = l.fontColor
          })



          // pU kontrolü ile text içeriğini güncelle
          if (l.elementDetails.pU) {
            const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);
            if (textElement) {
              if (l.elementDetails.pU === "Unit") {
                if (textElement.textContent.includes("%")) {
                  textElement.textContent = textElement.textContent.slice(0, -1); // "%" karakterini kaldır
                }
                textElement.textContent = value_tag;
              } else {
                if (!textElement.textContent.includes("%")) {
                  textElement.textContent = normalizedValue.toFixed(2) + "%";
                }
              }
            }
          }

          // Min ve Max değerlerini ayarla
          const min = l.elementDetails.pU === "Unit" && l.elementDetails.startValue ? startValue : 0;
          const max = l.elementDetails.pU === "Unit" && l.elementDetails.endValue ? endValue : 100;

          return (
            <div
              className={"gauge_widgetParentDiv" + " gauge_widgetParentDiv" + l.id}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              style={{
                border: "1px solid rgb(100,100,100)",
                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                backgroundColor: l.bgColor ? l.bgColor : "transparent",
                borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius + "px" : "8px",
                minWidth: "100px", minHeight: "100px",
                zIndex: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                overflow: "hidden", // Ebeveyn div taşmasını önler
              }}
              key={l.i + " " + `${random_value}`}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              onDoubleClick={(e) => {
                copyToClipboard(l);
              }}
              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-gauge").classList.toggle("changeProperties_active");
                document.querySelector(".Popup-gauge").id = l.id;

                var popup = document.querySelector(".Popup-gauge");
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                const parentElement = e.target.closest(".gauge_widgetParentDiv");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "");
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""));

                if (l.elementDetails.limitValues) {
                  Set_gauge_limit_values(l.elementDetails.limitValues);
                }

                if (l.elementDetails.pU && l.elementDetails.pU === "Unit") {
                  Set_gauge_unit_control(true);
                }

                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                });
              }}
            >
              <GaugeComponent
                className="gauge_widget"
                value={
                  isNumeric ? l.elementDetails.pU === "Unit"
                    ? Number(value_tag).toFixed(2) // value_tag geçerli sayı mı?
                    : Number(value_tag) * max / 100 : 50 // normalizedValue geçerli sayı mı?
                }
                maxValue={max}
                minValue={min}
                arc={{
                  subArcs:
                    l.elementDetails.pU ? l.elementDetails.pU === "Percent"
                      ? arcLimits.map((arc) => ({
                        limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                        color: arc.color,
                        showTick: true,
                      }))
                      : // Eğer "Unit" modundaysa, startValue ve endValue arasında 5 eşit dilim oluştur
                      arcLimits.map((arc) => {
                        // Eğer arc.limit startValue'dan küçükse startValue'ya ayarla
                        let adjustedLimit = arc.limit < startValue ? startValue
                          // Eğer arc.limit endValue'dan büyükse endValue'ya ayarla
                          : arc.limit > endValue ? endValue
                            : arc.limit;

                        return {
                          limit: adjustedLimit, // Normalize edilmiş limit
                          color: arc.color,
                          showTick: true,
                        };
                      }) : arcLimits.map((arc) => ({
                        limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                        color: arc.color,
                        showTick: true,
                      })),
                }}
                style={{
                  width: "80%", // Tam genişlik
                  height: "80%",
                  marginLeft: "0%", // Tam yükseklik kaplama,
                  opacity: "1",
                }}
              />
            </div>
          );
        }
        else if (l.type === "gauge_linear") {

          console.log("gauge_linear", l)

          // tip kontrolü ile uygun tag değerini bul
          let selectedTag;
          if (l.elementDetails.tip === "Var") {
            selectedTag = tag_values_state.find(
              (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
            );
          } else {
            selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
          }

          // Sayısal değeri güvenli şekilde al
          let value_tag = selectedTag ? selectedTag.tagValue : "";
          const numericValue = parseFloat(value_tag);
          const isNumeric = !isNaN(numericValue);

          // Eğer isNumeric false ise boşluktan sonrasını kes
          value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];





          console.warn(numericValue, "num", l.elementDetails.endValue, isNumeric)
          // startValue ve endValue güvenli şekilde belirle
          const startValue =
            l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
              ? l.elementDetails.startValue
              : 0;

          const endValue =
            l.elementDetails.pU && l.elementDetails.pU === "Unit"
              ? (() => {
                // If limitValues exists, sort it and get the largest value
                const largestLimitValue = l.elementDetails.limitValues
                  ? [...l.elementDetails.limitValues].sort((a, b) => a.value - b.value)[l.elementDetails.limitValues.length - 1]?.value
                  : null;

                // If endValue exists and is numeric
                if (l.elementDetails.endValue && isNumeric) {
                  // If largestLimitValue exists and is greater than endValue, sum them
                  if (largestLimitValue && largestLimitValue > l.elementDetails.endValue) {
                    return l.elementDetails.endValue + largestLimitValue;
                  }
                  // Otherwise, use endValue
                  return l.elementDetails.endValue;
                }

                // If endValue does not exist, use largestLimitValue if it exists
                if (largestLimitValue) {
                  return largestLimitValue;
                }

                // Fallback to numericValue or default value
                return isNumeric ? numericValue.toFixed(2) : 100;
              })()
              : l.elementDetails.endValue && isNumeric
                ? Math.max(l.elementDetails.endValue, numericValue) // Use the larger value between endValue and numericValue
                : isNumeric
                  ? numericValue.toFixed(2) // Fallback to numericValue if endValue is not provided
                  : 100; // Default value if neither is valid
          // normalizedValue hesapla
          const normalizedValue = isNumeric
            ? ((value_tag - startValue) / (endValue - startValue)) * 100
            : 0;


          const alarmValue = l.elementDetails.alarmValue || 0

          const linearOptions = {
            pointer: {
              value: isNumeric ? numericValue : 50, // Sayıysa kullan, değilse 50
              shape: "arrow",
              size: 20,
              color: "rgb(20,20,20)"// Pointer büyüklüğü artırıldı
            },
            scale: {
              min: startValue,
              max: endValue,
              majorUnit: (endValue - startValue) / 5,
              minorUnit: 2,
              line: {
                width: 5, // Ölçek çizgisi kalınlaştırıldı
                color: "black"
              },
              labels: {
                color: "black",
                visible: true,
                font: "14px Arial, sans-serif", // Yazı fontu büyütüldü
              },
              ranges: [
                { from: startValue, to: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, color: "red" },
                { from: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, to: endValue, color: "blue" },
              ],
            },
          };


          return (
            <div
              className="gauge_widgetParentDiv"
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}


              style={{
                border: "none",
                borderWidth: l.borderWidth ? `${l.borderWidth}px` : "2px",
                backgroundColor: "transparent",
                borderRadius: l.elementDetails.borderRadius ? `${l.elementDetails.borderRadius}px` : "8px",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                overflow: "hidden",
              }}
              key={l.i + " " + `${random_value}`}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              onDoubleClick={(e) => {
                copyToClipboard(l)
              }}
              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".Popup-gauge-linear").classList.toggle("changeProperties_active");
                document.querySelector(".Popup-gauge-linear").id = l.id;

                var popup = document.querySelector(".Popup-gauge-linear");
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                const parentElement = e.target.closest(".gauge_widgetParentDiv");
                const parentRect = parentElement.getBoundingClientRect();

                setSearchTerm(l.elementDetails.tagId !== "" ? props.tags.find(item => item.tagId === l.elementDetails.tagId)?.tagName : "")
                Set_add_option_value(l.elementDetails.text === "ON" && l.elementDetails.value1
                  ? l.elementDetails.value1
                  : (l.elementDetails.text === "OFF" && l.elementDetails.value2 !== ""
                    ? l.elementDetails.value2 : ""))


                Set_elem_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  borderWidth: l.borderWidth ? l.borderWidth : 2,
                  borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius : 2,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000", type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                  tagId: l.elementDetails && l.elementDetails.tagId ? l.elementDetails.tagId : ""
                });
              }}
            >


              <div className="su_tanki_gauge_linear" style={{ borderColor: l.borderColor || "#000" }}>
                <div style={{ position: "relative", height: "100%", width: "100%", display: "flex", flexDirection: "column-reverse" }}>
                  <div style={{ width: "100%", height: alarmValue >= numericValue ? "0%" : numericValue * 100 / endValue + "%", backgroundColor: "blue" }} className="water"></div>
                  <div style={{ width: "100%", height: alarmValue >= numericValue ? numericValue * 100 / endValue + "%" : "0%", backgroundColor: "red" }} className="alarmWater"></div>

                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)", // Bu, öğeyi tam olarak ortalar
                      backgroundColor: "black", // Hafif şeffaf beyaz arka plan
                      padding: "4px 8px",
                      borderRadius: "6px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      zIndex: "3",
                      color: "#ffffff", // Daha koyu siyah
                      fontFamily: "'Poppins', sans-serif", // Daha modern ve seksi font
                      boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.15)", // Hafif gölge efekti
                    }}
                  >
                    {isNumeric ? l.elementDetails.pU && l.elementDetails.pU === "Percent" ? (numericValue * 100 / endValue).toFixed(2) + "%" : numericValue : 50}
                  </div>
                </div>
              </div>



            </div>
          );
        }
        else if (l.type === "left_ok") {
          let rotate_deg = 0;
          if (l.elementDetails.rotate_deg) {
            rotate_deg = l.elementDetails.rotate_deg
          }

          return (
            <div

              style={{ maxHeight: "50px", display: "flex", alignItems: "center", zIndex: "1" }}


              onContextMenu={(e) => {
                console.log(e.target);
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".change_color").classList.toggle("change_color_active")
                document.querySelector(".change_color").id = l.id

                var popup = document.querySelector(".change_color")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                const parentElement = e.target.closest(".left_ok_arrow");
                const parentRect = parentElement.getBoundingClientRect();

                Set_ok_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  top: l.y,
                  borderColor: l.borderColor ? l.borderColor : "#000000",
                  bgColor: l.bgColor ? l.bgColor : "#ffffff",
                  fontColor: l.fontColor ? l.fontColor : "#000000",
                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              key={l.i}
              data-key={l.i}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              className="left_ok_arrow"
            >

              <svg style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} width={"100%"} className="sebeke-giris-cizgi">
                <line
                  x1="0"
                  y1="25"
                  x2="200%"
                  y2="25"
                  stroke={l.elementDetails.color}
                  strokeWidth="8"
                />
                <polygon
                  points="0,25 20,10 20,40"
                  fill={l.elementDetails.color}
                />
                <line

                  stroke="black"
                  strokeWidth="14"
                  markerEnd="url(#arrowhead)"
                />
              </svg>

            </div>
          )


        } else if (l.type === "right_ok") {

          let rotate_deg = 0;
          if (l.elementDetails.rotate_deg) {
            rotate_deg = l.elementDetails.rotate_deg
          }

          return (
            <div

              style={{ maxHeight: "50px", display: "flex", alignItems: "center", color: `${l.elementDetails.color}`, zIndex: "1" }}

              onContextMenu={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const { clientX, clientY } = e;
                document.querySelector(".change_color").classList.toggle("change_color_active")
                document.querySelector(".change_color").id = l.id

                var popup = document.querySelector(".change_color")
                const popupRect = popup.getBoundingClientRect();

                // Yeni pozisyonları hesapla
                let newX = clientX + window.scrollX;
                let newY = clientY + window.scrollY;

                console.log(newX, newY);

                // Sağ kenardan taşmayı önle
                if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                  newX = window.innerWidth + window.scrollX - popupRect.width;
                }

                // Alt kenardan taşmayı önle
                if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                  newY = window.innerHeight + window.scrollY - popupRect.height;
                }

                // Sol kenardan taşmayı önle
                if (newX < window.scrollX) {
                  newX = window.scrollX;
                }

                // Üst kenardan taşmayı önle
                if (newY < window.scrollY) {
                  newY = window.scrollY;
                }

                console.log(newX, newY);

                // Pop-up'ın pozisyonunu ayarla
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;


                Set_ok_popup({
                  width: l.w,
                  height: l.h,
                  left: l.x,
                  top: l.y,


                  type: l.type,
                  id: l.id,
                  fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                })
              }}
              data-grid={{
                x: l.x,
                y: l.y,
                w: l.w,
                h: l.h,
                resizeHandles: l.resizeHandles,
              }}
              key={l.i}
              data-key={l.i}
              id={l.id}
              data-id={l.special_type ? "special_type" : ""}
              className="right_arrow"
            >

              <svg width="100%" style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} height="50" className="sebeke-giris-cizgi">
                <defs>
                  <marker id={`arrowhead${l.id}`} orient="auto" markerWidth="5" markerHeight="5" refX="5" refY="2.5">
                    <path d="M 0,0 L 5,2.5 L 0,5 Z" fill={`${l.elementDetails.color}`} />
                  </marker>
                </defs>

                <line
                  x1="0"
                  y1="25"
                  x2="calc(100% - 10px)"
                  y2="25"
                  stroke={l.elementDetails.color}
                  strokeWidth="8"
                />

                <line
                  x1="0"
                  y1="25"
                  x2="100%"
                  y2="25"
                  stroke={l.elementDetails.color}
                  strokeWidth="8"
                  marker-end={`url(#arrowhead${l.id})`}
                />
              </svg>









            </div>
          )

        }

      });
    })
  };

  const [showPopupCopyPage, setShowPopupCopyPage] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const copyLayout = async () => {
    const copiedLayout = JSON.stringify({ copied_page: layouts }, null, 2);
    try {
      await navigator.clipboard.writeText(copiedLayout);
      setShowPopupCopyPage(true); // Popup'u göster
      setFadeOut(false);

      setTimeout(() => setFadeOut(true), 3000); // 3 saniye sonra opaklığı azalt


      setTimeout(() => {

        setShowPopupCopyPage(false); // 4 saniye sonra kaybolsun
      }, 4000);

    } catch (err) {
      console.error("Kopyalama başarısız!", err);
    }
  };


  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (text.includes('"copied_page"')) {

        const copied_layout = JSON.parse(text).copied_page
        setLayouts(copied_layout)
      } else {
        alert("Yapıştırılan içerik geçerli değil!");
      }
    } catch (err) {
      console.error("Yapıştırma hatası:", err);
    }
  };

  const [group_t_id, Set_group_t_id] = useState(1)


  useEffect(() => {
    const cleanImageSrc = (layout) => {
      return layout.map(item => {
        if (item.type === 'image') {
          return {
            ...item,
            elementDetails: {
              ...item.elementDetails,
              src: '' // src'yi temizle
            }
          };
        }
        return item;
      });
    };

    const breakpoints = ['lg', 'md', 'sm', 'xs', 'xxs'];

    const hasLayouts = breakpoints.some(bp => layouts[bp] && layouts[bp].length > 0);
    console.warn("hasLayouts", layouts);

    if (hasLayouts) {
      const updatedLayouts = breakpoints.reduce((acc, bp) => {
        const bpLayouts = layouts[bp] || [];

        acc[bp] = bpLayouts.map(item => {
          const { elementDetails, ...rest } = item;
          let safeElementDetails = null;

          if (elementDetails) {
            let newElementDetails = { ...elementDetails };

            if (Array.isArray(newElementDetails.items)) {
              newElementDetails.items = newElementDetails.items.map(item2 => {
                let newItem2 = { ...item2 };

                if (
                  newItem2.type === "frame" &&
                  newItem2.special_type &&
                  newItem2.elementDetails?.items
                ) {
                  newItem2 = {
                    ...newItem2,
                    elementDetails: { ...newItem2.elementDetails }
                  };
                  delete newItem2.elementDetails.items;
                }

                return newItem2;
              });
            }

            safeElementDetails = newElementDetails;
          }

          return { ...rest, elementDetails: safeElementDetails };
        });

        return acc;
      }, {});

      console.warn("cleanedLayouts", updatedLayouts);
      localStorage.setItem("layouts", JSON.stringify(updatedLayouts));
    }



  }, [layouts, currentBreakpoint]);

  const [iterate_group_nod_id, Set_itarate_group_no_id] = useState(0)
  const elemPopupPositionHandler = (axis, value) => {
    if (value !== "") {
      const numericValue = Number(value);
      Set_elem_popup((prevItems) => ({
        ...prevItems,
        [axis === "X" ? "left" : "top"]: numericValue,
      }));

      setLayouts((prevLayouts) => {
        const updatedLayouts = { ...prevLayouts };

        const baseElement = updatedLayouts[currentBreakpoint].find(
          (layout) => String(layout.id) === String(elem_popup.id)
        );

        if (!baseElement) return prevLayouts;

        const isX = axis === "X";
        const delta = numericValue - baseElement[isX ? "x" : "y"];

        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((layout) => {
          if (String(layout.id) === String(elem_popup.id)) {
            return {
              ...layout,
              [isX ? "x" : "y"]: numericValue,
              [isX ? "x_percent" : "y_percent"]:
                numericValue /
                (isX
                  ? document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86
                  : document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86),
            };
          }

          if (layout.group_t_id === elem_popup.group_t_id && String(layout.id) !== String(elem_popup.id)) {
            return {
              ...layout,
              [isX ? "x" : "y"]: layout[isX ? "x" : "y"] + delta,
              [isX ? "x_percent" : "y_percent"]:
                (layout[isX ? "x" : "y"] + delta) /
                (isX
                  ? document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86
                  : document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86),
            };
          }


          return layout;
        });

        return updatedLayouts;
      });
    }
  };

  const onBreakpointChange = (breakpoint) => {
    // Geçerli breakpoint'teki layout'u geçici bir değişkende sakla
    // Yeni breakpoint'i ayarla
    setCurrentBreakpoint(breakpoint);
  };

  const onCompactTypeChange = () => {
    setCompactType((oldCompactType) =>
      oldCompactType === "horizontal"
        ? "vertical"
        : oldCompactType === "vertical"
          ? null
          : "horizontal"
    );
  };

  const onResizeTypeChange = () => {
    setResizeHandles((currentHandles) =>
      currentHandles === availableHandles ? ["se"] : availableHandles
    );
  };

  useEffect(() => {
  }, [layouts]);

  const onLayoutChangeHandler = (layout, layouts) => {
    onLayoutChange(layout, layouts);
  };

  const onNewLayout = () => {
    if (currentBreakpoint === "lg") {
      setLayouts((prevLayouts) => {
        return { ...prevLayouts, lg: generateLayout(resizeHandles) };
      });
    } else if (currentBreakpoint === "md") {
      setLayouts((prevLayouts) => {
        return { ...prevLayouts, md: generateLayout(resizeHandles) };
      });
    } else if (currentBreakpoint === "sm") {
      setLayouts((prevLayouts) => {
        return { ...prevLayouts, sm: generateLayout(resizeHandles) };
      });
    } else if (currentBreakpoint === "xs") {
      setLayouts((prevLayouts) => {
        return { ...prevLayouts, xs: generateLayout(resizeHandles) };
      });
    } else if (currentBreakpoint === "xxs") {
      setLayouts((prevLayouts) => {
        return { ...prevLayouts, xxs: generateLayout(resizeHandles) };
      });
    }
  };
  useEffect(() => {
    localStorage.setItem("layouts", JSON.stringify({}))
    const updateLayouts = () => {
      setLayouts((prevLayouts) => {
        const updatedLayouts = { ...prevLayouts };



        // Function to check if all breakpoints have the same layout
        const areAllBreakpointsSame = () => {
          const currentLayoutJSON = JSON.stringify(updatedLayouts[currentBreakpoint]);
          return Object.keys(updatedLayouts).every((breakpoint) =>
            JSON.stringify(updatedLayouts[breakpoint]) === currentLayoutJSON
          );
        };

        // Update all breakpoints if they are not already the same
        if (!areAllBreakpointsSame()) {
          Object.keys(updatedLayouts).forEach((breakpoint) => {
            updatedLayouts[breakpoint] = [...updatedLayouts[currentBreakpoint]];
          });
        }

        return updatedLayouts;
      });
    };
    updateLayouts()
  }, [])
  const [selectedlibrary_number, Set_selected_library_number] = useState(0)


  const onDrop = (elemParams, first, last) => {
    console.log("Last Position:", last);

    let xChange = 0;
    let yChange = 0;
    let group_t_id = null;

    setLayouts((prevLayouts) => {
      const currentItems = prevLayouts[currentBreakpoint];

      // İlk olarak, frame elemanının group_t_id'sini belirle
      currentItems.forEach((layoutItem) => {
        const currentI = layoutItem.i.includes(" ") ? layoutItem.i.split(" ")[0] : layoutItem.i; // Boşluk içeriyorsa boşluktan önceki kısmı al
        const firstI = first.i.includes(" ") ? first.i.split(" ")[0] : first.i; // Boşluk içeriyorsa boşluktan önceki kısmı al

        if (currentI === firstI && layoutItem.type === "frame") {
          group_t_id = layoutItem.group_t_id;
        }
      });

      // Ana eleman için x ve y değişimlerini hesapla
      if (last.x !== first.x || last.y !== first.y) {
        xChange = last.x - first.x;
        yChange = last.y - first.y;
      }

      // Layoutları güncelle
      return {
        ...prevLayouts,
        [currentBreakpoint]: currentItems.map((layoutItem) => {
          const currentI = layoutItem.i.includes(" ") ? layoutItem.i.split(" ")[0] : layoutItem.i; // Boşluk içeriyorsa boşluktan önceki kısmı al
          const firstI = first.i.includes(" ") ? first.i.split(" ")[0] : first.i; // Boşluk içeriyorsa boşluktan önceki kısmı al

          if (currentI === firstI) {
            // Ana elemanın pozisyonunu güncelle
            return {
              ...layoutItem,
              x: Number(last.x.toFixed(4)),
              y: Number(last.y.toFixed(4)),
              x_percent: Number((last.x / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)).toFixed(4)),
              y_percent: Number((last.y / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)).toFixed(4)),
            };
          } else if (group_t_id && layoutItem.group_t_id === group_t_id) {
            // Aynı group_t_id'ye sahip diğer elemanları hareket ettir
            return {
              ...layoutItem,
              x: Number((layoutItem.x + xChange).toFixed(4)),
              y: Number((layoutItem.y + yChange).toFixed(4)),
              x_percent: Number(
                ((layoutItem.x + xChange) / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)).toFixed(4)
              ),
              y_percent: Number(
                ((layoutItem.y + yChange) / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)).toFixed(4)
              ),
            };
          } else {
            // Diğer elemanları olduğu gibi bırak
            return { ...layoutItem };
          }
        }),
      };
    });
  };










  const createWidget = (e) => {
    document.querySelector(".tool_box").classList.toggle("tool_box_active")

    let id_ = e.target.id;
    if (id_ !== "") {
      if (id_ === "text") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "text"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "" },
            type: "text",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "on/off") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "on/off"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "ON" },
            type: "on/off",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "Alarm") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "Alarm"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { seviye: "1" },
            type: "Alarm",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "empty_btn") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "empty_btn"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "" },
            type: "empty_btn",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "selectbox") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "selectbox"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "", text_list: [], value_list: [] },
            type: "selectbox",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "set") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "set"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "", text_list: [], value_list: [] },
            type: "set",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "senaryoSelect") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "senaryoSelect"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "", flow: null },
            type: "senaryoSelect",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "Popup") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "Popup"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "", items: [] },
            type: "Popup",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "frame") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "frame"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 202,
            elementDetails: { borderRadius: "8", borderWidth: "3" },
            type: "frame",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (202 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "calisma_modu") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "calisma_modu"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "SOĞUTMA", value: "1" },
            type: "calisma_modu",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "fan_modu") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "fan_modu"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "DÜŞÜK", value: "1" },
            type: "fan_modu",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "go_page") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "go_page"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "", value: "1" },
            type: "go_page",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "y_g") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "y_g"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { tagId: "" },
            type: "y_g",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "i_g") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "i_g"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "GERİ", value: "1" },
            type: "i_g",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "t_t") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "t_t"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "", tagId: "" },
            type: "t_t",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "tag") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "tag"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { tagId: "" },
            type: "tag",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "left_ok") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "left_ok"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            elementDetails: { color: "aqua" },
            w: 102,
            h: 35,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            type: "left_ok",
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (35 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "right_ok") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "right_ok"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            elementDetails: { color: "aqua" },
            w: 102,
            h: 35,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            type: "right_ok",
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (35 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))

          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "image") {
      } else if (id_ === "bg") {
        var toplam_control = 0;
        render_items[currentBreakpoint].forEach((i) => {
          if (i === "bg") {
            toplam_control++;
          }
        });
        if (toplam_control < 1) {
          Set_render_items((prevLayouts) => {
            return {
              ...prevLayouts,
              [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "bg"],
            };
          });
        }
      } else if (id_ === "gauge") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "gauge"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 70,
            elementDetails: { maxValue: "", pU: "Percent" },
            type: "gauge",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (70 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "trend") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "trend"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 2,
            elementDetails: { tagId: "", tagName: "" },
            type: "trend",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (2 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "gauge_linear") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "gauge_linear"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 70,
            elementDetails: { maxValue: "" },
            type: "gauge_linear",
            h: 55,
            i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (70 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else {
        return 0;
      }
    }
  };

  const createWidget2 = (e) => {
    document.querySelector(".tool_box").classList.toggle("tool_box_active")

    let id_ = e.target.id;
    if (id_ !== "") {
      if (id_ === "text") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "" },
            type: "text",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "i_g") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "i_g"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { text: "GERİ", value: "1" },
            type: "i_g",
            special_type: "popup_elems",
            id2: active_popup_id,

            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "lock") {
        Set_render_items((prevLayouts) => {
          return {
            ...prevLayouts,
            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "lock"],
          };
        });
        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            w: 102,
            elementDetails: { tagId: "" },
            type: "lock",
            special_type: "popup_elems",
            id2: active_popup_id,

            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
            x_percent: (newX / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            y_percent: (newY / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86)),
            w_percent: (102 / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
            h_percent: (55 / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "on/off") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "ON" },
            type: "on/off",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "empty_btn") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "" },
            type: "empty_btn",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "selectbox") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "", text_list: [], value_list: [] },
            type: "selectbox",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "set") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "", flow: null },
            type: "set",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "senaryoSelect") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "", flow: null },
            type: "senaryoSelect",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }

      else if (id_ === "frame") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 202,
            elementDetails: { borderRadius: "8", borderWidth: "3" },
            type: "frame",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "calisma_modu") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "SOĞUTMA", value: "1" },
            type: "calisma_modu",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "fan_modu") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "DÜŞÜK", value: "1" },
            type: "fan_modu",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "y_g") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { tagId: "" },
            type: "y_g",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "i_g") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "GERİ", value: "1" },
            type: "i_g",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "go_page") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "", value: "1" },
            type: "go_page",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "t_t") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { text: "", tagId: "" },
            type: "t_t",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "tag") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 102,
            elementDetails: { tagId: "" },
            type: "tag",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else if (id_ === "left_ok") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            elementDetails: { color: "aqua" },
            w: 102,
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            type: "left_ok",
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "right_ok") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            elementDetails: { color: "aqua" },
            w: 102,
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            type: "right_ok",
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "image") {
      } else if (id_ === "bg") {
        var toplam_control = 0;
        render_items[currentBreakpoint].forEach((i) => {
          if (i === "bg") {
            toplam_control++;
          }
        });
        if (toplam_control < 1) {
          Set_render_items((prevLayouts) => {
            return {
              ...prevLayouts,
              [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "bg"],
            };
          });
        }
      } else if (id_ === "gauge") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 70,
            elementDetails: { maxValue: "" },
            type: "gauge",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "trend") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 2,
            elementDetails: { tagId: "", tagName: "" },
            type: "trend",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      } else if (id_ === "gauge_linear") {

        setLayouts((prevLayouts) => {
          const newX = Math.round(Math.random() * 600);
          const newY = Math.floor(Math.random() * 250);
          const newWidget = {
            x: newX,
            y: newY,
            id: layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
            id2: active_popup_id,
            special_type: "popup_elems",
            w: 2,
            elementDetails: { maxValue: "" },
            type: "gauge_linear",
            h: 55,
            i: String(layouts[currentBreakpoint].filter(item => item.special_type).length + 1500 + top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
          };
          const updatedLayouts = { ...prevLayouts };
          if (Array.isArray(updatedLayouts[currentBreakpoint])) {
            updatedLayouts[currentBreakpoint] = [
              ...updatedLayouts[currentBreakpoint],
              newWidget,
            ];
          } else {
            updatedLayouts[currentBreakpoint] = [newWidget];
          }
          return updatedLayouts;
        });
      }
      else {
        return 0;
      }
    }
  };
  // 🟡 Highlight ekle (frame’in çevresindeki tüm elemanlar)
  const addHighlight = (groupFrameId, realGroupFrameId) => {
    let realGroupFrameId_ = realGroupFrameId !== "" ? realGroupFrameId : ""
    const elements = document.querySelectorAll("[data-template-id]");
    console.warn("ana", groupFrameId, realGroupFrameId, elements)
    elements.forEach(el => {
      const templateId = el.getAttribute("data-template-id");
      if (templateId && templateId.includes(groupFrameId) && !templateId.includes(realGroupFrameId_)) {
        el.style.boxShadow = "0 0 15px 4px rgba(237,188,69,0.9)";
        el.style.transition = "box-shadow 0.2s ease";
      }
    });
  };


  // 🔵 Highlight kaldır
  const removeHighlight = () => {
    const elements = document.querySelectorAll("[data-template-id]");
    elements.forEach(el => {
      el.style.boxShadow = "";
    });
  };

  const handleFrameResizeChange = (key, value) => {
    if (!old_resize_infos_frame) return;

    const v = Number(value);

    setLayouts(prev => {
      const items = prev[currentBreakpoint] || [];
      const frame = items.find(it => it.i === old_resize_infos_frame.id && it.type === "frame");
      if (!frame) return prev;

      // Yeni ölçüler
      const nextW = key === "width" ? v : (new_resize_infos_frame?.width ?? frame.w);
      const nextH = key === "height" ? v : (new_resize_infos_frame?.height ?? frame.h);

      // Oranlar
      const xRatio = nextW / frame.w;
      const yRatio = nextH / frame.h;
      const avgRatio = (xRatio + yRatio) / 2; // y_g için kullanılacak

      // State güncelle
      Set_new_resize_infos_frame({
        width: nextW,
        height: nextH,
        id: frame.i,
        group_t_id: frame.group_t_id,
        group_t_id_frame: frame.group_t_id_frame
      });

      const containerW = document.querySelector("aside")
        ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
        : window.innerWidth * 0.86;

      const containerH = document.querySelector("header")
        ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
        : window.innerHeight - 86;

      return {
        ...prev,
        [currentBreakpoint]: items.map(it => {
          const isFrame = it.i === frame.i;
          const inSameGroup = it.group_t_id === frame.group_t_id;

          const inSameSpecialTypeGroup =
            frame.special_type &&
            it.special_type &&
            frame.id2 &&
            it.id2 &&
            frame.id2 === it.id2;

          // 🔹 Frame'in kendisi
          if (isFrame) {
            return {
              ...it,
              w: nextW,
              h: nextH,
              w_percent: Number((nextW / containerW).toFixed(4)),
              h_percent: Number((nextH / containerH).toFixed(4))
            };
          }

          // 🔹 Aynı group_t_id'ye sahip elemanlar
          if (inSameGroup) {
            const relX = (it.x - frame.x) * xRatio;
            const relY = (it.y - frame.y) * yRatio;
            const x = Number((frame.x + relX).toFixed(4));
            const y = Number((frame.y + relY).toFixed(4));

            // ✨ y_g tipi için özel işlem
            if (it.type === "y_g" && it.elementDetails?.rad) {
              // Normal eleman gibi genişlik/yükseklik oranla çarpılsın
              const w = Number((it.w * xRatio).toFixed(4));
              const h = Number((it.h * yRatio).toFixed(4));

              // Rad = kare olduğu için ortalama boyut alınabilir
              const newRad = Number(((w + h) / 2).toFixed(4));

              return {
                ...it,
                x, y, w, h,
                elementDetails: {
                  ...it.elementDetails,
                  rad: newRad,   // rad senkron kalıyor
                },
                x_percent: Number((x / containerW).toFixed(4)),
                y_percent: Number((y / containerH).toFixed(4)),
                w_percent: Number((w / containerW).toFixed(4)),
                h_percent: Number((h / containerH).toFixed(4))
              };
            }

            // Normal elemanlar için
            const w = Number((it.w * xRatio).toFixed(4));
            const h = Number((it.h * yRatio).toFixed(4));

            return {
              ...it,
              x, y, w, h,
              x_percent: Number((x / containerW).toFixed(4)),
              y_percent: Number((y / containerH).toFixed(4)),
              w_percent: Number((w / containerW).toFixed(4)),
              h_percent: Number((h / containerH).toFixed(4))
            };
          }

          // 🔹 Eğer id2 grubu ise sadece genişlik / yükseklik oranını uygula
          if (inSameSpecialTypeGroup) {
            const relX = (it.x - frame.x) * xRatio;
            const relY = (it.y - frame.y) * yRatio;
            const w = Number((it.w * xRatio).toFixed(4));
            const h = Number((it.h * yRatio).toFixed(4));
            const x = Number((frame.x + relX).toFixed(4));
            const y = Number((frame.y + relY).toFixed(4));

            return {
              ...it,
              x, y, w, h,
              x_percent: Number((x / containerW).toFixed(4)),
              y_percent: Number((y / containerH).toFixed(4)),
              w_percent: Number((w / containerW).toFixed(4)),
              h_percent: Number((h / containerH).toFixed(4))
            };
          }

          // 🔹 Hiçbir gruba girmiyorsa dokunma
          return it;
        })
      };
    });
  };


  const applyResizeToSelectedWidgets = () => {
    console.warn(old_resize_infos_frame)
    if (!old_resize_infos_frame) return;

    const baseW = Number(old_resize_infos_frame.width);
    const baseH = Number(old_resize_infos_frame.height);
    const newW = Number(new_resize_infos_frame.width);
    const newH = Number(new_resize_infos_frame.height);

    const xRatioBase = newW / baseW;
    const yRatioBase = newH / baseH;

    setLayouts(prev => {
      const items = prev[currentBreakpoint] || [];

      const containerW = document.querySelector("aside")
        ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
        : window.innerWidth * 0.86;

      const containerH = document.querySelector("header")
        ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
        : window.innerHeight - 86;

      const updatedItems = [...items];
      console.warn(updatedItems, old_resize_infos_frame)


      // 🔹 BLOK 1: Normal selectedWidgets varsa
      if (selectedWidgetsToResize.length > 0) {
        selectedWidgetsToResize.forEach(selId => {
          const frame = updatedItems.find(
            it => it.group_t_id_frame && it.group_t_id_frame.includes(selId)
          );
          if (!frame) return;

          updatedItems.forEach((it, idx) => {
            const inSameGroup = it.group_t_id === frame.group_t_id;
            const isFrame = it.i === frame.i;
            if (!(inSameGroup || isFrame)) return;

            const relX = (it.x - frame.x) * xRatioBase;
            const relY = (it.y - frame.y) * yRatioBase;
            const w = Number((it.w * xRatioBase).toFixed(4));
            const h = Number((it.h * yRatioBase).toFixed(4));
            const x = Number((frame.x + relX).toFixed(4));
            const y = Number((frame.y + relY).toFixed(4));

            updatedItems[idx] = {
              ...it,
              x, y, w, h,
              x_percent: Number((x / containerW).toFixed(4)),
              y_percent: Number((y / containerH).toFixed(4)),
              w_percent: Number((w / containerW).toFixed(4)),
              h_percent: Number((h / containerH).toFixed(4))
            };
          });
        });
      }

      // 🔹 BLOK 2: Eğer selectedWidgets boş ama special_type + id2 varsa
      else if (old_resize_infos_frame.special_type && old_resize_infos_frame.id2) {
        const frame = updatedItems.find(
          it => it.i === old_resize_infos_frame.id && it.type === "frame"
        ); if (frame) {
          updatedItems.forEach((it, idx) => {
            if (String(it.id2) !== String(frame.id2) || it.i === frame.i) return;

            const relX = (it.x - frame.x) * xRatioBase;
            const relY = (it.y - frame.y) * yRatioBase;
            const w = Number((it.w * xRatioBase).toFixed(4));
            const h = Number((it.h * yRatioBase).toFixed(4));
            const x = Number((frame.x + relX).toFixed(4));
            const y = Number((frame.y + relY).toFixed(4));

            updatedItems[idx] = {
              ...it,
              x, y, w, h,
              x_percent: Number((x / containerW).toFixed(4)),
              y_percent: Number((y / containerH).toFixed(4)),
              w_percent: Number((w / containerW).toFixed(4)),
              h_percent: Number((h / containerH).toFixed(4))
            };
          });
        }
      }

      return {
        ...prev,
        [currentBreakpoint]: updatedItems
      };
    });
  };









  const onResize = (elemParams, first, last) => {
    let newValue = Math.random() * 1000000;
    Set_random_value(newValue.toFixed(0));

    setLayouts(prevLayouts => {
      const currentItems = prevLayouts[currentBreakpoint];
      let group_t_id = null;
      let oldFrame = null;

      // Frame bul
      currentItems.forEach(item => {
        const currentI = item.i.includes(" ") ? item.i.split(" ")[0] : item.i;
        const firstI = first.i.includes(" ") ? first.i.split(" ")[0] : first.i;
        if (currentI === firstI && item.type === "frame") {
          group_t_id = item.group_t_id;
          oldFrame = item;
        }
      });

      // Frame varsa
      if (oldFrame) {
        Set_resize_frame_popupActive(true);

        // popup için eski ve yeni bilgileri ayarla
        Set_old_resize_infos_frame({
          width: oldFrame.w,
          height: oldFrame.h,
          x: oldFrame.x,
          y: oldFrame.y,
          id: oldFrame.i,
          group_t_id: oldFrame.group_t_id || null,
          group_t_id_frame: oldFrame.group_t_id_frame || null,
          special_type: oldFrame.special_type || null,
          id2: oldFrame.id2 || null
        });

        Set_new_resize_infos_frame({
          width: last.w,
          height: last.h,
          id: oldFrame.i,
          group_t_id: oldFrame.group_t_id_frame || null
        });

        const xRatio = last.w / oldFrame.w;
        const yRatio = last.h / oldFrame.h;
        const avgRatio = (xRatio + yRatio) / 2; // yuvarlaklar için kullanılacak
        const newid = oldFrame.group_t_id_frame
          ? oldFrame.group_t_id_frame.match(/frameWidgetId-\d+-/)[0]
          : " ";

        console.warn(newid, oldFrame)

        addHighlight(newid, oldFrame.group_t_id_frame || "");

        return {
          ...prevLayouts,
          [currentBreakpoint]: currentItems.map(item => {
            if (item.type === "y_g") console.warn("yg", item, group_t_id)

            const isFrame = item.i.includes(" ")
              ? item.i.split(" ")[0] === first.i.split(" ")[0]
              : item.i === first.i;

            // 1. Frame'in kendisini güncelle
            if (isFrame) {
              return {
                ...item,
                w: last.w,
                h: last.h,
                w_percent:
                  last.w /
                  (document.querySelector("aside")
                    ? window.innerWidth -
                    document.querySelector("aside").getBoundingClientRect().width
                    : window.innerWidth * 0.86),
                h_percent:
                  last.h /
                  (document.querySelector("header")
                    ? window.innerHeight -
                    document.querySelector("header").getBoundingClientRect().height
                    : window.innerHeight - 86)
              };
            }

            // 2. Eğer frame special_type ise → aynı id2'ye sahip diğer special_type elemanlarını güncelle
            if (
              oldFrame.special_type &&
              item.special_type &&
              item.id2 === oldFrame.id2
            ) {
              const relativeX = (item.x - oldFrame.x) * xRatio;
              const relativeY = (item.y - oldFrame.y) * yRatio;

              // Eğer eleman "y_g" tipindeyse rad değerine göre güncelle
              if (item.type === "y_g" && item.elementDetails?.rad) {
                const newRad = item.elementDetails.rad * avgRatio;

                return {
                  ...item,
                  x: Number((oldFrame.x + relativeX).toFixed(4)),
                  y: Number((oldFrame.y + relativeY).toFixed(4)),
                  w: Number(newRad.toFixed(4)),
                  h: Number(newRad.toFixed(4)),
                  elementDetails: {
                    ...item.elementDetails,
                    rad: Number(newRad.toFixed(4)),
                  },
                  x_percent: Number(
                    (
                      (oldFrame.x + relativeX) /
                      (document.querySelector("aside")
                        ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                        : window.innerWidth * 0.86)
                    ).toFixed(4)
                  ),
                  y_percent: Number(
                    (
                      (oldFrame.y + relativeY) /
                      (document.querySelector("header")
                        ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                        : window.innerHeight - 86)
                    ).toFixed(4)
                  ),
                  w_percent: Number(
                    (
                      newRad /
                      (document.querySelector("aside")
                        ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                        : window.innerWidth * 0.86)
                    ).toFixed(4)
                  ),
                  h_percent: Number(
                    (
                      newRad /
                      (document.querySelector("header")
                        ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                        : window.innerHeight - 86)
                    ).toFixed(4)
                  )
                };
              }

              // Normal elemanlar için eski mantık
              const newW = item.w * xRatio;
              const newH = item.h * yRatio;

              return {
                ...item,
                x: Number((oldFrame.x + relativeX).toFixed(4)),
                y: Number((oldFrame.y + relativeY).toFixed(4)),
                w: Number(newW.toFixed(4)),
                h: Number(newH.toFixed(4)),
                x_percent: Number(
                  (
                    (oldFrame.x + relativeX) /
                    (document.querySelector("aside")
                      ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                      : window.innerWidth * 0.86)
                  ).toFixed(4)
                ),
                y_percent: Number(
                  (
                    (oldFrame.y + relativeY) /
                    (document.querySelector("header")
                      ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                      : window.innerHeight - 86)
                  ).toFixed(4)
                ),
                w_percent: Number(
                  (
                    newW /
                    (document.querySelector("aside")
                      ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                      : window.innerWidth * 0.86)
                  ).toFixed(4)
                ),
                h_percent: Number(
                  (
                    newH /
                    (document.querySelector("header")
                      ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                      : window.innerHeight - 86)
                  ).toFixed(4)
                )
              };
            }


            // 3. Normal group_t_id eşleşenler (eski mantık + y_g için özel durum)
            if (group_t_id && item.group_t_id === group_t_id) {
              const relativeX = (item.x - oldFrame.x) * xRatio;
              const relativeY = (item.y - oldFrame.y) * yRatio;

              // Eğer eleman "y_g" tipindeyse rad değerine göre güncelle
              if (item.type === "y_g" && item.elementDetails?.rad) {
                const newRad = item.elementDetails.rad * avgRatio;

                return {
                  ...item,
                  x: Number((oldFrame.x + relativeX).toFixed(4)),
                  y: Number((oldFrame.y + relativeY).toFixed(4)),
                  w: Number(newRad.toFixed(4)),
                  h: Number(newRad.toFixed(4)),
                  elementDetails: {
                    ...item.elementDetails,
                    rad: Number(newRad.toFixed(4)),
                  },
                  x_percent: Number(
                    (
                      (oldFrame.x + relativeX) /
                      (document.querySelector("aside")
                        ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                        : window.innerWidth * 0.86)
                    ).toFixed(4)
                  ),
                  y_percent: Number(
                    (
                      (oldFrame.y + relativeY) /
                      (document.querySelector("header")
                        ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                        : window.innerHeight - 86)
                    ).toFixed(4)
                  ),
                  w_percent: Number(
                    (
                      newRad /
                      (document.querySelector("aside")
                        ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                        : window.innerWidth * 0.86)
                    ).toFixed(4)
                  ),
                  h_percent: Number(
                    (
                      newRad /
                      (document.querySelector("header")
                        ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                        : window.innerHeight - 86)
                    ).toFixed(4)
                  )
                };
              }

              // Normal elemanlar için eski mantık
              const newW = item.w * xRatio;
              const newH = item.h * yRatio;

              return {
                ...item,
                x: Number((oldFrame.x + relativeX).toFixed(4)),
                y: Number((oldFrame.y + relativeY).toFixed(4)),
                w: Number(newW.toFixed(4)),
                h: Number(newH.toFixed(4)),
                x_percent: Number(
                  (
                    (oldFrame.x + relativeX) /
                    (document.querySelector("aside")
                      ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                      : window.innerWidth * 0.86)
                  ).toFixed(4)
                ),
                y_percent: Number(
                  (
                    (oldFrame.y + relativeY) /
                    (document.querySelector("header")
                      ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                      : window.innerHeight - 86)
                  ).toFixed(4)
                ),
                w_percent: Number(
                  (
                    newW /
                    (document.querySelector("aside")
                      ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width
                      : window.innerWidth * 0.86)
                  ).toFixed(4)
                ),
                h_percent: Number(
                  (
                    newH /
                    (document.querySelector("header")
                      ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height
                      : window.innerHeight - 86)
                  ).toFixed(4)
                )
              };
            }

            return item;
          })
        };
      }

      // Frame yoksa: sadece o elemanı güncelle
      return {
        ...prevLayouts,
        [currentBreakpoint]: currentItems.map(item => {
          if (item.i === first.i) {
            return {
              ...item,
              w: last.w,
              h: last.h,
              w_percent:
                last.w /
                (document.querySelector("aside")
                  ? window.innerWidth -
                  document.querySelector("aside").getBoundingClientRect().width
                  : window.innerWidth * 0.86),
              h_percent:
                last.h /
                (document.querySelector("header")
                  ? window.innerHeight -
                  document.querySelector("header").getBoundingClientRect().height
                  : window.innerHeight - 86)
            };
          }
          return item;
        })
      };
    });
  };







  const closePopUpGauge = () => {
    document
      .querySelector(".gauge_pop_up")
      .classList.toggle("gauge_pop_up_active");
    document.querySelector(".main_sec").classList.toggle("main_sec_dark");
  };

  const open_gauge_poup = () => {
    document
      .querySelector(".gauge_pop_up")
      .classList.toggle("gauge_pop_up_active");
    document.querySelector(".main_sec").classList.toggle("main_sec_dark");
  };


  const [components, setComponents] = useState([]);

  useEffect(() => {
    localStorage.setItem('components-draggable', JSON.stringify([]));


  }, []);

  useEffect(() => {
    // Save components to localStorage whenever components state changes
    localStorage.setItem('components-draggable', JSON.stringify(components));
  }, [components]);
  const refs = useRef([]);

  const handleDrag = (e, data, id) => {
    Set_dragggableActive(true);

    let elementDetails;

    components.forEach(a => {
      if (String(a.id) === String(id)) {
        elementDetails = a.elementDetails
      }
    })

    if (e.target) {
      const selectedDrag = e.target.getBoundingClientRect();
      console.log(selectedDrag);
      let newData = { x: selectedDrag.x, y: selectedDrag.y, w: selectedDrag.width, h: selectedDrag.height, id: id, type: e.target.id, elementDetails: elementDetails }
      console.log(newData);
      Set_dragggableDetail(newData)
    }
  }

  const handleResize = (e, direction, ref, delta, id) => {
    setComponents(prevComponents =>
      prevComponents.map(component =>
        component.id === id
          ? { ...component, width: ref.style.width, height: ref.style.height }
          : component
      )
    );
  };


  const cancelDrag = () => {
    Set_dragggableActive(false)
  }

  const addComponent = (e) => {
    let id_ = e.target.id;
    if (id_ !== "") {
      const commonProperties = {
        id: uuidv4(),
        x: window.innerWidth / 2 - 50,
        y: window.innerHeight / 2 - 50,
        width: 100,
        height: 100,
      };

      let newComponent;

      if (id_ === "text") {
        newComponent = {
          ...commonProperties,
          type: "text",
          elementDetails: { text: "" }
        };
      } else if (id_ === "tag") {
        newComponent = {
          ...commonProperties,
          type: "tag",
          elementDetails: { tagId: "" }
        };
      } else if (id_ === "left_ok") {
        newComponent = {
          ...commonProperties,
          type: "left_ok",
          elementDetails: { color: "aqua" },
          width: 100,
          height: 200,
        };
      } else if (id_ === "right_ok") {
        newComponent = {
          ...commonProperties,
          type: "right_ok",
          elementDetails: { color: "aqua" },
          width: 100,
          height: 200,
        };
      } else if (id_ === "image") {
        newComponent = {
          ...commonProperties,
          type: "image",
          elementDetails: { src: "" }
        };
      } else if (id_ === "gauge") {
        newComponent = {
          ...commonProperties,
          type: "gauge",
          elementDetails: { maxValue: "" }
        };
      }
      setComponents(prevComponents => [...prevComponents, newComponent]);
    }
  };



  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);
      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    document.querySelector("aside").style.minWidth = document.querySelector("aside").getBoundingClientRect().width + "px"
  }, [])


  const onay_okPoup = (e) => {
    if (ok_popup !== null) {
      console.log(ok_popup);

      setLayouts((prevLayouts) => {
        const updatedLayouts = { ...prevLayouts };

        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((widget) => {
            if (String(widget.id) === String(ok_popup.id)) {  // Burada targetId, güncellenecek elemanın id'sidir
              return {
                ...widget,
                x: Number(ok_popup.left),
                y: Number(ok_popup.top),
                w: Number(ok_popup.width),
                h: Number(ok_popup.height),
              };
            }
            return widget;
          });
        }

        return updatedLayouts;
      });

    }
  }

  const bgDrag = (e, data) => {
    console.log(e, data);
  }

  const onay_elemPoup = (e) => {
    if (elem_popup !== null) {
      console.log(elem_popup);

      setLayouts((prevLayouts) => {
        const updatedLayouts = { ...prevLayouts };

        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((widget) => {
            if (String(widget.id) === String(elem_popup.id)) {
              if (widget.type === "y_g") {
                const updatedWidget = {
                  ...widget,


                  borderWidth: elem_popup.borderWidth,


                };
                return updatedWidget;

              } else if (widget.type === "selectbox" || widget.type === "set" || widget.type === "Popup") {
                const updatedWidget = {
                  ...widget,

                  fontSize: Number(elem_popup.fontSize),

                  borderWidth: elem_popup.borderWidth,


                };
                return updatedWidget;

              }
              else {
                const updatedWidget = {
                  ...widget,

                  fontSize: Number(elem_popup.fontSize),
                  borderColor: elem_popup.borderColor,
                  bgColor: elem_popup.bgColor,
                  fontColor: elem_popup.fontColor,
                  borderWidth: elem_popup.borderWidth,


                };
                return updatedWidget;

              }


            }
            return widget;
          });
        }

        return updatedLayouts;
      });
    }
  };

  const [rotate, setRotate] = useState(0); // Açı state'i
  const [isOpeni_g, setIsOpeni_g] = useState(false);
  const [selectedOptioni_g, setSelectedOptioni_g] = useState("GERİ");

  const toggleDropdowni_g = () => setIsOpeni_g(!isOpeni_g);

  const handleOptionClicki_g = (option) => {
    setSelectedOptioni_g(option);
    setIsOpeni_g(false);
  };

  const [currentIndexSelectbox, Set_currentIndexSelectbox] = useState(0)
  const [isOpenselectbox, setIsOpenselectbox] = useState(false);
  const [selectedOptionselectbox, setSelectedOptionselectbox] = useState("");

  const toggleDropdownselectbox = () => setIsOpenselectbox(!isOpenselectbox);

  const handleOptionClickselectbox = (option) => {
    setSelectedOptionselectbox(option);
    setIsOpenselectbox(false);
  };

  const [isOpenselectbox3, setIsOpenselectbox3] = useState(false);
  const [selectedOptionselectbox3, setSelectedOptionselectbox3] = useState("");

  const toggleDropdownselectbox3 = () => setIsOpenselectbox3(!isOpenselectbox3);

  const handleOptionClickselectbox3 = (option) => {
    setSelectedOptionselectbox3(option);
    setIsOpenselectbox3(false);
  };

  const [add_option_text, Set_add_option_text] = useState("")
  const [add_option_value, Set_add_option_value] = useState("")

  const [isOpencalisma, setIsOpencalisma] = useState(false);
  const [selectedOptioncalisma, setSelectedOptioncalisma] = useState("SOĞUTMA");

  const toggleDropdowncalisma = () => setIsOpencalisma(!isOpencalisma);

  const handleOptionClickcalisma = (option) => {
    setSelectedOptioncalisma(option);
    setIsOpencalisma(false);
  };

  const [isOpenlibrary, setIsOpenlibrary] = useState(false);
  const [selectedOptionlibrary, setSelectedOptionlibrary] = useState("");

  const toggleDropdownlibrary = () => setIsOpenlibrary(!isOpenlibrary);

  const handleOptionClicklibrary = (option) => {
    setSelectedOptionlibrary(option);
    setIsOpenlibrary(false);
  };

  const [isOpenfan, setIsOpenfan] = useState(false);
  const [selectedOptionfan, setSelectedOptionfan] = useState("DÜŞÜK");

  const toggleDropdownfan = () => setIsOpenfan(!isOpenfan);

  const handleOptionClickfan = (option) => {
    setSelectedOptionfan(option);
    setIsOpenfan(false);
  };

  const [isOpenİkon, setIsOpenİkon] = useState(false);
  const [selectedOptionİkon, setSelectedOptionİkon] = useState("");

  const toggleDropdownİkon = () => setIsOpenİkon(!isOpenİkon);

  const handleOptionClickİkon = (option) => {
    setSelectedOptionİkon(option);
    setIsOpenİkon(false);
  };

  const [pageId, Set_pageId] = useState(null)
  useEffect(() => {
    if (props.pages.length > 0) {

      let pageName_ = window.location.pathname;
      function normalizeURLPath(path) {
        const turkishMap = {
          'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
          'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
          'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
        };

        return path
          .split('')
          .map(char => turkishMap[char] || char)
          .join('')
          .replace(/\s/g, '_'); // Boşlukları _ ile değiştiriyoruz
      }

      pageName_ = pageName_.substring(pageName_.indexOf("s/") + 2, pageName_.lastIndexOf("/"));
      pageName_ = normalizeURLPath(pageName_);  // pageName_ değerini normalizasyon filtresinden geçiriyoruz

      let icon = props.pages.length > 0
        ? props.pages.filter(x => normalizeURLPath(x.pageName) === pageName_).map(x => x.pageIcon)[0]
        : null;

      console.log(icon);

      let Id = props.pages.length > 0
        ? props.pages.filter(x => normalizeURLPath(x.pageName) === pageName_).map(x => x.pageId)[0]
        : null;

      console.log(Id);

      Set_pageId(Id)
      Set_sayfa_ikonu_son(icon)


      if (icon.startsWith("fa")) {
        handleOptionClickİkon(<i style={{ color: "rgb(67,67,67)", margin: "0 10%" }} className={`${icon}`}></i>)
      } else {
        handleOptionClickİkon(<img src={`${icon}`} />)
      }
    }
  }, [props.pages])




  useEffect(() => {
    console.log(canvas_boyutu);
  }, [canvas_boyutu])
  return (
    <>

      {showPopup_kopyalandi && (
        <div
          style={{
            position: 'fixed',
            left: popupPosition_kopyalandi.x + 'px',
            top: popupPosition_kopyalandi.y + 'px',
            backgroundColor: '#000', // Arka plan rengi
            color: '#fff', // Metin rengi
            padding: '8px 12px',
            borderRadius: '8px',
            opacity: popupOpacity_kopyalandi, // Şeffaflık
            transition: 'opacity 2s ease-out', // Yavaşça kaybolacak
            pointerEvents: 'none', // Pop-up tıklanamaz hale gelir
            zIndex: 9999, // Diğer elemanların üstünde
          }}
        >
          Kopyalandı!
        </div>
      )}

      {resize_frame_popupActive && (
        <div className="resize_frame_popup_overlay">
          <div className="resize_frame_popup">
            <h3 className="popup-title">Resize Frame</h3>
            <div className="resize_frame_content">
              <div className="old_part">
                <p>Previous Width: {old_resize_infos_frame?.width || 0}px</p>
                <p>Previous Height: {old_resize_infos_frame?.height || 0}px</p>
              </div>
              <div className="new_part">
                <div className="input-group">
                  <label htmlFor="new_width">New Width:</label>
                  <input
                    type="number"
                    id="new_width"
                    value={new_resize_infos_frame?.width || 0}
                    onChange={e => handleFrameResizeChange("width", e.target.value)}
                  />
                </div>
                <div className="input-group">
                  <label htmlFor="new_height">New Height:</label>
                  <input
                    type="number"
                    id="new_height"
                    value={new_resize_infos_frame?.height || 0}
                    onChange={e => handleFrameResizeChange("height", e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="popup-buttons">
              <button
                className="close-btn"
                onClick={() => {
                  Set_resize_frame_popupActive(false);
                  Set_new_resize_infos_frame(null);
                  Set_old_resize_infos_frame(null);
                  Set_selectedWidgetsToResize([]);
                  removeHighlight();
                }}
              >
                Close
              </button>
              <button
                className="save-btn"
                onClick={() => {
                  // burada kaydetme aksiyonunuzu ekleyebilirsiniz
                  if (selectedWidgetsToResize.length > 0) {
                    applyResizeToSelectedWidgets(); // diğer seçili widget’lara uygula

                  }

                  Set_resize_frame_popupActive(false);
                  Set_new_resize_infos_frame(null);
                  Set_old_resize_infos_frame(null);
                  Set_selectedWidgetsToResize([]);
                  removeHighlight();
                }}
              >
                {selectedWidgetsToResize.length > 0 ? "Apply to Selected Widgets" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}


      {showPopupCopyPage && (<div className={`page_copied_popup ${fadeOut ? "fade-out" : ""}`}>


        <p style={{ textAlign: "center" }}>Sayfa Kopyalandı</p>

      </div>

      )}
      <div className="export_loading">
        <img style={{ width: "40%", position: "relative", left: "30%" }} src={loading_} alt="" />
        <p style={{ textAlign: "center" }}>Sayfa Kaydediliyor. Lütfen Bekleyiniz...</p>

      </div>

      {/* {showColorPicker && (
        <div className="color-picker-popup">
          <h3>Bir Arka Plan Rengi Seçin</h3>
          <div className="color-options">
            {colors.map((color) => (
              <div
                key={color.name}
                className="color-option"
                style={{
                  backgroundColor: color.color,
                  border: selectedColor === color.color ? "3px solid #000" : "1px solid #ccc",
                }}
                onClick={() => handleColorSelection(color.color)}
              />
            ))}
          </div>
          <button onClick={() => setShowColorPicker(false)}>Renk Seç</button>
        </div>
      )} */}

      <div style={{ maxHeight: "100vh", height: Number(canvas_boyutu.height).toFixed(5) + "px", width: Number(canvas_boyutu.width).toFixed(5) + "px" }} onClick={() => {
      }} className="maiN_main-sec" ref={mainRef}>
        {bigger_trend_active && <div className="bigger_trend_pop_up_active">
          <i onClick={(e) => {
            Set_bigger_trend_active(false)
            Set_bigger_trend_id(null)
          }} id="close-full-s-trend" className="fa fa-times"></i>
          <div style={{ border: "none" }} className="bottom_sec trend_graph">
            <Line options={createChartOptions(String(bigger_trend_id))} data={createChartData(String(bigger_trend_id))} />
          </div>
        </div>}
        <div className="show_pop_up show_external_trend">
          <i
            onClick={close_pop_up}
            style={{ position: "relative", left: "50%" }}
            className="fa fa-times close_tag_pop_up"
          ></i>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              width: "100%",
            }}
            className="top_flex"
          >
            <p>
              {" "}
              TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
            </p>
            <p>
              {" "}
              TagName:{" "}
              <span className="pop_up_x pop_up_external show_tagName"></span>
            </p>
          </div>
          <div className="btn_area_popup_external">
            <button
              onClick={(e) => {
                day_trend(e);
              }}
            >
              Günlük Trend <i className="fa-solid fa-chart-line"></i>
            </button>
            <button
              onClick={(e) => {
                month_trend(e);
              }}
            >
              Aylık Trend <i className="fa-solid fa-chart-line"></i>
            </button>
          </div>
        </div>

        {bg_control &&
          <div id="bg_control_section" style={{
            border: "6px solid rgb(50,50,50)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: canvas_boyutu.width ? canvas_boyutu.width + "px" : "100%",
            height: canvas_boyutu.height ? canvas_boyutu.height + "px" : "100vh",
            paddingTop: "100px"
          }} className="main_sec">

            <Draggable onStop={(e, data) => {
              console.log(e, data);
            }} style={{ marginTop: "100px" }}>
              <Resizable>
                <div>
                  <img
                    ref={bgRef}
                    key={bg_key_current.key}
                    style={{ width: "100%", height: "100%", border: "1.5px solid rgb(30,30,30)" }}
                    className="xIMG_bg_resizable"
                    src={bg_key_current.elementDetails.src !== "" ? bg_key_current.elementDetails.src : ""}
                    alt=""
                  />
                </div>
              </Resizable>
            </Draggable>

            <div className="btn_group_bg_selection">
              <button onClick={() => {
                let img_tag = document.querySelector(".xIMG_bg_resizable");
                let w_ = img_tag.offsetWidth;
                let h_ = img_tag.offsetHeight;
                const bgElement = bgRef.current;

                if (bgElement !== null) {
                  // Parent elementin konumunu al
                  const parentRect = document.querySelector("#bg_control_section").getBoundingClientRect();
                  // Resmin konumunu al
                  const imgRect = img_tag.getBoundingClientRect();

                  const imgLeft = imgRect.left - parentRect.left;
                  const imgTop = imgRect.top - parentRect.top;

                  console.log(imgLeft, imgTop, imgRect, parentRect)

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = {};

                    Object.keys(prevLayouts).forEach((breakpoint) => {
                      if (breakpoint !== "canvas_boyutu") {
                        const currentLayout = prevLayouts[breakpoint] || [];
                        let bgExists = false;
                        let screenWidth = window.innerWidth;
                        let screenHeight = window.innerHeight;

                        console.log("typeof", typeof (currentLayout), currentLayout);

                        if (currentLayout.length >= 0) {

                          const updatedLayout = currentLayout.map((widget) => {
                            if (widget.type === "bg") {
                              bgExists = true;
                              return {
                                ...widget,
                                elementDetails: {
                                  ...widget.elementDetails,
                                  src: bg_item,
                                  width: w_,
                                  height: h_,
                                  left: imgLeft,
                                  top: imgTop,
                                  initalWidth: screenWidth,
                                  initalHeight: screenHeight,
                                },
                              };
                            }
                            return widget;

                          });

                          console.log(updatedLayout, "updatedlayout");

                          if (!bgExists) {
                            const newX = Math.round(Math.random() * 5) * 2;
                            const newY = Math.floor(12 / 6) * 2;
                            const newWidget = {
                              x: newX,
                              id: render_items[breakpoint].length,
                              y: newY,
                              elementDetails: {
                                src: bg_item,
                                width: w_,
                                height: h_,
                                left: imgLeft,
                                top: imgTop,
                                initalWidth: screenWidth,
                                initalHeight: screenHeight,
                              },
                              w: 70,
                              h: 1,
                              i: String(render_items[breakpoint].length),
                              static: Math.random() < 0.05,
                              resizeHandles: resizeHandles,
                              type: "bg",
                            };
                            updatedLayout.push(newWidget);
                          }
                          updatedLayouts[breakpoint] = updatedLayout;


                        }

                      }
                    });




                    return {
                      ...prevLayouts,
                      ...updatedLayouts,
                    };
                  });

                  Set_bg_control(false);
                  Set_bg_item("");
                  Set_bg_key_current("");
                }
              }}>Kaydet</button>

              <button onClick={() => {
                Set_bg_control(false);
                Set_bg_item("");
                Set_bg_key_current("");
              }}>İptal</button>
            </div>
          </div>

        }
        <div className="change_color">
          <ul>
            <li onClick={(e) => {
              let parent = e.target.parentElement.parentElement;
              let id_ = parent.id;

              setLayouts(prevLayouts => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(item => {
                  if (String(item.id) === id_) {
                    return {
                      ...item,
                      elementDetails: {
                        ...item.elementDetails,
                        color: "red",
                      },
                    };
                  }
                  return item;
                });
                return updatedLayouts;
              });

            }}>Kırmızı <input type="text" disabled={true} style={{ border: "none", backgroundColor: "red", width: "12px", height: "12px", borderRadius: "12px" }} /></li>
            <li onClick={(e) => {
              let parent = e.target.parentElement.parentElement;
              let id_ = parent.id;

              setLayouts(prevLayouts => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(item => {
                  if (String(item.id) === id_) {
                    return {
                      ...item,
                      elementDetails: {
                        ...item.elementDetails,
                        color: "aqua",
                      },
                    };
                  }
                  return item;
                });
                return updatedLayouts;
              });

            }}> Mavi <input type="text" disabled={true} style={{ border: "none", backgroundColor: "aqua", width: "12px", height: "12px", borderRadius: "12px" }} /></li>
            <li onClick={(e) => {
              let parent = e.target.parentElement.parentElement;
              let id_ = parent.id;

              setLayouts(prevLayouts => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(item => {
                  if (String(item.id) === id_) {
                    return {
                      ...item,
                      elementDetails: {
                        ...item.elementDetails,
                        color: "rgb(237,188,69)",
                      },
                    };
                  }
                  return item;
                });
                return updatedLayouts;
              });

            }}> Sarı <input type="text" disabled={true} style={{ border: "none", backgroundColor: "rgb(237,188,69)", width: "12px", height: "12px", borderRadius: "12px" }} /></li>
            <li onClick={(e) => {
              let parent = e.target.parentElement.parentElement;
              let id_ = parent.id;

              setLayouts(prevLayouts => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(item => {
                  if (String(item.id) === id_) {
                    return {
                      ...item,
                      elementDetails: {
                        ...item.elementDetails,
                        color: "rgb(12,12,12)",
                      },
                    };
                  }
                  return item;
                });
                return updatedLayouts;
              });
            }}> Siyah <input type="text" disabled={true} style={{ border: "none", backgroundColor: "rgb(12,12,12)", width: "12px", height: "12px", borderRadius: "12px" }} /></li>
          </ul>
          <input
            type="range"
            max={360}
            min={0}
            value={rotate}
            onChange={(e) => {

              setRotate(e.target.value)

              let parent = e.target.parentElement;
              let id_ = parent.id;

              setLayouts(prevLayouts => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(item => {
                  if (String(item.id) === id_) {
                    return {
                      ...item,
                      elementDetails: {
                        ...item.elementDetails,
                        rotate_deg: e.target.value
                      },
                    };
                  }
                  return item;
                });
                return updatedLayouts;
              });

            }}
            style={{ width: '100px', marginBottom: '10px' }}
          />
          {ok_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(ok_popup);
                if (e.target.value !== "") Set_ok_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }));
              }} value={String(ok_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_ok_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }));
              }} value={String(ok_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {ok_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_ok_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }));
              }} value={String(ok_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_ok_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }));
              }} type="number" value={String(ok_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".change_color").classList.toggle("change_color_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => { onay_okPoup(e) }}>Kaydet</button><button onClick={() => {
              document.querySelector(".change_color").classList.toggle("change_color_active")
              Set_ok_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties   Popup-empty_btn changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Empty Btn Popup</div>
          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}

          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}





          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}



          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}

          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-empty_btn").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-empty_btn").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-empty_btn").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-onOff changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>ON-OFF Popup</div>

          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}
          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="set_on_off_deger">
            <h5>Çalışma Durumu</h5>
            <button onClick={(e) => {
              setLayouts((prevLayouts) => {

                const updatedLayouts = { ...prevLayouts };

                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                  if (String(layout.id) === String(elem_popup.id)) {
                    e.target.textContent = layout.elementDetails.text === "ON" ? "OFF" : "ON"

                    return {
                      ...layout,
                      elementDetails: {
                        ...layout.elementDetails,
                        text: layout.elementDetails.text === "ON" ? "OFF" : "ON"
                      }
                    };
                  }
                  return layout;
                });
                return updatedLayouts;
              });

            }}>{elem_popup.value}</button>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}

          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // `tip` değerini belirle

                            if (layout.elementDetails.text === "ON") {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  tagId: e.target.id,
                                  tip: tagType // `tagId` güncellendiğinde `tip` ekleniyor
                                }
                              };
                            } else {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  tagId2: e.target.id,
                                  tip: tagType // `tagId2` güncellendiğinde `tip2` ekleniyor
                                }
                              };
                            }
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>

          {elem_popup !== null && <div className="add_option">
            <h5>Set value of option</h5>

            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>
              <input type="text" value={add_option_value} onChange={(e) => { Set_add_option_value(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };
                    const targetId = elem_popup.id;
                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(targetId)) {
                        if (layout.elementDetails.text === "ON") {
                          return {
                            ...layout,
                            elementDetails: {
                              ...layout.elementDetails,
                              value1: add_option_value
                            }
                          };
                        } else {
                          return {
                            ...layout,
                            elementDetails: {
                              ...layout.elementDetails,
                              value2: add_option_value
                            }
                          };
                        }

                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_option_value("")

                }}

                className="fa fa-plus"></i>
            </div>


          </div>}




          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Tag Popup</div>

          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}
          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Decimal</label>
              <input min={0} onChange={(e) => {
                const value = parseFloat(e.target.value); // Girilen değeri sayıya çeviriyoruz.

                if (!isNaN(value) && value >= 0) { // Sadece geçerli sayıları ve 0 veya üstünü kabul ediyoruz.
                  Set_elem_popup((prevItems) => ({
                    ...prevItems,
                    decimal: value
                  }));

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };
                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            decimal: value
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                } else {
                  // Eğer değer geçersizse, kullanıcıya bir uyarı göstermek isterseniz burada bir işlem yapabilirsiniz.
                  console.log("Decimal değeri 0'dan küçük olamaz!");
                }
              }} value={String(elem_popup.decimal ? elem_popup.decimal : 0)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}
          {elem_popup !== null && <div className="mode">

            <h5>Unit</h5>

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownUnit}>
                {selectedOptionUnit}
                <span className={`arrow ${isOpenUnit ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenUnit && (
                <ul className="select-box-dropdown">
                  {["None", "°C", "kWh", "m³", "m³/h", ...elem_popup.unit_list].map((option, index) => (
                    <li

                      id={index + 1}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  unit: option
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });


                        handleOptionClickUnit(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>}

          {elem_popup !== null && <div className="add_option">
            <h5>Add unit</h5>

            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>
              <input type="text" value={add_unit} onChange={(e) => { Set_add_unit(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  Set_elem_popup((prevItems) => {
                    const updatedList = prevItems.unit_list
                      ? [...prevItems.unit_list, add_unit]
                      : [add_unit];
                    return {
                      ...prevItems,
                      unit_list: updatedList,
                    };
                  });


                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };
                    const targetId = elem_popup.id;
                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(targetId)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            unit_list: layout.elementDetails.unit_list ? [...layout.elementDetails.unit_list, add_unit] : [add_unit]
                          }
                        };


                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_unit("")

                }}

                className="fa fa-plus"></i>
            </div>


          </div>}

          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        borderWidth: e.target.value

                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        borderRadius: e.target.value

                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-text changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Text Popup</div>

          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}


          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}




          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        borderWidth: e.target.value

                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        borderRadius: e.target.value

                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-text").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-text").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-text").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-fan changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Fan Popup</div>

          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}
          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}




          {elem_popup !== null && <div className="mode">

            <h5>Mod</h5>

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownfan}>
                {selectedOptionfan}
                <span className={`arrow ${isOpenfan ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenfan && (
                <ul className="select-box-dropdown">
                  {["DÜŞÜK", "YÜKSEK", "MID 1", "MID 2", "AUTO"].map((option, index) => (
                    <li
                      id={index + 1}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  text: option,
                                  value: index + 1
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });

                        handleOptionClickfan(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>}


          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-senaryo changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Senaryo Popup</div>

          {elem_popup !== null && (
            <>
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "Yeşil", color: "#008000" },
                  { name: "Açık Gri", color: "#EDEDED" }
                ].map(({ name, color }) => (
                  <div
                    key={color}
                    onClick={() => {
                      Set_elem_popup((PrevItems) => ({
                        ...PrevItems,
                        borderColor: color
                      }));
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: color,
                      border: "1px solid black",
                      borderRadius: "50%",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  />
                ))}
              </div>
            </>
          )}



          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>


            </>
          )}




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}




          {elem_popup !== null && <div className="mode">

            <h5>Senaryo</h5>

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownSenaryo}>
                {selectedOptionSenaryo}
                <span className={`arrow ${isOpenSenaryo ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenSenaryo && (
                <ul className="select-box-dropdown">
                  {props.flowList.map((option, index) => (
                    <li
                      id={index + 1}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  text: option.senaryoAdi,
                                  flow: option
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });

                        handleOptionClickSenaryo(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>}


          {/* <div className="select_tag_popup_dyn">
<input
type="text"
className="searchInputclass"
id="searchInput"
placeholder="Tag ismine göre ara..."
value={searchTerm}
onChange={handleSearch}
/>
<div className="tag-list-dyn">
{filteredTags.map((tag, index) => (
<div onClick={(e) => {

var id__ = e.target.parentElement.parentElement.parentElement.id;


if (id__) {
console.log(id__)
if (!ws_active) {
setLayouts((prevLayouts) => {
const updatedLayouts = { ...prevLayouts };
const targetId = id__;
updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
if (String(layout.id) === targetId) {
return {
...layout,
elementDetails: {
  ...layout.elementDetails,
  tagId: e.target.id
}
};
}
return layout;
});
return updatedLayouts;
});
}

document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
setSearchTerm("")
}

}} className="tag-dyn" id={tag.tagId} key={index}>
{tag.tagName}
</div>
))}
</div>
</div> */
          }



          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}
          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-senaryo").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-senaryo").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-senaryo").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-calisma changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Çalışma Popup</div>


          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}

          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}

          {elem_popup !== null && <div className="mode">

            <h5>Mod</h5>

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdowncalisma}>
                {selectedOptioncalisma}
                <span className={`arrow ${isOpencalisma ? 'open' : ''}`}>▼</span>
              </div>
              {isOpencalisma && (
                <ul className="select-box-dropdown">
                  {["SOĞUTMA", "ISITMA", "FAN", "AUTO", "NEM ALMA", "SETBACK"].map((option, index) => (
                    <li

                      id={index + 1}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  text: option,
                                  value: index + 1
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });


                        handleOptionClickcalisma(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>}



          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-gauge changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Gauge Popup</div>


          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}

          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}


          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          <div style={{ width: "100%" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginLeft: "4px" }}>Select Unit or Percent</p>
            <button style={{ width: "25%" }} id="reverse_color_btn" onClick={(e) => {
              let value = e.target.textContent === "Percent" ? "Unit" : "Percent";
              e.target.textContent = value;
              if (value === "Unit") {
                Set_gauge_unit_control(true)
              } else {
                Set_gauge_unit_control(false)
              }
              setLayouts((prevLayouts) => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                  if (String(layout.id) === String(elem_popup.id)) {
                    return {
                      ...layout,
                      elementDetails: {
                        ...layout.elementDetails,
                        pU: value
                      }
                    };
                  }
                  return layout;
                });
                return updatedLayouts;
              });

            }}>Percent</button>
          </div>

          {gauge_unit_control && (
            <div className="gauge_unit_add">
              <div className="input_group_add_gauge_unit">
                <input type="number" placeholder="add limit number" />
                <i
                  onClick={(e) => {
                    if (e.target.parentElement.firstElementChild.value !== "") {
                      try {
                        const newValue = e.target.parentElement.firstElementChild.value;
                        Set_gauge_limit_values((prevValues) => [
                          ...prevValues,
                          { value: newValue, color: "" },
                        ]);

                        // Eğer layouts state'ini de güncellemeniz gerekiyorsa:
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };
                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((layout) => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  limitValues: layout.elementDetails.limitValues ? [
                                    ...layout.elementDetails.limitValues,
                                    { value: newValue, color: "" },
                                  ] : [{ value: newValue, color: "" }],
                                },
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });
                      } catch (err) {
                        console.log(err);
                      } finally {
                        e.target.parentElement.firstElementChild.value = "";
                      }
                    }
                  }}
                  className="fa fa-plus"
                ></i>
              </div>

              <ul className="add_unit_gauge_list">
                {gauge_unit_limit_values
                  .sort((a, b) => a.value - b.value)
                  .map((item, index) => (
                    <li key={index}>
                      {item.value}
                      <div className="color_group">
                        {[
                          { name: "Yeşil", color: "#008000" },
                          { name: "TURUNCU", color: "#F58B19" },
                          { name: "KIRMIZI", color: "#ff0000" },
                        ].map(({ name, color }) => (
                          <div
                            key={color}
                            onClick={() => {
                              Set_gauge_limit_values((prevValues) =>
                                prevValues.map((i) =>
                                  String(i.value) === String(item.value) ? { ...i, color: color } : i
                                )
                              );

                              setLayouts((prevLayouts) => {
                                const updatedLayouts = { ...prevLayouts };
                                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((layout) => {
                                  if (String(layout.id) === String(elem_popup.id)) {
                                    return {
                                      ...layout,
                                      elementDetails: {
                                        ...layout.elementDetails,
                                        limitValues: layout.elementDetails.limitValues.map((i) =>
                                          String(i.value) === String(item.value) ? { ...i, color: color } : i
                                        ),
                                      },
                                    };
                                  }
                                  return layout;
                                });
                                return updatedLayouts;
                              });
                            }}
                            title={name}
                            style={{
                              width: "40px",
                              height: "40px",
                              backgroundColor: color,
                              border: "1px solid black",
                              borderRadius: "50%",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                            }}
                          />
                        ))}
                      </div>
                      <i
                        onClick={() => {
                          Set_gauge_limit_values((prevValues) =>
                            prevValues.filter((i) => String(i.value) !== String(item.value))
                          );

                          setLayouts((prevLayouts) => {
                            const updatedLayouts = { ...prevLayouts };
                            updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((layout) => {
                              if (String(layout.id) === String(elem_popup.id)) {
                                return {
                                  ...layout,
                                  elementDetails: {
                                    ...layout.elementDetails,
                                    limitValues: layout.elementDetails.limitValues.filter(
                                      (i) => String(i.value) !== String(item.value)
                                    ),
                                  },
                                };
                              }
                              return layout;
                            });
                            return updatedLayouts;
                          });
                        }}
                        className="fa fa-times"
                      ></i>
                    </li>
                  ))}
              </ul>
            </div>
          )}

          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Start Value</label>
              <input min={0} onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {

                  Set_elem_popup((prevItems) => ({ ...prevItems, startValue: Number(e.target.value) }))


                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            startValue: Number(e.target.value),

                          }
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.startValue ? elem_popup.startValue : 0)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">End Value</label>
              <input min={0} onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, endValue: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            endValue: Number(e.target.value),

                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.endValue ? elem_popup.endValue : 0)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}




          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          <div style={{ width: "100%" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginLeft: "4px" }}>Reverse Colors</p>
            <button id="reverse_color_btn" onClick={(e) => {
              let value = e.target.textContent === "1" ? "-1" : "1";
              e.target.textContent = value;
              setLayouts((prevLayouts) => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                  if (String(layout.id) === String(elem_popup.id)) {
                    return {
                      ...layout,
                      elementDetails: {
                        ...layout.elementDetails,
                        scaleX: value
                      }
                    };
                  }
                  return layout;
                });
                return updatedLayouts;
              });

            }}>1</button>
          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-gauge").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
              Set_gauge_unit_control(false)
              Set_gauge_limit_values([])
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-gauge").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
              Set_gauge_unit_control(false)
              Set_gauge_limit_values([])
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-lock changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Lock Icon Popup</div>

          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}






          {elem_popup !== null && (
            <>
              <p>Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "Yeşil", color: "#008000" },
                  { name: "Açık Gri", color: "#EDEDED" }

                ].map(({ name, color }) => (
                  <div
                    key={color}
                    onClick={() => {
                      Set_elem_popup((PrevItems) => ({
                        ...PrevItems,
                        fontColor: color
                      }));
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: color,
                      border: "1px solid black",
                      borderRadius: "50%",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  />
                ))}
              </div>
            </>
          )}



          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}







          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // `tip` değerini belirle

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // `tagId` güncellendiğinde `tip` ekleniyor
                              }
                            };

                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>

          <h3>Etkilenecek Tag</h3>


          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm2}
              onChange={handleSearch2}
            />
            <div className="tag-list-dyn">
              {filteredTags2.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // `tip` değerini belirle

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagIdEx: e.target.id,
                              }
                            };

                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm2(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>








          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-lock").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-lock").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-lock").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-gauge-linear changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Gauge-Linear Popup</div>


          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}
          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>


            </>
          )}



          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          <div style={{ width: "100%" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginLeft: "4px" }}>Select Unit or Percent</p>
            <button style={{ width: "25%" }} id="reverse_color_btn" onClick={(e) => {
              let value = e.target.textContent === "Percent" ? "Unit" : "Percent";
              e.target.textContent = value;
              setLayouts((prevLayouts) => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                  if (String(layout.id) === String(elem_popup.id)) {
                    return {
                      ...layout,
                      elementDetails: {
                        ...layout.elementDetails,
                        pU: value
                      }
                    };
                  }
                  return layout;
                });
                return updatedLayouts;
              });

            }}>Percent</button>
          </div>

          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Start Value</label>
              <input min={0} onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {

                  Set_elem_popup((prevItems) => ({ ...prevItems, startValue: Number(e.target.value) }))


                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            startValue: Number(e.target.value),

                          }
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.startValue ? elem_popup.startValue : 0)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">End Value</label>
              <input min={0} onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, endValue: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            endValue: Number(e.target.value),

                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.endValue ? elem_popup.endValue : 0)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="max-value">Alarm Value</label>
              <input onChange={(e) => {
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          alarmValue: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}


          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          <div style={{ width: "100%" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginLeft: "4px" }}>Reverse Colors</p>
            <button id="reverse_color_btn" onClick={(e) => {
              let value = e.target.textContent === "1" ? "-1" : "1";
              e.target.textContent = value;
              setLayouts((prevLayouts) => {
                const updatedLayouts = { ...prevLayouts };
                updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                  if (String(layout.id) === String(elem_popup.id)) {
                    return {
                      ...layout,
                      elementDetails: {
                        ...layout.elementDetails,
                        scaleX: value
                      }
                    };
                  }
                  return layout;
                });
                return updatedLayouts;
              });

            }}>1</button>
          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-gauge-linear").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-gauge-linear").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-trend changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Trend Popup</div>


          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}


          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    fetchTag(tag.tagId, props.totalizer_tags.some(tag2 => tag.tagId === tag2.tagId) ? "1" : " 0", "0", id__)

                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                    document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")

                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>
          </div>

          {elem_popup !== null && elem_popup.tagId !== "" && <div className="deleteElem full-screen-trend">
            <button onClick={(e) => {
              Set_bigger_trend_active(true)
              Set_bigger_trend_id(elem_popup.id)
              document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")

            }}>Full Ekran</button>

          </div>}

          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}


          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup_y_g changePoup">



          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Çap</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, rad: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86)),
                          elementDetails: {
                            ...layout.elementDetails,
                            rad: Number(e.target.value)
                          }
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.rad)} type="number" className="adjust_width_pop_up" />
            </div>


          </div>}

          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5 style={{ marginTop: "16px" }}>Circle x Square</h5>
            <div style={{ justifyContent: "space-around" }} className="opu">
              <p>Circle</p>
              <p>Square</p>
            </div>
            <div className="opu">


              <input
                className="rkjg-c"
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) { // Checkbox işaretlenmişse
                    document.querySelector(".rkjg-s").checked = false;

                    Set_elem_popup((prevItems) => ({
                      ...prevItems,
                      tur: "circle"
                    }));

                    setLayouts((prevLayouts) => {
                      const updatedLayouts = { ...prevLayouts };
                      updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                        if (String(layout.id) === String(elem_popup.id)) {
                          return {
                            ...layout,
                            elementDetails: {
                              ...layout.elementDetails,
                              tur: "circle"
                            }
                          };
                        }
                        return layout;
                      });
                      return updatedLayouts;
                    });
                  }
                }}
              />

              <input className="rkjg-s" type="checkbox" onChange={(e) => {
                if (e.target.checked) {
                  Set_elem_popup((prevItems) => ({ ...prevItems, tur: "square" }));

                  document.querySelector(".rkjg-c").checked = false

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };
                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            tur: "square"
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} />
            </div>
          </div>}



          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}







          {elem_popup !== null && <div className="add_option">
            <h5>Set value of option</h5>

            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>
              <input type="text" value={add_option_value} onChange={(e) => { Set_add_option_value(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  Set_elem_popup((prevItems) => {
                    const updatedValueList = prevItems.value_list
                      ? [...prevItems.value_list, add_option_value]
                      : [add_option_value];

                    return { ...prevItems, value_list: updatedValueList };
                  });

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            value_list: layout.elementDetails.value_list ? [...layout.elementDetails.value_list, add_option_value] : [add_option_value]
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_option_value("")

                }}

                className="fa fa-plus"></i>
            </div>


          </div>}

          {elem_popup !== null && (
            <>
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "Yeşil", color: "#008000" },
                  { name: "Açık Gri", color: "#EDEDED" }
                ].map(({ name, color }) => (
                  <div
                    key={color}
                    onClick={() => {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            console.warn("currentIndex", currentIndexYG, color)

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                border_list: selectedOptionyg === "" || selectedOptionyg === "Add"
                                  ? [...(layout.elementDetails.border_list || []), color]
                                  : layout.elementDetails.border_list.map((item, index) =>
                                    index === currentIndexYG ? color : item
                                  )
                              }
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });

                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: color,
                      border: "1px solid black",
                      borderRadius: "50%",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  />
                ))}
              </div>
            </>
          )}



          {elem_popup !== null && (
            <>
              <p>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "Yeşil", color: "#008000" },
                  { name: "Açık Gri", color: "#EDEDED" }
                ].map(({ name, color }) => (
                  <div
                    key={color}
                    onClick={() => {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            console.warn("currentIndex", currentIndexYG, color)

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                bg_list: selectedOptionyg === "" || selectedOptionyg === "Add"
                                  ? [...(layout.elementDetails.bg_list || []), color]
                                  : layout.elementDetails.bg_list.map((item, index) =>
                                    index === currentIndexYG ? color : item
                                  )
                              }
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });

                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: color,
                      border: "1px solid black",
                      borderRadius: "50%",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  />
                ))}
              </div>
            </>
          )}



          {elem_popup !== null && <div style={{ marginBottom: "16px", marginTop: "12px" }} className="mode">

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownyg}>
                {selectedOptionyg}
                <span className={`arrow ${isOpenyg ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenyg && (
                <ul className="select-box-dropdown">
                  {["Add", ...elem_popup.value_list].map((option, index) => {
                    console.log(option, elem_popup.text_list);
                    return <li

                      id={elem_popup.value_list.length > 0 && elem_popup.value_list[index]}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id) && option !== "Add") {
                              Set_currentIndexYG(index - 1)
                              return {
                                ...layout,
                                bgColor: layout.elementDetails.bg_list ? layout.elementDetails.bg_list[index - 1] : "transparent",
                                borderColor: layout.elementDetails.border_list ? layout.elementDetails.border_list[index - 1] : "black",
                                fontColor: layout.elementDetails.font_list ? layout.elementDetails.font_list[index - 1] : "black",
                                elementDetails: {
                                  ...layout.elementDetails,
                                  value: option,

                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });


                        handleOptionClickyg(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  })}
                </ul>
              )}
            </div>

          </div>}



          <div className="select_tag_popup_dyn" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginRight: "80%" }}>Get Tag</p>
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.warn(elem_popup); if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>
          </div>



          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}




          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup_y_g").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup_y_g").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
              setSelectedOptionyg("")
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup_y_g").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
              setSelectedOptionyg("")

            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-frame changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Çerçeve Popup</div>

          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}



          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input
                onChange={(e) => { elemPopupPositionHandler("X", e.target.value) }}
                value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input
                onChange={(e) => { elemPopupPositionHandler("Y", e.target.value) }}

                type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />


          </div>}



          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-frame").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          {elem_popup !== null && elem_popup.group_t_id && elem_popup.group_t_id !== null && <div className="deleteElem">
            <button onClick={(e) => {
              widget_delete(e.target.parentElement.parentElement.id); document.querySelector(".Popup-frame").classList.toggle("changeProperties_active")
            }}>Widget Sil</button>
          </div>
          }

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-frame").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-frame").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup_Alarm changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Alarm Popup</div>


          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}


          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}

          {elem_popup !== null && <div className="select_seviye_main">
            <p>Seviye Seç</p>
            <div className="select_seviye">
              <div style={{ backgroundColor: elem_popup.seviye === "1" ? "rgb(237,188,69)" : "transparent" }} onClick={(e) => {
                document.querySelectorAll(".seviye_box").forEach(x => {
                  if (x.classList.contains("seviye_box_selected")) x.classList.remove("seviye_box_selected")
                })

                e.target.classList.toggle("seviye_box_selected");

                Set_elem_popup((prevItems) => ({ ...prevItems, seviye: String(e.target.textContent) }))

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          seviye: String(e.target.textContent)
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });


              }} className={elem_popup.seviye === "1" ? "seviye_box seviye_box_selected" : "seviye_box"}>1</div>
              <div style={{ backgroundColor: elem_popup.seviye === "2" ? "rgb(237,188,69)" : "transparent" }} onClick={(e) => {
                document.querySelectorAll(".seviye_box").forEach(x => {
                  if (x.classList.contains("seviye_box_selected")) x.classList.remove("seviye_box_selected")
                })

                e.target.classList.toggle("seviye_box_selected");

                Set_elem_popup((prevItems) => ({ ...prevItems, seviye: String(e.target.textContent) }))

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          seviye: String(e.target.textContent)
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });

              }} className={elem_popup.seviye === "2" ? "seviye_box seviye_box_selected" : "seviye_box"}>2</div>
              <div style={{ backgroundColor: elem_popup.seviye === "3" ? "rgb(237,188,69)" : "transparent" }} onClick={(e) => {
                document.querySelectorAll(".seviye_box").forEach(x => {
                  if (x.classList.contains("seviye_box_selected")) x.classList.remove("seviye_box_selected")
                })

                e.target.classList.toggle("seviye_box_selected")

                Set_elem_popup((prevItems) => ({ ...prevItems, seviye: String(e.target.textContent) }))

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          seviye: String(e.target.textContent)
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });

              }} className={elem_popup.seviye === "3" ? "seviye_box seviye_box_selected" : "seviye_box"}>3</div>
            </div>


          </div>}



          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>


            </>
          )}



          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        borderWidth: e.target.value


                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout, borderRadius: e.target.value


                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}


          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup_Alarm").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup_Alarm").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup_Alarm").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-selectbox changePoup">




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}


          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}

          {elem_popup !== null && <div className="add_option">
            <h5>Add option to select-box</h5>
            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>

              <input type="text" value={add_option_text} onChange={(e) => { Set_add_option_text(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  console.log(e.target.previousElementSibling.value);
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            text_list: layout.elementDetails.text_list ? [...layout.elementDetails.text_list, add_option_text] : [add_option_text]
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_option_text("")
                }}

                className="fa fa-plus"></i>
            </div>

          </div>}
          {elem_popup !== null && <div className="add_option">
            <h5>Set value of option</h5>

            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>
              <input type="text" value={add_option_value} onChange={(e) => { Set_add_option_value(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            value_list: layout.elementDetails.value_list ? [...layout.elementDetails.value_list, add_option_value] : [add_option_value]
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_option_value("")

                }}

                className="fa fa-plus"></i>
            </div>


          </div>}

          {elem_popup !== null && (
            <>
              {[
                { label: "Border Color", key: "border_list" },
                { label: "Background Color", key: "bg_list" },
                { label: "Font Color", key: "font_list" }
              ].map(({ label, key }) => (
                <div key={key} style={{ marginBottom: "20px" }}>
                  <p>{label}</p>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginTop: "10px"
                    }}
                  >
                    {[
                      { name: "TURUNCU", color: "#edbc45" },
                      { name: "KIRMIZI", color: "#ff0000" },
                      { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                      { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                      { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                      { name: "BEYAZ", color: "#ffffff" },
                      { name: "SİYAH", color: "#000" },
                      { name: "YEŞİL", color: "#008000" },
                      { name: "AÇIK GRİ", color: "#EDEDED" }
                    ].map(({ name, color }) => (
                      <div
                        key={color + key}
                        onClick={() => {
                          setLayouts((prevLayouts) => {
                            const updatedLayouts = { ...prevLayouts };

                            updatedLayouts[currentBreakpoint] =
                              updatedLayouts[currentBreakpoint].map((layout) => {
                                if (String(layout.id) === String(elem_popup.id)) {
                                  const list = layout.elementDetails[key] || [];

                                  const updatedList =
                                    selectedOptionselectbox === "" ||
                                      selectedOptionselectbox === "Add"
                                      ? [...list, color]
                                      : list.map((item, index) =>
                                        index === currentIndexSelectbox ? color : item
                                      );

                                  return {
                                    ...layout,
                                    elementDetails: {
                                      ...layout.elementDetails,
                                      [key]: updatedList
                                    }
                                  };
                                }
                                return layout;
                              });

                            return updatedLayouts;
                          });
                        }}
                        title={name}
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: color,
                          border: "1px solid black",
                          borderRadius: "50%",
                          cursor: "pointer",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                        }}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </>
          )}






          {elem_popup !== null && <div style={{ marginBottom: "16px", marginTop: "12px" }} className="mode">

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownselectbox}>
                {selectedOptionselectbox}
                <span className={`arrow ${isOpenselectbox ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenselectbox && (
                <ul className="select-box-dropdown">
                  {["Add", ...(elem_popup.text_list || [])].map((option, index) => {
                    console.log(option, elem_popup.text_list);
                    return <li

                      id={elem_popup.value_list.length > 0 && elem_popup.value_list[index]}
                      key={index}
                      onClick={() => {

                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id) && option !== "Add") {
                              Set_currentIndexSelectbox(index - 1)
                              return {
                                ...layout,
                                bgColor: layout.elementDetails.bg_list ? layout.elementDetails.bg_list[index - 1] : "transparent",
                                borderColor: layout.elementDetails.border_list ? layout.elementDetails.border_list[index - 1] : "black",
                                fontColor: layout.elementDetails.font_list ? layout.elementDetails.font_list[index - 1] : "black",
                                elementDetails: {
                                  ...layout.elementDetails,
                                  text: option,
                                  value: elem_popup.value_list[index - 1],
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });


                        handleOptionClickselectbox(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  })}
                </ul>
              )}
            </div>

          </div>}



          <div className="select_tag_popup_dyn" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginRight: "80%" }}>Get Tag</p>
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {["None", ...filteredTags].map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm("")
                  }

                }} className="tag-dyn" id={tag.tagId || "None"} key={index}>
                  {tag.tagName || tag}
                </div>
              ))}
            </div>
          </div>

          <div className="select_tag_popup_dyn" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginRight: "80%" }}>Set Tag</p>
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm2}
              onChange={handleSearch2}
            />
            <div className="tag-list-dyn">
              {["None", ...filteredTags2].map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;
                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId2: e.target.id,
                                tip: tagType
                              }
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                    }

                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm2("")
                  }

                }} className="tag-dyn" id={tag.tagId || "None"} key={index}>
                  {tag.tagName || tag}
                </div>
              ))}
            </div>
          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        borderWidth: e.target.value


                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout, borderRadius: e.target.value


                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}


          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-selectbox2 changePoup">

          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>SET Popup</div>


          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}


          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}


          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}


          {elem_popup !== null && <div className="add_option">
            <h5>Set value of option</h5>

            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>
              <input type="text" value={add_option_value} onChange={(e) => { Set_add_option_value(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            value_list: layout.elementDetails.value_list ? [...layout.elementDetails.value_list, add_option_value] : [add_option_value]
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_option_value("")

                }}

                className="fa fa-plus"></i>
            </div>


          </div>}

          {elem_popup !== null && (
            <>
              {[
                { label: "Border Color", key: "border_list" },
                { label: "Background Color", key: "bg_list" },
                { label: "Font Color", key: "font_list" }
              ].map(({ label, key }) => (
                <div key={key} style={{ marginBottom: "20px" }}>
                  <p>{label}</p>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginTop: "10px"
                    }}
                  >
                    {[
                      { name: "TURUNCU", color: "#edbc45" },
                      { name: "KIRMIZI", color: "#ff0000" },
                      { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                      { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                      { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                      { name: "BEYAZ", color: "#ffffff" },
                      { name: "SİYAH", color: "#000" },
                      { name: "YEŞİL", color: "#008000" },
                      { name: "AÇIK GRİ", color: "#EDEDED" }
                    ].map(({ name, color }) => (
                      <div
                        key={color + key}
                        onClick={() => {
                          setLayouts((prevLayouts) => {
                            const updatedLayouts = { ...prevLayouts };

                            updatedLayouts[currentBreakpoint] =
                              updatedLayouts[currentBreakpoint].map((layout) => {
                                if (String(layout.id) === String(elem_popup.id)) {
                                  const list = layout.elementDetails[key] || [];

                                  const updatedList =
                                    selectedOptionselectbox === "" ||
                                      selectedOptionselectbox === "Add"
                                      ? [...list, color]
                                      : list.map((item, index) =>
                                        index === currentIndexSelectbox ? color : item
                                      );

                                  return {
                                    ...layout,
                                    elementDetails: {
                                      ...layout.elementDetails,
                                      [key]: updatedList
                                    }
                                  };
                                }
                                return layout;
                              });

                            return updatedLayouts;
                          });
                        }}
                        title={name}
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: color,
                          border: "1px solid black",
                          borderRadius: "50%",
                          cursor: "pointer",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                        }}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </>
          )}






          {elem_popup !== null && <div style={{ marginBottom: "16px", marginTop: "12px" }} className="mode">

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownselectbox2}>
                {selectedOptionselectbox2}
                <span className={`arrow ${isOpenselectbox2 ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenselectbox2 && (
                <ul className="select-box-dropdown">
                  {elem_popup.value_list.length > 0 && elem_popup.value_list.map((option, index) => {
                    console.log(option, elem_popup.text_list);
                    return <li

                      id={elem_popup.value_list.length > 0 && elem_popup.value_list[index]}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                bgColor: layout.elementDetails.bg_list ? layout.elementDetails.bg_list[index] : "transparent",
                                borderColor: layout.elementDetails.border_list ? layout.elementDetails.border_list[index] : "black",
                                fontColor: layout.elementDetails.font_list ? layout.elementDetails.font_list[index] : "black",
                                elementDetails: {
                                  ...layout.elementDetails,
                                  text: option,
                                  value: elem_popup.value_list[index],
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });


                        handleOptionClickselectbox2(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  })}
                </ul>
              )}
            </div>

          </div>}



          <div className="select_tag_popup_dyn" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginRight: "80%" }}>Get Tag</p>
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>
          </div>

          <div className="select_tag_popup_dyn" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ fontWeight: "600", fontSize: "larger", marginRight: "80%" }}>Set Tag</p>
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm2}
              onChange={handleSearch2}
            />
            <div className="tag-list-dyn">
              {filteredTags2.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;
                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId2: e.target.id
                              }
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                    }

                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm2("")
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>
          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        borderWidth: e.target.value


                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout, borderRadius: e.target.value


                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}


          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>

        <div className="changeProperties Popup-go_page changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Sayfaya Git Btn Popup</div>

          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}

          {elem_popup !== null && <div style={{ position: "relative", margin: "24px 0" }} className="select_page_popup_dyn">
            <input
              type="text"
              className="searchInputClass"
              id="searchInput"
              placeholder="Sayfa ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}

            />
            <div className="page-list-dyn">
              {["Alarm", ...props.pages].map((page, index) => (
                <div
                  onClick={(e) => {
                    const id__ = e.target.parentElement.parentElement.parentElement.id;

                    if (id__) {
                      console.log(id__);
                      if (!ws_active) {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };
                          const targetId = id__;
                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((layout) => {
                            if (String(layout.id) === targetId) {
                              if (page === "Alarm") {
                                return {
                                  ...layout,
                                  elementDetails: {
                                    ...layout.elementDetails,
                                    pageId: "0.1",
                                    text: page
                                  },
                                };
                              } else {
                                return {
                                  ...layout,
                                  elementDetails: {
                                    ...layout.elementDetails,
                                    pageId: page.pageId,
                                    text: page.pageName || page
                                  },
                                };
                              }

                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });
                      }

                      // Seçilen sayfa adını input'a yazdır
                      setSearchTerm(page.pageNamepage === "Alarm" ? page : page.pageName);

                      document
                        .querySelector(".select_page_popup_dyn")
                        .classList.toggle("select_page_popup_dyn_active");
                    }
                  }}
                  className="page-dyn"
                  id={page === "Alarm" ? "0.1" : page.pageId}
                  key={index}
                >
                  {page === "Alarm" ? page : page.pageName}
                </div>
              ))}
            </div>
          </div>
          }



          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}












          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}    <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-go_page").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button
              onClick={(e) => {
                onay_elemPoup(e);
                document.querySelector(".Popup-go_page").classList.toggle("changeProperties_active");


                Set_elem_popup(null);
              }}
            >
              Kaydet
            </button>
            <button
              onClick={() => {
                document.querySelector(".Popup-go_page").classList.toggle("changeProperties_active");
                Set_elem_popup(null);
              }}
            >
              İptal
            </button>
          </div>

        </div>
        <div className="changeProperties Popup_t_t changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Text-Tag Popup</div>


          {elem_popup !== null && (
            <>
              <p>Add Trend?</p>
              <div
                className="add_trend_que"
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px"
                }}
              >
                {[
                  { name: "YES" },
                  { name: "NO" },

                ].map(({ name }) => (
                  <div
                    key={name}
                    onClick={(e) => {

                      document.querySelectorAll(".add_trend_que div").forEach(x => {
                        x.style.backgroundColor = "transparent"
                        x.style.color = "black"
                      })

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === String(elem_popup.id)) {
                            return {
                              ...layout,
                              add_trend: `${name}`
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                      if (name === "NO") {
                        e.target.style.backgroundColor = "red"

                      } else {
                        e.target.style.backgroundColor = "green"

                      }
                      e.target.style.color = "white"
                    }}
                    title={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      display: "flex"
                      , alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: "1px solid black",
                      cursor: "pointer",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                    }}
                  >{name}</div>
                ))}
              </div>
            </>
          )}
          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}
          {elem_popup !== null && <div className="mode">

            <h5>Unit</h5>

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownUnit}>
                {selectedOptionUnit}
                <span className={`arrow ${isOpenUnit ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenUnit && (
                <ul className="select-box-dropdown">
                  {["None", "°C", "kWh", "m³", "m³/h"].map((option, index) => (
                    <li

                      id={index + 1}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  unit: option
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });


                        handleOptionClickUnit(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>}

          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}

          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}
          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup_t_t").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup_t_t").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup_t_t").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-popupduz changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>Popupdüz Popup</div>

          {elem_popup !== null && <div className="add_option">
            <h5>Set value of option</h5>

            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>
              <input type="text" value={add_option_value} onChange={(e) => { Set_add_option_value(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            value_list: layout.elementDetails.value_list ? [...layout.elementDetails.value_list, add_option_value] : [add_option_value]
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_option_value("")

                }}

                className="fa fa-plus"></i>
            </div>


          </div>}

          {elem_popup !== null && (
            <>
              {[
                { label: "Border Color", key: "border_list" },
                { label: "Background Color", key: "bg_list" },
                { label: "Font Color", key: "font_list" }
              ].map(({ label, key }) => (
                <div key={key} style={{ marginBottom: "20px" }}>
                  <p>{label}</p>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginTop: "10px"
                    }}
                  >
                    {[
                      { name: "TURUNCU", color: "#edbc45" },
                      { name: "KIRMIZI", color: "#ff0000" },
                      { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                      { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                      { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                      { name: "BEYAZ", color: "#ffffff" },
                      { name: "SİYAH", color: "#000" },
                      { name: "Yeşil", color: "#008000" },
                      { name: "Açık Gri", color: "#EDEDED" }
                    ].map(({ name, color }) => (
                      <div
                        key={color + key}
                        onClick={() => {
                          setLayouts((prevLayouts) => {
                            const updatedLayouts = { ...prevLayouts };

                            updatedLayouts[currentBreakpoint] =
                              updatedLayouts[currentBreakpoint].map((layout) => {
                                if (String(layout.id) === String(elem_popup.id)) {
                                  const currentList = layout.elementDetails[key] || [];

                                  const updatedList =
                                    selectedOptionselectbox === "" ||
                                      selectedOptionselectbox === "Add"
                                      ? [...currentList, color]
                                      : currentList.map((item, index) =>
                                        index === currentIndexSelectbox
                                          ? color
                                          : item
                                      );

                                  return {
                                    ...layout,
                                    elementDetails: {
                                      ...layout.elementDetails,
                                      [key]: updatedList
                                    }
                                  };
                                }
                                return layout;
                              });

                            return updatedLayouts;
                          });
                        }}
                        title={name}
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: color,
                          border: "1px solid black",
                          borderRadius: "50%",
                          cursor: "pointer",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                        }}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </>
          )}


          {elem_popup !== null && <div style={{ marginBottom: "16px", marginTop: "12px" }} className="mode">

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownselectbox}>
                {selectedOptionselectbox}
                <span className={`arrow ${isOpenselectbox ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenselectbox && (
                <ul className="select-box-dropdown">
                  {["Add", ...(elem_popup.value_list || [])].map((option, index) => {
                    console.log(option, elem_popup.value_list);
                    return <li

                      id={elem_popup.value_list.length > 0 && elem_popup.value_list[index]}
                      key={index}
                      onClick={() => {
                        if (option !== "Add") {

                          setLayouts((prevLayouts) => {
                            const updatedLayouts = { ...prevLayouts };

                            updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                              if (String(layout.id) === String(elem_popup.id)) {
                                return {
                                  ...layout,
                                  bgColor: layout.elementDetails.bg_list ? layout.elementDetails.bg_list[index - 1] : "transparent",
                                  borderColor: layout.elementDetails.border_list ? layout.elementDetails.border_list[index - 1] : "black",
                                  fontColor: layout.elementDetails.font_list ? layout.elementDetails.font_list[index - 1] : "black",
                                  index: index - 1,
                                  elementDetails: {
                                    ...layout.elementDetails,
                                    value: elem_popup.value_list[index - 1],
                                  }
                                };
                              }
                              return layout;
                            });
                            return updatedLayouts;
                          });


                          handleOptionClickselectbox(option)
                        }
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  })}
                </ul>
              )}
            </div>

          </div>}

          <h4>LED Adjusment</h4>

          {elem_popup !== null && <div className="add_option">
            <h5>Set value of option</h5>

            <div style={{ width: "100%", display: "flex", alignItems: "center", }}>
              <input type="text" value={add_option_value} onChange={(e) => { Set_add_option_value(e.target.value) }} className="add_option_inp" /><i
                onClick={(e) => {
                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          elementDetails: {
                            ...layout.elementDetails,
                            value_list2: layout.elementDetails.value_list2 ? [...layout.elementDetails.value_list2, add_option_value] : [add_option_value]
                          }
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                  Set_add_option_value("")

                }}

                className="fa fa-plus"></i>
            </div>


          </div>}

          {elem_popup && (
            <>
              {[
                { title: "Border Color", key: "border_list2" },
                { title: "Background Color", key: "bg_list2" },
              ].map(({ title, key }) => (
                <div key={key}>
                  <p>{title}</p>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginTop: "10px",
                    }}
                  >
                    {[
                      { name: "TURUNCU", color: "#edbc45" },
                      { name: "KIRMIZI", color: "#ff0000" },
                      { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                      { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                      { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                      { name: "BEYAZ", color: "#ffffff" },
                      { name: "SİYAH", color: "#000" },
                      { name: "Yeşil", color: "#008000" },
                      { name: "Açık Gri", color: "#EDEDED" },
                    ].map(({ name, color }) => (
                      <div
                        key={`${key}-${color}`}
                        onClick={() => {
                          setLayouts((prevLayouts) => {
                            const updatedLayouts = { ...prevLayouts };

                            updatedLayouts[currentBreakpoint] =
                              updatedLayouts[currentBreakpoint].map((layout) => {
                                if (String(layout.id) === String(elem_popup.id)) {
                                  const currentList =
                                    layout.elementDetails?.[key] || [];

                                  const updatedList =
                                    selectedOptionselectbox3 === "" ||
                                      selectedOptionselectbox3 === "Add"
                                      ? [...currentList, color]
                                      : currentList.map((bg, index) =>
                                        index === layout.index2 ? color : bg
                                      );

                                  return {
                                    ...layout,
                                    elementDetails: {
                                      ...layout.elementDetails,
                                      [key]: updatedList,
                                    },
                                  };
                                }
                                return layout;
                              });

                            return updatedLayouts;
                          });
                        }}
                        title={name}
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: color,
                          border: "1px solid black",
                          borderRadius: "50%",
                          cursor: "pointer",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                        }}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </>
          )}




          {elem_popup !== null && <div style={{ marginBottom: "16px", marginTop: "12px" }} className="mode">

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdownselectbox3}>
                {selectedOptionselectbox3}
                <span className={`arrow ${isOpenselectbox3 ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenselectbox3 && (
                <ul className="select-box-dropdown">
                  {elem_popup.value_list2 && ["Add", ...(elem_popup.value_list2 || [])].map((option, index) => {
                    console.log(option, elem_popup.value_list2);
                    return <li

                      id={elem_popup.value_list2.length > 0 && elem_popup.value_list2[index]}
                      key={index}
                      onClick={() => {
                        if (option !== "Add") {
                          setLayouts((prevLayouts) => {
                            const updatedLayouts = { ...prevLayouts };

                            updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                              if (String(layout.id) === String(elem_popup.id)) {
                                return {
                                  ...layout,
                                  bgColor2: layout.elementDetails.bg_list2 ? layout.elementDetails.bg_list2[index - 1] : "transparent",
                                  borderColor2: layout.elementDetails.border_list2 ? layout.elementDetails.border_list2[index - 1] : "black",
                                  index2: index - 1,
                                  elementDetails: {
                                    ...layout.elementDetails,
                                  }

                                };
                              }
                              return layout;
                            });
                            return updatedLayouts;
                          });


                          handleOptionClickselectbox3(option)
                        }

                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  })}
                </ul>
              )}
            </div>

          </div>}

          <div className="select_tag_popup_dyn" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left", width: "50%", fontWeight: "600", fontSize: "larger", marginRight: "80%" }}>Get Tag</p>
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId: e.target.id,
                                tip: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>
          </div>




          <div className="select_tag_popup_dyn" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left", width: "50%", fontWeight: "600", fontSize: "larger", marginRight: "80%" }}>Get Tag For LED</p>
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm2}
              onChange={handleSearch2}
            />
            <div className="tag-list-dyn">
              {filteredTags2.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;
                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId2: e.target.id
                              }
                            };
                          }
                          return layout;
                        });
                        return updatedLayouts;
                      });
                    }

                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm2("")
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>
          </div>




          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}


          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}


          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Oda Sıcaklığı"
              value={searchTerm3}
              onChange={handleSearch3}
            />
            <div className="tag-list-dyn">
              {filteredTags3.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId3: e.target.id,
                                tip3: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm3(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>

          <div className="select_tag_popup_dyn">
            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Oda Set Değeri"
              value={searchTerm4}
              onChange={handleSearch4}
            />
            <div className="tag-list-dyn">
              {filteredTags4.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.parentElement.parentElement.parentElement.id;


                  if (id__) {
                    console.log(id__)
                    if (!ws_active) {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };
                        const targetId = id__;

                        updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                          if (String(layout.id) === targetId) {
                            const selectedTag = tag_values_state.find(item => item.tagId === e.target.id);
                            const tagType = selectedTag && selectedTag.tip === "Var" ? "Var" : "Tag"; // Eğer `tip === "Var"` ise "Var", değilse "Tag" olarak kaydet

                            return {
                              ...layout,
                              elementDetails: {
                                ...layout.elementDetails,
                                tagId4: e.target.id,
                                tip4: tagType // Yeni `tip` değeri ekleniyor
                              }
                            };
                          }
                          return layout;
                        });

                        return updatedLayouts;
                      });
                    }


                    document.querySelector(".select_tag_popup_dyn").classList.toggle("select_tag_popup_dyn_active")
                    setSearchTerm4(tag.tagName)
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>

          </div>


          {elem_popup !== null && (
            <div className="start_build_popupBTN-div">
              <button
                onClick={(e) => {
                  try {
                    Set_special_type_active(true);
                    Set_active_popup_id(elem_popup.id);

                    if (active_popup_items.length < 1) {
                      setLayouts((prevLayouts) => {
                        const newX = Math.round(Math.random() * 5) * 2;
                        const newY = Math.floor(12 / 6) * 2;
                        const newWidget = {
                          x: newX,
                          y: newY,
                          id:
                            layouts[currentBreakpoint].filter((item) => item.special_type).length +
                            1500 +
                            (top_score_id !== null
                              ? layouts[currentBreakpoint].length + top_score_id
                              : layouts[currentBreakpoint].length + top_score_id2),
                          id2:
                            top_score_id !== null
                              ? layouts[currentBreakpoint].length + top_score_id
                              : layouts[currentBreakpoint].length + top_score_id2 - 1,
                          special_type: "popup_elems",
                          w: 202,
                          elementDetails: { borderRadius: "8", borderWidth: "3" },
                          type: "frame",
                          h: 3,
                          i: String(
                            layouts[currentBreakpoint].filter((item) => item.special_type).length +
                            1500 +
                            (top_score_id !== null
                              ? layouts[currentBreakpoint].length + top_score_id
                              : layouts[currentBreakpoint].length + top_score_id2)
                          ),
                          static: Math.random() < 0.05,
                          resizeHandles: resizeHandles,
                        };
                        const updatedLayouts = { ...prevLayouts };
                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                          updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                          ];
                        } else {
                          updatedLayouts[currentBreakpoint] = [newWidget];
                        }
                        return updatedLayouts;
                      });
                    } else {
                      let w__, h__;

                      const currentPopupId = `popup_${active_popup_id}`;


                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                          updatedLayouts[currentBreakpoint].forEach((item) => {
                            if (String(item.id) === String(active_popup_id)) {
                              if (!item.elementDetails.items) {
                                item.elementDetails.items = [];
                              }




                              item.elementDetails.items.forEach((newItem) => {
                                if (newItem.type === "frame") {
                                  w__ = newItem.w;
                                  h__ = newItem.h;

                                }

                                newItem.isDraggable = false;
                                newItem.isResizable = false;
                                updatedLayouts[currentBreakpoint].push(newItem);
                              });
                            }
                          });
                        }

                        return updatedLayouts;
                      });

                      // 👇 Popup Göster'deki gibi pozisyonla
                      setTimeout(() => {
                        let diffX, diffY;
                        const layoutItems = document.querySelector(".react-grid-layout")
                          .childNodes;

                        layoutItems.forEach((x) => {
                          const id = x.getAttribute("data-id");
                          if (!id?.includes(currentPopupId)) return;

                          if (x.classList.contains("frame_widget")) {

                            x.style.width = `${w__}px`; // Grid birimlerini px'e çevir
                            x.style.height = `${h__}px`;

                            const initialRect = x.getBoundingClientRect();
                            const mainSec = document.querySelector(".main_sec");
                            const mainSecRect = mainSec.getBoundingClientRect();

                            const centerX = (mainSecRect.width) / 2;
                            const centerY = (mainSecRect.height) / 2 - mainSecRect.top / 10;

                            console.warn(mainSecRect, "kdoejdıoejoejoe")

                            const targetX = (centerX - w__ / 2) - mainSecRect.left / 5;
                            const targetY = (centerY - h__ / 2);

                            console.log("targetX", targetX)

                            diffX = targetX;
                            diffY = targetY;

                            x.style.transform = `translate(${targetX}px, ${targetY}px)`;
                          }
                        });

                        // Diğer öğeleri frame'e göre taşı
                        layoutItems.forEach((x) => {
                          const id = x.getAttribute("data-id");
                          if (!id?.includes(currentPopupId)) return;
                          if (x.classList.contains("frame_widget")) return;

                          if (typeof diffX !== "undefined" && typeof diffY !== "undefined") {
                            const frameWidgetRect = document
                              .querySelector(".frame_widget")
                              .getBoundingClientRect();
                            const elementRect = x.getBoundingClientRect();

                            const relativeX = elementRect.left - frameWidgetRect.left;
                            const relativeY = elementRect.top - frameWidgetRect.top;

                            x.style.transform = `translate(${diffX + relativeX}px, ${diffY + relativeY
                              }px)`;
                          }
                        });
                      }, 100);
                    }

                    // Ortak görsel güncellemeler
                    document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                      x.style.opacity = "0";
                      x.style.zIndex = "-1";
                    });
                    document.querySelector(".tool_box").style.opacity = "0";
                    document.querySelector(".tool_box").style.zIndex = "-1";
                    document.querySelector(".tool_box2").style.opacity = "1";
                    document.querySelector(".tool_box2").style.zIndex = "100000";
                    document.querySelector(".tool_box2").classList.toggle("tool_box_active");
                    document.querySelector(".Popup-popupduz").classList.toggle("changeProperties_active");
                  } catch (err) {
                    console.log(err);
                  }
                }}
                className="start_build_popupBTN"
              >
                Popup Düzenle
              </button>
            </div>
          )}
          {/* 
          {elem_popup !== null && active_popup_items.length > 0 && (
            <div className="start_build_popupBTN-div">
              <button
                onClick={(e) => {
                  Set_special_type_active(true);
                  if (document
                    .querySelector(".Popup-popupduz")
                    .classList.contains("changeProperties_active")) {
                    document
                      .querySelector(".Popup-popupduz")
                      .classList.remove("changeProperties_active");
                  }
                  Set_elem_popup(null);

                  const allItems = document.querySelector(".react-grid-layout")
                    .childNodes;
                  const currentPopupId = `popup_${active_popup_id}`;


                  let w__, h__, x__, y__;

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                      updatedLayouts[currentBreakpoint].forEach((item) => {
                        if (String(item.id) === String(active_popup_id)) {
                          if (!item.elementDetails.items) {
                            item.elementDetails.items = [];
                          }




                          item.elementDetails.items.forEach((newItem) => {
                            if (newItem.type === "frame") {
                              w__ = newItem.w;
                              h__ = newItem.h;
                              x__ = newItem.x;
                              y__ = newItem.y;
                            }

                            newItem.isDraggable = false;
                            newItem.isResizable = false;
                            updatedLayouts[currentBreakpoint].push(newItem);
                          });
                        }
                      });
                    }

                    return updatedLayouts;
                  });

                  document
                    .querySelector(".main_sec")
                    .classList.toggle("main_sec_bg_blur");

                  setTimeout(() => {
                    document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                      if (window.getComputedStyle(x).zIndex !== "-1") {
                        x.style.zIndex = "2";
                      }
                    });
                  }, 50);

                  let frame_inf = null;

                  setTimeout(() => {
                    let diffX, diffY;
                    const layoutItems = document.querySelector(".react-grid-layout")
                      .childNodes;

                    layoutItems.forEach((x) => {
                      const id = x.getAttribute("data-id");
                      console.log(x, id)
                      if (!id?.includes(currentPopupId)) return;

                      if (x.classList.contains("frame_widget")) {

                        x.style.width = `${w__}px`; // Grid birimlerini px'e çevir
                        x.style.height = `${h__}px`;

                        const initialRect = x.getBoundingClientRect();
                        const mainSec = document.querySelector(".main_sec");
                        const mainSecRect = mainSec.getBoundingClientRect();

                        const centerX = (mainSecRect.width) / 2;
                        const centerY = (mainSecRect.height) / 2 - mainSecRect.top / 10;

                        console.warn(mainSecRect, "kdoejdıoejoejoe")

                        const targetX = (centerX - w__ / 2) - mainSecRect.left / 5;
                        const targetY = (centerY - h__ / 2);

                        console.log("targetX", targetX)

                        diffX = targetX;
                        diffY = targetY;

                        x.style.transform = `translate(${targetX}px, ${targetY}px)`;
                      }
                    });

                    // Diğer öğeleri frame'e göre taşı
                    layoutItems.forEach((x) => {
                      const id = x.getAttribute("data-id");
                      if (!id?.includes(currentPopupId)) return;
                      if (x.classList.contains("frame_widget")) return;

                      if (typeof diffX !== "undefined" && typeof diffY !== "undefined") {
                        const frameWidgetRect = document
                          .querySelector(".frame_widget")
                          .getBoundingClientRect();
                        const elementRect = x.getBoundingClientRect();

                        const relativeX = elementRect.left - frameWidgetRect.left;
                        const relativeY = elementRect.top - frameWidgetRect.top;

                        x.style.transform = `translate(${diffX + relativeX}px, ${diffY + relativeY
                          }px)`;
                      }
                    });
                  }, 100);

                  // Ortak görsel güncellemeler
                  document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                    x.style.opacity = "0";
                    x.style.zIndex = "-1";
                  });
                  document.querySelector(".tool_box").style.opacity = "0";
                  document.querySelector(".tool_box").style.zIndex = "-1";
                  document.querySelector(".tool_box2").style.opacity = "1";
                  document.querySelector(".tool_box2").style.zIndex = "100000";
                  document.querySelector(".tool_box2").classList.toggle("tool_box_active");
                }}
                className="start_build_popupBTN-green"
              >
                Popup'ı Göster
              </button>
            </div>
          )} */}







          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}
          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-popupduz").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button onClick={(e) => {
              onay_elemPoup(e); document.querySelector(".Popup-popupduz").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".Popup-popupduz").classList.toggle("changeProperties_active")
              Set_elem_popup(null)
            }}>İptal</button>
          </div>
        </div>
        <div className="changeProperties Popup-i_g changePoup">
          <div style={{ width: "100%", display: "block", margin: "8px 0 ", textAlign: "center", fontWeight: "600", color: "rgb(30,30,30)", fontSize: "larger" }}>İleri-Geri Popup</div>

          {elem_popup !== null && (
            <>
              {/* --- Border Color --- */}
              <p>Border Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.borderColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          borderColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Background Color --- */}
              <p style={{ marginTop: "20px" }}>Background Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.bgColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          bgColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>

              {/* --- Font Color --- */}
              <p style={{ marginTop: "20px" }}>Font Color</p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                {[
                  { name: "TURUNCU", color: "#edbc45" },
                  { name: "KIRMIZI", color: "#ff0000" },
                  { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                  { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                  { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                  { name: "BEYAZ", color: "#ffffff" },
                  { name: "SİYAH", color: "#000" },
                  { name: "YEŞİL", color: "#008000" },
                  { name: "AÇIK GRİ", color: "#EDEDED" },
                ].map(({ name, color }) => {
                  const isActive = elem_popup.fontColor === color;
                  return (
                    <div
                      key={color}
                      onClick={() =>
                        Set_elem_popup((PrevItems) => ({
                          ...PrevItems,
                          fontColor: color,
                        }))
                      }
                      title={name}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: color,
                        border: isActive ? "3px solid black" : "1px solid black",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 0 10px 2px rgba(0, 0, 0, 0.4)"
                          : "0 2px 5px rgba(0, 0, 0, 0.2)",
                        transform: isActive ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  );
                })}
              </div>
            </>
          )}



          {elem_popup !== null && <div className="Size">
            <div className="input-group">
              <label htmlFor="Width">Width</label>
              <input onChange={(e) => {
                console.log(elem_popup);
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          w: Number(e.target.value),
                          w_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        }
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Height">Height</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          h: Number(e.target.value),
                          h_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="X">X</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          x: Number(e.target.value),
                          x_percent: Number(e.target.value / (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
            </div>
            <div className="input-group">
              <label htmlFor="Y">Y</label>
              <input onChange={(e) => {
                if (e.target.value !== "") {
                  Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }))

                  setLayouts((prevLayouts) => {
                    const updatedLayouts = { ...prevLayouts };

                    updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                      if (String(layout.id) === String(elem_popup.id)) {
                        return {
                          ...layout,
                          y: Number(e.target.value),
                          y_percent: Number(e.target.value / (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86))
                        };
                      }
                      return layout;
                    });
                    return updatedLayouts;
                  });
                }
              }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
            </div>
          </div>}

          {elem_popup !== null && <div className="Position">

            <div className="input-group">
              <label htmlFor="font-size">Font Size</label>
              <input onChange={(e) => {
                if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, fontSize: Number(e.target.value) }));
              }} value={String(elem_popup.fontSize)} type="number" className="adjust_X_pop_up" />
            </div>

          </div>}

          {elem_popup !== null && <div className="Text-Position">

            <h5>Text Position</h5>

            <div className="btn-group">
              <button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "left"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Left</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Center</button><button onClick={(e) => {
                e.target.parentElement.childNodes.forEach(x => {
                  if (x.classList.contains("selected")) {
                    x.classList.remove("selected")
                  }
                })
                e.target.classList.add("selected");
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "right"
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }}>Right</button>
            </div>

          </div>}


          {elem_popup !== null && <div className="select_page_popup_dyn">
            <input
              type="text"
              className="searchInputClass"
              id="searchInput"
              placeholder="Sayfa ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}

            />
            <div className="page-list-dyn">
              {props.pages.map((page, index) => (
                <div
                  onClick={(e) => {
                    const id__ = e.target.parentElement.parentElement.parentElement.id;

                    if (id__) {
                      console.log(id__);
                      if (!ws_active) {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };
                          const targetId = id__;
                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((layout) => {
                            if (String(layout.id) === targetId) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  pageId: page.pageId,
                                },
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });
                      }

                      // Seçilen sayfa adını input'a yazdır
                      setSearchTerm(page.pageName);

                      document
                        .querySelector(".select_page_popup_dyn")
                        .classList.toggle("select_page_popup_dyn_active");
                    }
                  }}
                  className="page-dyn"
                  id={page.pageId}
                  key={index}
                >
                  {page.pageName}
                </div>
              ))}
            </div>
          </div>
          }


          {elem_popup !== null && <div style={{ marginTop: "35%" }} className="mode">

            <h5>Mod</h5>

            <div className="select-box">
              <div className="select-box-header" onClick={toggleDropdowni_g}>
                {selectedOptioni_g}
                <span className={`arrow ${isOpeni_g ? 'open' : ''}`}>▼</span>
              </div>
              {isOpeni_g && (
                <ul className="select-box-dropdown">
                  {["GERİ", "İLERİ"].map((option, index) => (
                    <li
                      id={index + 1}
                      key={index}
                      onClick={() => {
                        setLayouts((prevLayouts) => {
                          const updatedLayouts = { ...prevLayouts };

                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                            if (String(layout.id) === String(elem_popup.id)) {
                              return {
                                ...layout,
                                elementDetails: {
                                  ...layout.elementDetails,
                                  text: option,
                                  value: index + 1
                                }
                              };
                            }
                            return layout;
                          });
                          return updatedLayouts;
                        });

                        handleOptionClicki_g(option)
                      }}
                      className="select-box-option"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>}







          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Width</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderWidth: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderWidth: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderWidth)} className="inp-set-border-radius" />

          </div>}
          {elem_popup !== null && <div className="dyn-border-radius_set">
            <h5>Border Radius</h5>
            <input type="number" onChange={(e) => {
              if (e.target.value !== "") {
                Set_elem_popup((prevItems) => ({ ...prevItems, borderRadius: Number(e.target.value) }));

                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          borderRadius: e.target.value
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });
              }
            }} value={String(elem_popup.borderRadius)} className="inp-set-border-radius" />

          </div>}
          <div className="deleteElem">
            <button onClick={(e) => {
              deleteElem(e.target.parentElement.parentElement.id); document.querySelector(".Popup-i_g").classList.toggle("changeProperties_active")
            }}>Elemanı Sil</button>
          </div>

          <div className="btnpart">
            <button
              onClick={(e) => {
                onay_elemPoup(e);
                document.querySelector(".Popup-i_g").classList.toggle("changeProperties_active");


                Set_elem_popup(null);
              }}
            >
              Kaydet
            </button>
            <button
              onClick={() => {
                document.querySelector(".Popup-i_g").classList.toggle("changeProperties_active");
                Set_elem_popup(null);
              }}
            >
              İptal
            </button>
          </div>

        </div>
        {/* <div className="changeProperties-gauge Popup changePoup">

        <p>Tag Seçin</p>

        {elem_popup !== null && <div className="Size">
          <div className="input-group">
            <label htmlFor="Width">Width</label>
            <input onChange={(e) => {
              console.log(elem_popup);
              if(e.target.value!==""){
              setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };

                  updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layout => {
                    if (String(layout.id) === String(elem_popup.id)) {
                      return {
                        ...layout,
                        elementDetails: {
                          ...layout.elementDetails,
                          textAlign: "center",
                        }
                      };
                    }
                    return layout;
                  });
                  return updatedLayouts;
                });}
            }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
          </div>
          <div className="input-group">
            <label htmlFor="Height">Height</label>
            <input onChange={(e) => {
              if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }));
            }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
          </div>

        </div>}

        {elem_popup !== null && <div className="Position">

          <div className="input-group">
            <label htmlFor="X">X</label>
            <input onChange={(e) => {
              if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }));
            }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
          </div>
          <div className="input-group">
            <label htmlFor="Y">Y</label>
            <input onChange={(e) => {
              if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }));
            }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
          </div>
        </div>}

        <div className="btnpart">
          <button onClick={(e) => { onay_elemPoup(e) }}>Kaydet</button><button onClick={() => {
            document.querySelector(".Popup").classList.toggle("changeProperties_active")
            Set_elem_popup(null)
          }}>İptal</button>
        </div>
      </div> */}
        <div className="gauge_pop_up">
          <i
            onClick={closePopUpGauge}
            style={{
              position: "absolute",
              left: "93%",
              bottom: "92%",
              color: "red",
              scale: "1.2",
              cursor: "pointer",
            }}
            className="fa fa-times"
          ></i>
          <div className="fgh">
            <GaugeChart id="gauge-chart2" nrOfLevels={20} percent={0.86} />
            <span>This is example</span>
          </div>

          <div className="fgh">
            <p style={{ textAlign: "left", display: "block", width: "100%", marginBottom: "12px" }}>Max Value</p>
            <input
              value={temp_gauge_max}
              onChange={(e) => {
                Set_temp_gauge_max(e.target.value);
              }}
              type="text"
            />

            <p style={{ textAlign: "left", display: "block", width: "100%", marginBottom: "12px" }}>Tag Seçin</p>

            <input
              type="text"
              className="searchInputclass"
              id="searchInput"
              placeholder="Tag ismine göre ara..."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="tag-list-dyn">
              {filteredTags.map((tag, index) => (
                <div onClick={(e) => {

                  var id__ = e.target.id;


                  if (id__) {


                    setLayouts((prevLayouts) => {
                      const updatedLayouts = { ...prevLayouts };
                      const targetId = id__.substring(0, id__.length - 1);
                      updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map((layout, index, array) => {
                        if (layout.type === "gauge" && index === array.length - 1) {
                          return {
                            ...layout,
                            elementDetails: {
                              ...layout.elementDetails,
                              tagId: e.target.id
                            }
                          };
                        }
                        return layout;
                      });
                      return updatedLayouts;
                    });


                    setSearchTerm("")
                  }

                }} className="tag-dyn" id={tag.tagId} key={index}>
                  {tag.tagName}
                </div>
              ))}
            </div>


            <button
              onClick={() => {
                setLayouts((prevLayouts) => {
                  const updatedLayouts = { ...prevLayouts };
                  if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                    updatedLayouts[currentBreakpoint] = updatedLayouts[
                      currentBreakpoint
                    ].map((item, index, array) => {
                      if (index === array.length - 1) {
                        // Sadece son elemanı kontrol et

                        return {
                          ...item,
                          elementDetails: {
                            ...item.elementDetails,
                            maxValue: temp_gauge_max, // yeniDeger, yeni maxValue değerini temsil eder
                          },
                        };
                      }
                      return item;
                    });
                  }
                  return updatedLayouts;
                });

                document
                  .querySelector(".gauge_pop_up")
                  .classList.toggle("gauge_pop_up_active");

                document
                  .querySelector(".main_sec")
                  .classList.toggle("main_sec_dark");

                Set_temp_gauge_max(0);
              }}
            >
              SAVE
            </button>
          </div>
        </div>

        <div className="canvas_adjust_popUp">
          <div className="input-group">
            <label htmlFor="width">Genişlik (px)</label>
            <input type="number" onChange={(e) => {
              Set_canvas_boyutu_gecici((prevItem) => ({
                ...prevItem,
                width: e.target.value
              }))
            }} value={canvas_boyutu_gecici.width} placeholder="genişlik" />
          </div>
          <div className="input-group">
            <label htmlFor="height">Yükseklik (px)</label>
            <input onChange={(e) => {
              Set_canvas_boyutu_gecici((prevItem) => ({
                ...prevItem,
                height: e.target.value
              }))
            }} type="number" value={canvas_boyutu_gecici.height} placeholder="yükseklik" />
          </div>
          <div className="btn-group">
            <button onClick={(e) => {
              try {
                let w, h;
                w = e.target.parentElement.parentElement.firstElementChild.firstElementChild.nextElementSibling.value;
                h = e.target.parentElement.parentElement.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.value

                Set_canvas_boyutu({ width: w, height: h })
                Store.dispatch(setCanvasBoyut({ width: w, height: h }))
                document.querySelector("aside").style.height = String(Number(document.querySelector("header").getBoundingClientRect().height) + Number(h) - 13) + "px"
                document.querySelector("aside").style.maxHeight = String(Number(document.querySelector("header").getBoundingClientRect().height) + Number(h) - 13) + "px"


              } catch (err) {
                console.log(err);
              } finally {
                document.querySelector(".canvas_adjust_popUp").classList.toggle("canvas_adjust_popUp_active");
                document.querySelector(".main_sec").classList.toggle("main_sec_dark")
              }


            }}>Kaydet</button><button onClick={() => {
              document.querySelector(".canvas_adjust_popUp").classList.toggle("canvas_adjust_popUp_active");
              document.querySelector(".main_sec").classList.toggle("main_sec_dark")

              Set_canvas_boyutu_gecici({ width: canvas_boyutu.width, height: canvas_boyutu.height })
            }}>İptal</button>
          </div>
        </div>
        {!bg_control &&

          <div className="main_sec" style={{ backgroundColor: page_bgColor !== "" ? page_bgColor : "transparent", border: "6px solid rgb(50,50,50)", width: "100%", height: Number(canvas_boyutu.height).toFixed(5) + "px" }}>
            {control_loading === true ? <div
              style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
              }}
              className="loading"
            >
              <img style={{ width: "15%" }} src={loading_} alt="" />
              <p style={{ textAlign: "center", marginTop: "16px", fontWeight: "600", color: "rgb(70,70,70)" }}>Sayfa Yükleniyor. Lütfen Bekleyiniz...</p>

            </div> : <>


              <div onClick={(e) => {
                if (window.getComputedStyle(document.querySelector(".tool_box2")).opacity === "1") {
                  document.querySelector(".tool_box2").classList.toggle("tool_box_active")

                } else {

                  document.querySelector(".tool_box").classList.toggle("tool_box_active")
                }
              }} className="hamburgerDyn">
                <span></span>
                <span></span>
                <span></span>
              </div>

              <div className="tool_box">
                <div className="top">
                  <h4>Toolbox</h4>
                  <i onClick={() => {
                    document.querySelector(".tool_box").classList.toggle("tool_box_active")
                  }} className="fa fa-times"></i></div>

                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "flex-start" }} className="mode">

                  <button onClick={copyLayout} className="copy_page" style={{ fontWeight: "600", color: "rgb(80,80,80)" }}>Sayfayı Kopyala</button>

                  <button onClick={handlePaste} className="paste_page" style={{ fontWeight: "600", color: "rgb(80,80,80)" }}>Sayfa Yapıştır</button>

                  <h5 style={{ fontWeight: "600", color: "rgb(80,80,80)" }}>Kütüphaneden Kullan</h5>

                  <div style={{ width: "100%" }} className="select-box">
                    <div className="select-box-header" onClick={toggleDropdownlibrary}>
                      {selectedOptionlibrary}
                      <span className={`arrow ${isOpenlibrary ? 'open' : ''}`}>▼</span>
                    </div>
                    {isOpenlibrary && (
                      <ul style={{ maxHeight: "60%", overflowY: "auto" }} className="select-box-dropdown">
                        {props.widgets_library.length > 0 && props.widgets_library
                          .sort((a, b) => {
                            const nameA = typeof a.widget_name === "string" ? a.widget_name.toLowerCase() : "";
                            const nameB = typeof b.widget_name === "string" ? b.widget_name.toLowerCase() : "";
                            return nameA.localeCompare(nameB);
                          })
                          .map((option, index) => {
                            return (
                              <li
                                id={option.widgetId}
                                key={index}
                                onClick={() => {
                                  const normalizeURLPath = (path) => {
                                    const turkishMap = {
                                      'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                      'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                      'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                    };
                                    return path.split('').map(char => turkishMap[char] || char).join('');
                                  };

                                  Set_selected_library_number(selectedlibrary_number + 1);
                                  Set_total_widget_in_page(prev => prev + 1);

                                  setLayouts((prevLayouts) => {
                                    const updatedLayouts = { ...prevLayouts };

                                    try {
                                      const normalizedPageName = normalizeURLPath(option.widget_name).replaceAll(" ", "_");
                                      const items = props.widgets_library
                                        .filter(x => normalizeURLPath(x.widget_name).replaceAll(" ", "_") === normalizedPageName)
                                        .map(x => (typeof x.widget_details === 'string' ? JSON.parse(x.widget_details) : x.widget_details))[0];
                                      const combine_trend_control_ = props.widgets_library
                                        .filter(x => normalizeURLPath(x.widget_name).replaceAll(" ", "_") === normalizedPageName)
                                        .map(x => (typeof x.widget_details === 'string' ? (JSON.parse(x.widget_details).combine_trend ? JSON.parse(x.widget_details).combine_trend : undefined) : null))[0];


                                      if (items) {
                                        const canvas_boyutu_ = items.canvas_boyutu;
                                        Set_currentpageDetails(items);

                                        const df1_w = document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86;
                                        const df1_h = document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86;

                                        const df2_w = (document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86);
                                        const df2_h = (document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86);

                                        const guncel_ekran_boyutu = { w: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, h: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 }

                                        const currentWidth = guncel_ekran_boyutu.w;
                                        const currentHeight = guncel_ekran_boyutu.h;
                                        const initalWidth = canvas_boyutu_.width;
                                        const initalHeight = canvas_boyutu_.height;
                                        const width_oran = initalWidth !== 0 ? currentWidth / initalWidth : 1;
                                        const height_oran = initalHeight !== 0 ? currentHeight / initalHeight : 1;

                                        let newIdOffset = updatedLayouts[currentBreakpoint]?.length || 0;
                                        let maxId = top_score_id;
                                        let maxGid = top_group_t_id

                                        const processItems = (items) => {
                                          return items.map((item, idx) => {
                                            const safeOranlama = (value, oran) => (typeof value === 'number' && !isNaN(value)) ? value * oran : value;



                                            if (item.type === "bg") {
                                              item.elementDetails.left = safeOranlama(item.elementDetails.left, width_oran);
                                              item.elementDetails.width = safeOranlama(item.elementDetails.width, width_oran);
                                              item.elementDetails.top = safeOranlama(item.elementDetails.top, height_oran);
                                              item.elementDetails.height = safeOranlama(item.elementDetails.height, height_oran);
                                            } else if (item.type === "frame") {
                                              item.combine_trend = combine_trend_control_ !== null && combine_trend_control_ !== undefined ? combine_trend_control_ : null;
                                              item.group_t_id_frame = "frameWidgetId-" + String(index) + "-" + String(total_widget_in_page + 1)

                                            } else if (item.elementDetails.items && item.elementDetails.items.length > 0) {
                                              item.elementDetails.items = item.elementDetails.items.map((x, i) => {
                                                console.log(x)
                                                let obj = {
                                                  ...x,
                                                  id2: 3000 + maxId + idx + top_score_id2,
                                                  id: 3000 + maxId + idx + top_score_id2 + x.id,
                                                  i: (3000 + maxId + idx + top_score_id2 + x.id).toString(),
                                                  w: x.w_percent ? x.w_percent * currentWidth : safeOranlama(x.w, width_oran),
                                                  h: x.h_percent ? x.h_percent * currentHeight : safeOranlama(x.h, height_oran),
                                                  y: x.y_percent ? x.y_percent * currentHeight : safeOranlama(x.y, height_oran),
                                                  x: x.x_percent ? x.x_percent * currentWidth : safeOranlama(x.x, width_oran),
                                                  fontSize: Number(x.fontSize) * width_oran
                                                }
                                                console.log(obj)
                                                return obj
                                              });
                                            }

                                            item.x = safeOranlama(item.x, width_oran);
                                            item.w = safeOranlama(item.w, width_oran);
                                            item.y = safeOranlama(item.y, height_oran);
                                            item.h = safeOranlama(item.h, height_oran);
                                            item.fontSize = safeOranlama(item.fontSize, Math.min(width_oran, height_oran));
                                            item.id = 3000 + maxId + idx + top_score_id2;
                                            item.i = (3000 + maxId + idx + top_score_id2).toString();
                                            item.group_t_id = group_t_id + iterate_group_nod_id + maxGid;

                                            return item;
                                          });
                                        };

                                        if (items.items_last) {
                                          Object.keys(items.items_last).forEach((key) => {
                                            const itemList = items.items_last[key];
                                            if (Array.isArray(itemList)) {
                                              updatedLayouts[key] = (updatedLayouts[key] || []).concat(processItems(itemList));
                                            }
                                          });
                                        }

                                        Set_top_group_t_id(group_t_id + iterate_group_nod_id + maxGid);


                                        Set_group_t_id(group_t_id + 1)
                                        Set_itarate_group_no_id(iterate_group_nod_id + 1)

                                        maxId += Object.values(items.items_last || {}).flat().length;
                                        Set_top_score_id(maxId);

                                      }
                                    } catch (error) {
                                      console.error("Error updating layouts: ", error);
                                    } finally {
                                      document.querySelector(".tool_box").classList.toggle("tool_box_active");
                                    }

                                    return updatedLayouts;
                                  });

                                  handleOptionClicklibrary(option.widget_name);
                                }}
                                className="select-box-option"
                              >
                                {typeof option.widget_name === "string"
                                  ? option.widget_name
                                  : JSON.stringify(option.widget_name)}
                              </li>
                            );
                          })}
                      </ul>







                    )}
                  </div>

                </div>
                <button onClick={createWidget} id="text">
                  Text Box

                </button>
                <button onClick={createWidget} id="tag">
                  Tag
                </button>
                <button
                  id="empty_btn"
                  onClick={(e) => {

                    createWidget(e);
                  }}
                >
                  Button &#40;No Label&#41;
                </button>
                <button
                  id="y_g"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Yuvarlak Gösterge
                </button>
                <button
                  id="selectbox"
                  onClick={(e) => {

                    createWidget(e);
                  }}
                >
                  Selectbox
                </button>


                <button
                  id="go_page"
                  onClick={(e) => {

                    createWidget(e);
                  }}
                >
                  Sayfa Butonu
                </button>
                <button
                  id="on/off"
                  onClick={(e) => {

                    createWidget(e);
                  }}
                >
                  On/Off
                </button>
                <button
                  id="calisma_modu"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Çalışma Modu
                </button>
                <button
                  id="fan_modu"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Fan Modu
                </button>
                <button
                  id="i_g"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  İleri/Geri
                </button>
                <button
                  id="t_t"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Text-Tag
                </button>
                <button
                  id="Alarm"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Alarm
                </button>
                <button
                  onClick={(e) => {
                    if (
                      e.target.firstElementChild.classList.contains(
                        "arrow_list_active"
                      )
                    ) {

                      e.target.firstElementChild.classList.remove(
                        "arrow_list_active"
                      );
                    } else {
                      e.target.firstElementChild.classList.add(
                        "arrow_list_active"
                      );
                    }
                  }}
                  id="ok"
                >
                  Ok
                  <ul className="arrow_list">
                    <li id="left_ok" onClick={(e) => {
                      e.stopPropagation()
                      createWidget(e)
                    }}>
                      Sol Ok <i className="fa fa-arrow-left"></i>
                    </li>
                    <li id="right_ok" onClick={(e) => {
                      e.stopPropagation();
                      createWidget(e)

                    }}>
                      Sağ Ok <i className="fa fa-arrow-right"></i>
                    </li>
                  </ul>
                </button>
                <button className="img_btn_dyn" onClick={createWidget} id="image">
                  Image{" "}
                  <input
                    className="img_btn_dyn_inp"
                    onChange={(e) => {
                      let file = e.target;
                      let file_ = file.files[0];
                      if (file_ && file_.type.startsWith("image/")) {
                        const reader = new FileReader();

                        Set_render_items((prevLayouts) => {
                          return {
                            ...prevLayouts,
                            [currentBreakpoint]: [
                              ...prevLayouts[currentBreakpoint],
                              "image",
                            ],
                          };
                        });

                        reader.onload = function (event) {
                          const imageSrc = event.target.result;
                          Set_image_objs((prevItems) => [...prevItems, { id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length, src: imageSrc }])
                          setLayouts((prevLayouts) => {
                            const newX = Math.round(Math.random() * 600);
                            const newY = Math.floor(Math.random() * 250);
                            const newWidget = {
                              x: newX,
                              id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length,
                              y: newY,
                              elementDetails: { src: imageSrc },
                              w: 100,
                              h: 100,
                              i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length),
                              static: Math.random() < 0.05,
                              resizeHandles: [
                                "s",
                                "w",
                                "e",
                                "n",
                                "sw",
                                "nw",
                                "se",
                                "ne",
                              ],
                              type: "image",
                            };
                            const updatedLayouts = { ...prevLayouts };
                            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                              updatedLayouts[currentBreakpoint] = [
                                ...updatedLayouts[currentBreakpoint],
                                newWidget,
                              ];
                            } else {
                              updatedLayouts[currentBreakpoint] = [newWidget];
                            }
                            return updatedLayouts;
                          });
                        };

                        reader.readAsDataURL(file_);
                      }

                      e.target.value = "";
                    }}
                    type="file"
                    name=""
                    id=""
                  />
                </button>

                <button className="bg_btn_dyn" onClick={createWidget} id="bg">
                  Background{" "}
                  <input
                    className="bg_btn_dyn_inp"

                    onChange={(e) => {
                      let file = e.target;
                      let file_ = file.files[0];
                      if (file_ && file_.type.startsWith("image/")) {
                        const reader = new FileReader();

                        reader.onload = function (event) {
                          const imageSrc = event.target.result;

                          var toplam_control = 0;
                          layouts[currentBreakpoint].forEach((i) => {
                            if (i === "bg") {
                              toplam_control++;
                            }
                          });


                          Set_bg_item(imageSrc)
                          const newX = Math.round(Math.random() * 5) * 2;
                          const newY = Math.floor(12 / 6) * 2;

                          if (toplam_control < 1) {

                            console.log(imageSrc);

                            Set_bg_key_current({
                              x: newX,
                              id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length,
                              y: newY,
                              elementDetails: { src: imageSrc },
                              w: 70,
                              h: 1,
                              i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length),
                              static: Math.random() < 0.05,
                              resizeHandles: resizeHandles,
                              type: "bg",
                            })

                            setTimeout(() => { Set_bg_control(true) }, 200)

                          } else {

                            let widget_;
                            layouts[currentBreakpoint].forEach((widget, index) => {
                              if (widget.type === "bg") {
                                widget_ = { ...widget, elementDetails: { ...widget.elementDetails, src: imageSrc } };
                              }
                            });

                            // Güncellenmiş widget'i console'a yazdır

                            Set_bg_key_current(widget_)

                            setTimeout(() => { Set_bg_control(true) }, 200)

                          }
                        };
                        reader.readAsDataURL(file_);
                      }
                    }}
                    type="file"
                    name=""
                    id=""
                  />
                </button>
                <button
                  id="gauge"
                  onClick={(e) => {
                    createWidget(e);
                    open_gauge_poup();
                  }}
                >
                  Gauge
                </button>
                <button
                  id="gauge_linear"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Linear Gauge
                </button>
                <button
                  id="set"
                  onClick={(e) => {
                    createWidget(e);

                  }}
                >
                  Set Value
                </button>

                <button
                  id="frame"
                  onClick={(e) => {
                    createWidget(e);

                  }}
                >
                  Çerçeve
                </button>

                {set_Raporlama && <button
                  id="trend"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Trend
                </button>}

                <div className="bottom">
                  <p>Sayfa Adı</p>
                  <input type="text" value={sayfa_adi} onChange={onChangePageName} id="save_page_name_inp" />
                </div>
                <div className="bottom">
                  <p>Sayfa İkonu</p>
                  <div style={{ marginTop: "16px", maxHeight: "30%" }} className="select-box">
                    <div style={{ maxWidth: "60%", minWidth: "200px", borderColor: "rgb(237,188,69)", backgroundColor: "white", borderWidth: "2.5px", borderRadius: "8px" }} className="select-box-header" onClick={toggleDropdownİkon}>
                      {selectedOptionİkon}
                      <span className={`arrow ${isOpenİkon ? 'open' : ''}`}>▼</span>
                    </div>
                    {isOpenİkon && (
                      <ul style={{ width: "72%", marginLeft: "13.4%" }} className="select-box-dropdown">
                        {[dashBoard, water, enerjiIcon, heat_system, pumpicon, fansicon, vrf_icon].map((option, index) => {
                          if (option.startsWith("fa")) {
                            return <li
                              id={index + 1}
                              key={index}
                              onClick={() => {
                                Set_sayfa_ikonu_son(option)
                                handleOptionClickİkon(<i style={{ color: "rgb(67,67,67)", margin: "0 10%" }} className={`${option}`}></i>)
                              }}
                              className="select-box-option"
                            >
                              {<i style={{ color: "rgb(67,67,67)", marginLeft: "4%" }} className={option}></i>}
                            </li>
                          } else {
                            return <li
                              id={index + 1}
                              key={index}
                              onClick={() => {
                                Set_sayfa_ikonu_son(option)
                                handleOptionClickİkon(<img src={`${option}`} />)

                              }}
                              className="select-box-option"
                            >
                              {<img src={option} />}
                            </li>
                          }

                        })}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="bottom">
                  <p>Grup Seçiniz</p>
                  <div style={{ marginTop: "16px", maxHeight: "30%" }} className="select-box">
                    <div style={{ maxWidth: "60%", minWidth: "200px", borderColor: "rgb(237,188,69)", backgroundColor: "white", borderWidth: "2.5px", borderRadius: "8px" }} className="select-box-header" onClick={toggleDropdownGroup}>
                      {selectedOptionGroup}
                      <span className={`arrow ${isOpenGroup ? 'open' : ''}`}>▼</span>
                    </div>
                    {isOpenGroup && (
                      <ul style={{ width: "72%", marginLeft: "13.4%" }} className="select-box-dropdown">
                        {["Deneme", "Ana Ekran", ...props.pages.filter(page => page.group === "Ana Ekran").map(page => page.pageName),
                        ].map((option, index) => {
                          return <li
                            id={index + 1}
                            key={index}
                            onClick={() => {
                              Set_sayfa_group(option)
                              handleOptionClickGroup(option)
                            }}
                            className="select-box-option"
                          >
                            {option}
                          </li>



                        })}
                      </ul>
                    )}
                  </div>
                </div>

                <div className="bottom">
                  <p>Backround Rengi Seçiniz</p>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginTop: "10px"
                    }}
                  >
                    {[
                      { name: "TURUNCU", color: "#edbc45" },
                      { name: "KIRMIZI", color: "#ff0000" },
                      { name: "SOĞUTMA MODU MAVİSİ", color: "#6495ed" },
                      { name: "SOĞUTMA MODU GRİSİ", color: "#808080" },
                      { name: "VRF ÇALIŞMAYAN GRİSİ", color: "#d3d3d3" },
                      { name: "BEYAZ", color: "#ffffff" },
                      { name: "SİYAH", color: "#000" },
                      { name: "Yeşil", color: "#008000" },
                      { name: "Açık Gri", color: "#EDEDED" }
                    ].map(({ name, color }) => (
                      <div
                        key={color}
                        onClick={() => {
                          Set_page_bgColor(color)
                        }}
                        title={name}
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: color,
                          border: "1px solid black",
                          borderRadius: "50%",
                          cursor: "pointer",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                        }}
                      />
                    ))}
                  </div>
                </div>
                <div className="bottom">
                  <p>Sayfayı Kaydet</p>
                  <div className="dyn_save_btn_parts">
                    <button disabled={save_control} onClick={(e) => {
                      Set_save_control(true)

                      let items_last = localStorage.getItem("layouts");
                      if (items_last) {
                        items_last = JSON.parse(items_last);
                        items_last.length > 0 && items_last.lg.forEach(x => {
                          if (x.type === "image") {
                            console.log(image_objs);
                            const imageObj = image_objs.find(a => String(a.id) === String(x.id));
                            if (imageObj && imageObj.src.length > 0) {
                              x.elementDetails.src = imageObj.src;
                            }
                          }
                        });
                        items_last.length > 0 && items_last.md.forEach(x => {
                          if (x.type === "image") {
                            const imageObj = image_objs.find(a => String(a.id) === String(x.id));
                            if (imageObj && imageObj.src.length > 0) {
                              x.elementDetails.src = imageObj.src;
                            }
                          }
                        });
                        items_last.length > 0 && items_last.sm.forEach(x => {
                          if (x.type === "image") {
                            const imageObj = image_objs.find(a => String(a.id) === String(x.id));
                            if (imageObj && imageObj.src.length > 0) {
                              x.elementDetails.src = imageObj.src;
                            }
                          }
                        });
                        items_last.length > 0 && items_last.xs.forEach(x => {
                          if (x.type === "image") {
                            const imageObj = image_objs.find(a => String(a.id) === String(x.id));
                            if (imageObj && imageObj.src.length > 0) {
                              x.elementDetails.src = imageObj.src;
                            }
                          }
                        });
                        items_last.length > 0 && items_last.xxs.forEach(x => {
                          if (x.type === "image") {
                            const imageObj = image_objs.find(a => String(a.id) === String(x.id));
                            if (imageObj && imageObj.src.length > 0) {
                              x.elementDetails.src = imageObj.src;
                            }
                          }
                        });
                      } else {
                        items_last = {
                          lg: [],
                          md: [],
                          sm: [],
                          xs: [],
                          xxs: [],
                        }
                      }






                      console.log(items_last, image_objs);
                      if (sayfa_adi !== "" && sayfa_ikonu_son !== "" && sayfa_group !== null && items_last !== undefined) {
                        let obj_ilk = {
                          companyId: props.com_id,
                          userId: props.uid,
                          pageName: sayfa_adi,
                          group: sayfa_group,
                          pageIcon: sayfa_ikonu_son,
                          pageId: sayfa_adi !== ogPageName ? 0 : pageId,
                          bgColor: page_bgColor !== "" ? page_bgColor : "transparent",

                          details: JSON.stringify({ ...items_last, canvas_boyutu: { width: window.innerWidth - document.querySelector("aside").getBoundingClientRect().width, height: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 } })
                        }

                        try {
                          if (sayfa_adi !== ogPageName) {


                            let idc = props.temp_com_id < 3 ? 2 : props.temp_com_id;

                            props.users_list.forEach(async x => {
                              // Eğer `yetkilendirme` boş veya geçersizse, boş bir nesne `{}` ata
                              let objprev = (x.yetkilendirme && x.yetkilendirme.trim() !== "")
                                ? JSON.parse(x.yetkilendirme)
                                : {};

                              let currentTarget = objprev?.[idc] || {}; // Eğer yoksa boş nesne ata

                              // Sayfa adını ekle
                              currentTarget[sayfa_adi] = { O: "f", S: "f", Y: "f" };

                              let updated_yetki = {
                                ...objprev,
                                [idc]: {
                                  ...currentTarget // Direkt olarak `idc` içinde eklemeyi sağladık
                                }
                              };


                              if (objprev.hasOwnProperty(props.temp_com_id)) {

                                const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/SetYetkilendirme", {
                                  headers: {
                                    "Content-Type": "application/json",
                                    "Accept": "application/json",

                                  },
                                  method: "POST",
                                  body: JSON.stringify({
                                    userId: x.userId,
                                    yetkilendirme: JSON.stringify(updated_yetki)
                                  })
                                })

                                const response = await request.json();
                                if (request.status === 200 && response && response.length > 0) {
                                  let obj = { [x.userId]: JSON.parse(response[0].yetkilendirme) }

                                  Store.dispatch(set_yetkilendirme_state(obj))
                                }
                                console.log(response);


                              }
                            })
                          }

                        } catch (err) {
                          console.log(err)
                        }




                        let obj_son = JSON.stringify(obj_ilk);

                        addPageFunc(obj_son);


                      }
                    }}>Kaydet</button>
                    <button onClick={async (e) => {
                      localStorage.removeItem("canvas_properties")
                      await history.push("/");
                      localStorage.removeItem("layouts")

                    }}>İptal</button>
                  </div>
                </div>

              </div>
              <div style={{ opacity: "0", zIndex: "-1" }} className="tool_box tool_box2">
                <div className="top">
                  <h4>Toolbox</h4>
                  <i onClick={() => {
                    document.querySelector(".tool_box2").classList.toggle("tool_box_active")
                  }} className="fa fa-times"></i></div>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }} onClick={createWidget2} id="text">
                  Text Box
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }} onClick={createWidget2} id="tag">
                  Tag
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="empty_btn"
                  onClick={(e) => {

                    createWidget2(e);
                  }}
                >
                  Button &#40;No Label&#41;
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="set"
                  onClick={(e) => {
                    createWidget2(e);

                  }}
                >
                  Set Value
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="selectbox"
                  onClick={(e) => {

                    createWidget2(e);
                  }}
                >
                  Selectbox
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="go_page"
                  onClick={(e) => {

                    createWidget(e);
                  }}
                >
                  Sayfa Butonu
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="senaryoSelect"
                  onClick={(e) => {

                    createWidget2(e);
                  }}
                >
                  Senaryo
                </button>

                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="frame"
                  onClick={(e) => {
                    createWidget2(e);

                  }}
                >
                  Çerçeve
                </button>


                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="on/off"
                  onClick={(e) => {

                    createWidget2(e);
                  }}
                >
                  On/Off
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="calisma_modu"
                  onClick={(e) => {
                    createWidget2(e);
                  }}
                >
                  Çalışma Modu
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="fan_modu"
                  onClick={(e) => {
                    createWidget2(e);
                  }}
                >
                  Fan Modu
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="i_g"
                  onClick={(e) => {
                    createWidget2(e);
                  }}
                >
                  İleri/Geri
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="t_t"
                  onClick={(e) => {
                    createWidget2(e);
                  }}
                >
                  Text-Tag
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="lock"
                  onClick={(e) => {
                    createWidget2(e);
                  }}
                >
                  Kilit
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="y_g"
                  onClick={(e) => {
                    createWidget2(e);
                  }}
                >
                  Yuvarlak Gösterge
                </button>

                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }} className="img_btn_dyn" onClick={createWidget2} id="image">
                  Image{" "}
                  <input
                    className="img_btn_dyn_inp"
                    onChange={(e) => {
                      let file = e.target;
                      let file_ = file.files[0];
                      if (file_ && file_.type.startsWith("image/")) {
                        const reader = new FileReader();

                        Set_render_items((prevLayouts) => {
                          return {
                            ...prevLayouts,
                            [currentBreakpoint]: [
                              ...prevLayouts[currentBreakpoint],
                              "image",
                            ],
                          };
                        });

                        reader.onload = function (event) {
                          const imageSrc = event.target.result;
                          setLayouts((prevLayouts) => {
                            const newX = Math.round(Math.random() * 600);
                            const newY = Math.floor(Math.random() * 250);
                            const newWidget = {
                              x: newX,
                              id: top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2,
                              y: newY,
                              elementDetails: { src: imageSrc },
                              w: 100,
                              h: 100,
                              i: String(top_score_id !== null ? layouts[currentBreakpoint].length + top_score_id : layouts[currentBreakpoint].length + top_score_id2),
                              static: Math.random() < 0.05,
                              resizeHandles: [
                                "s",
                                "w",
                                "e",
                                "n",
                                "sw",
                                "nw",
                                "se",
                                "ne",
                              ],
                              type: "image",
                            };
                            const updatedLayouts = { ...prevLayouts };
                            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                              updatedLayouts[currentBreakpoint] = [
                                ...updatedLayouts[currentBreakpoint],
                                newWidget,
                              ];
                            } else {
                              updatedLayouts[currentBreakpoint] = [newWidget];
                            }
                            return updatedLayouts;
                          });
                        };

                        reader.readAsDataURL(file_);
                      }

                      e.target.value = "";

                    }}
                    type="file"
                    name=""
                    id=""
                  />
                </button>

                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="gauge"
                  onClick={(e) => {
                    createWidget2(e);
                    open_gauge_poup();
                  }}
                >
                  Gauge
                </button>
                <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="gauge_linear"
                  onClick={(e) => {
                    createWidget(e);
                  }}
                >
                  Linear Gauge
                </button>


                {set_Raporlama && <button disabled={true} style={{ opacity: "0.75", pointerEvents: "none" }}
                  id="trend"
                  onClick={(e) => {
                    createWidget2(e);
                  }}
                >
                  Trend
                </button>}

                <div className="bottom">
                  <p>Popup'ı Kaydet</p>
                  <div className="dyn_save_btn_parts">
                    <button onClick={(e) => {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };

                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                          // Find the item where id matches item.id2
                          updatedLayouts[currentBreakpoint].forEach((item) => {
                            if (String(item.id) === String(active_popup_id)) {
                              // elementDetails.items array'ini başlat
                              item.elementDetails.items = [];

                              // matchingItems'ı bul
                              const matchingItems = updatedLayouts[currentBreakpoint].filter(
                                (i) => i.special_type && String(i.id2) === String(active_popup_id)
                              );

                              console.warn(matchingItems, updatedLayouts[currentBreakpoint], active_popup_id);


                              // matchingItems'ı eklemeden önce id'lerin çakışmadığından emin ol
                              matchingItems.forEach((matchingItem) => {
                                const isDuplicate = item.elementDetails.items.some(
                                  (existingItem) => String(existingItem.id) === String(matchingItem.id)
                                );

                                if (!isDuplicate) {
                                  console.warn(matchingItem)
                                  item.elementDetails.items.push(matchingItem);
                                }
                              });
                            }
                          });

                        }

                        return updatedLayouts;
                      });

                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };


                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                          // Filter out items with matching special_type and id2
                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].filter(
                            (item) => !(item.special_type && String(item.id2) === String(active_popup_id))
                          );
                        }

                        return updatedLayouts;
                      });
                      document.querySelector(".react-grid-layout").childNodes.forEach(x => {
                        x.style.opacity = "1"
                        x.style.zIndex = "1"
                      })
                      document.querySelector(".tool_box2").style.opacity = "0"
                      document.querySelector(".tool_box2").style.zIndex = "-1"

                      document.querySelector(".tool_box").style.opacity = "1"
                      document.querySelector(".tool_box").style.zIndex = "100000"

                      document.querySelector(".tool_box2").classList.toggle("tool_box_active")

                    }
                    }>
                      Kaydet
                    </button>
                    <button onClick={(e) => {
                      setLayouts((prevLayouts) => {
                        const updatedLayouts = { ...prevLayouts };


                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                          // Filter out items with matching special_type and id2
                          updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].filter(
                            (item) => !(item.special_type && String(item.id2) === String(active_popup_id))
                          );
                        }

                        return updatedLayouts;
                      });
                      document.querySelector(".react-grid-layout").childNodes.forEach(x => {
                        x.style.opacity = "1"
                        x.style.zIndex = "1"
                      })
                      document.querySelector(".tool_box2").style.opacity = "0"
                      document.querySelector(".tool_box2").style.zIndex = "-1"

                      document.querySelector(".tool_box").style.opacity = "1"
                      document.querySelector(".tool_box").style.zIndex = "100000"

                      document.querySelector(".tool_box2").classList.toggle("tool_box_active")
                    }}>
                      İptal
                    </button>
                  </div>
                </div>


              </div>

            </>}


            <ResponsiveReactGridLayout
              {...props}
              rowHeight={1}
              cols={cols}
              layouts={layouts}
              onBreakpointChange={onBreakpointChange}
              onLayoutChange={onLayoutChangeHandler}
              onResizeStop={onResize}
              allowOverlap={true}
              onDragStop={onDrop}
              measureBeforeMount={false}
              useCSSTransforms={mounted}
              compactType={compactType}
              margin={[0, 0]}  // Kenar boşluklarını kaldırarak kesin kontrol sağlayın
              containerPadding={[0, 0]} // İç boşlukları da kaldırın
              preventCollision={!compactType}
              style={document.querySelector(".tool_box") ? { maxHeight: (canvas_boyutu.height - document.querySelector(".tool_box").getBoundingClientRect().height) + "px" } : {}}
            >
              {generateDOM()}
            </ResponsiveReactGridLayout>


          </div>
        }
      </div>
    </>
  );
}


function generateLayout(resizeHandles) {
  return _.map(_.range(0, 5), function (item, i) {
    var y = Math.ceil(Math.random() * 15) + 1;
    return {
      x: Math.round(Math.random() * 5) * 2,
      y: Math.floor(i / 6) * y,
      w: 70,
      h: y,
      i: i.toString(),
      static: Math.random() < 0.05,
      resizeHandles: resizeHandles,
    };
  });
}

const MapStateToProps = (state) => {
  return {
    tag_values: state.project_reducer.tag_values,
    tags: state.project_reducer.tag_list,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    uid: state.auth_reducer.user_id,
    totalizer_tags: state.project_reducer.totalizer_tags,
    com_id: state.project_reducer.company_id,
    pages: state.project_reducer.pages,
    flowList: state.project_reducer.reactFlowList,
    widgets_library: state.project_reducer.widget_library,
    current_page_setails_reducer: state.project_reducer.current_page_details,
    current_dyn_pageName: state.project_reducer.current_dyn_pageName,
    users_list: state.project_reducer.users_list,
    temp_com_id: state.project_reducer.temp_com_id




  }
}

export default connect(MapStateToProps)(DynEdit);
